import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Date: { input: any; output: any; }
  URL: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Query = {
  __typename?: 'Query';
  /** Fetch a single applicant match record by its legacy ID. */
  applicant?: Maybe<Applicant>;
  /**
   * Fetch the applicant count breakdown for a listing without resolving individual applicant items.
   * Useful when only count data is needed (e.g. initial page load badges).
   */
  applicantCounts: ApplicantsCounts;
  /** Fetch and paginate applicants for a listing, with optional filtering. */
  applicants: ApplicantsResult;
  /** Fetch a single application by its ID. Returns null if no application exists with the given ID. */
  application?: Maybe<Application>;
  /** Search and paginate applications across the organisation. */
  applications: ApplicationsResult;
  /** Fetch all applications submitted for a specific listing, with optional stage and pagination. */
  applicationsByListing: ApplicationsResult;
  /**
   * The caller organisation's approval-workflow configuration. Returns defaults
   * (disabled, no approval types) when the org has never configured it.
   */
  approvalConfig: ApprovalConfig;
  /** The generic approvals inbox, optionally filtered by item type. */
  approvals: Array<ApprovalItem>;
  /**
   * The assessment-based suggestion set for an interview's candidate + listing
   * (shared across all of that candidate/role's interviews). Null when the guide
   * didn't enable suggestions or nothing has been generated. Each suggestion's
   * added-state is resolved relative to this interview. Panel-scoped (interviewer
   * on this panel only). The UI polls this until status is READY.
   */
  assessmentSuggestions?: Maybe<AssessmentSuggestionSet>;
  authClients: Array<AuthClient>;
  authScopes: Array<AuthScope>;
  /**
   * Standing context about the caller's currently-selected organisation.
   * Null when no profile has been captured yet.
   */
  businessProfile?: Maybe<BusinessProfile>;
  cultureHotspots?: Maybe<Array<Maybe<CultureHotspot>>>;
  culturePerception?: Maybe<CulturePerceptionResult>;
  /**
   * The culture report for a campaign, or null if one has never been generated. Poll it
   * while the status is QUEUED or GENERATING.
   */
  cultureReport?: Maybe<CultureReport>;
  divisions: Array<Division>;
  /**
   * Org users eligible to be named as approvers — anyone with Hire access in
   * the caller's organisation, whatever their Hire role.
   */
  eligibleApprovers: Array<User>;
  feedbackThemes?: Maybe<Array<FeedbackTheme>>;
  getComponoAssistReaction?: Maybe<ComponoAssistReaction>;
  group?: Maybe<Group>;
  groupMember?: Maybe<GroupMember>;
  groupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  /**
   * List members for a group in the caller's organisation.
   *
   * - **Required Scopes:** `group:member`.
   */
  groupMembersPage?: Maybe<PublicGroupMembersResult>;
  groups?: Maybe<Array<Maybe<Group>>>;
  /**
   * List groups in the caller's organisation.
   *
   * - **Required Scopes:** `group:list`.
   */
  groupsPage?: Maybe<PublicGroupsResult>;
  hireReportProcess: HireReportProcess;
  hireReportResult?: Maybe<HireReportResult>;
  /**
   * Fetch a single interview guide by its ID. Returns null if no guide exists
   * with the given ID.
   */
  interviewGuide?: Maybe<InterviewGuide>;
  /** Search and paginate the organisation's interview guides. */
  interviewGuides: InterviewGuidesResult;
  /**
   * All scorecards for an interview (one per panel interviewer). Managers see
   * every scorecard; reviewers only interviews they are on the panel for.
   */
  interviewScorecards: Array<Scorecard>;
  /**
   * Fetch the transcript for an interview. Returns null when no transcript has
   * been uploaded, or when the caller has no access to the interview.
   */
  interviewTranscript?: Maybe<Transcript>;
  /**
   * Whether a match-recalculation job is currently in progress for the listing.
   * @deprecated Use Listing.isProcessingMatches instead.
   */
  isProcessingListingMatches: Scalars['Boolean']['output'];
  jobTitles: Array<JobTitle>;
  /**
   * The standing copy for every lifecycle stage, in lifecycle order. The same for every
   * organisation, so it can be read before a profile exists.
   */
  lifecycleStages: Array<LifecycleStageDescriptor>;
  /** Fetch a single listing by its ID. Returns null if no listing exists with the given ID. */
  listing?: Maybe<Listing>;
  /** Search and paginate listings */
  listings: ListingsResult;
  messageTemplate?: Maybe<MessageTemplate>;
  messageTemplateGenerate?: Maybe<MessageTemplateGeneratedResult>;
  messageTemplates?: Maybe<Array<Maybe<MessageTemplate>>>;
  /** The current user's pending approvals across all sources (generic inbox). */
  myApprovals: Array<ApprovalItem>;
  myCourses?: Maybe<Array<Course>>;
  myGroupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  /**
   * Offers whose Approval to Hire is awaiting the caller's decision.
   * Caller-scoped — never an org-wide read.
   */
  myOfferApprovals: Array<Offer>;
  myProfile?: Maybe<User>;
  /**
   * The calling interviewer's own scorecard for an interview. Null when no
   * guide is assigned or the caller has no scorecard yet.
   */
  myScorecard?: Maybe<Scorecard>;
  /** The offer for an application, if the offer process has been started. */
  offer?: Maybe<Offer>;
  /** The org's Approval to Hire configuration (defaults if never configured). */
  offerApprovalConfig?: Maybe<OfferApprovalConfig>;
  /**
   * Offers with an Approval to Hire the caller is named on, across pending
   * and decided (for the inbox History tab). Caller-scoped.
   */
  offerApprovals: Array<Offer>;
  /**
   * Short-lived presigned download URL for a file attached to the offer (a
   * document, a generated PDF, an approval supporting document, or an org
   * template). Null when the key doesn't belong to the offer.
   */
  offerDocumentDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** The org's offer document packages. */
  offerDocumentPackages: Array<OfferDocumentPackage>;
  /** The org's offer document templates. */
  offerDocumentTemplates: Array<OfferDocumentTemplate>;
  /** The org's offer document types. */
  offerDocumentTypes: Array<OfferDocumentType>;
  /**
   * Org users selectable as approvers — every active Hire
   * user, independent of role.
   */
  offerEligibleApprovers: Array<User>;
  /**
   * Culture-fit aggregates for the caller's currently-selected organisation.
   * Order is by closingDate descending.
   */
  organisationCampaignAggregates: Array<OrganisationCampaignAggregate>;
  /**
   * Returns the caller's organisation demographic reference data — divisions,
   * job titles (with levels) and office locations — with the IDs required by
   * createUser/updateUser's divisionId, jobTitleId and orgLocationId fields.
   *
   * - **Required Scopes:** `organisation:read`.
   */
  organisationDemographics: OrganisationDemographics;
  /**
   * People at the caller's currently-selected organisation, by name. Deactivated people
   * are left out.
   */
  organisationPeople: Array<OrganisationPerson>;
  /** Returns a single reference check guide question by ID. */
  organisationReferenceQuestion?: Maybe<OrganisationReferenceQuestion>;
  /** Returns all reference check guide questions for the current organisation. */
  organisationReferenceQuestions: Array<OrganisationReferenceQuestion>;
  organisationTags: Array<OrganisationTag>;
  /** Fetch a single talent pool candidate by ID. */
  organisationTalent?: Maybe<OrganisationTalent>;
  /** Search the organisation's talent pool. */
  organisationTalents?: Maybe<Array<OrganisationTalent>>;
  /**
   * The website of the caller's currently-selected organisation, as set in admin. Null when
   * none has been set. Readable before a business profile exists.
   */
  organisationWebsite?: Maybe<Scalars['String']['output']>;
  /**
   * Organisation users with Hire access, for selecting interview-guide
   * reviewers. Scoped to the caller's organisation. Defaults to the roles that
   * can be asked for input (Owner, Admin, Recruitment Manager, Hiring Manager)
   * when `roles` is omitted; `search` matches name or email.
   */
  orgHireUsers: Array<HireOrgUser>;
  /** All active users in the caller's organisation (e.g. for the CC picker). */
  orgUsers: Array<User>;
  permissions?: Maybe<Permission>;
  personalityAssessment?: Maybe<PersonalityAssessment>;
  personalityResults?: Maybe<Array<Maybe<PersonalityAssessmentResult>>>;
  /**
   * Retrieve a single group by ID in the caller's organisation.
   *
   * - **Required Scopes:** `group:read`.
   */
  publicGroup?: Maybe<PublicGroupDetail>;
  /** Search and paginate the organisation's reusable question bank. */
  questionBank: QuestionBankResult;
  /** Returns all pending reference requests for the authenticated candidate. */
  referenceRequests: Array<CandidateReferenceRequest>;
  rehydrateQualifications?: Maybe<Array<Qualification>>;
  rehydrateSkills?: Maybe<Array<Skill>>;
  rehydrateWorkAreas?: Maybe<Array<WorkArea>>;
  /**
   * Fetch a single requisition by id. Returns null if none exists in the
   * caller's organisation.
   */
  requisition?: Maybe<Requisition>;
  /** The chronological activity log for a requisition. */
  requisitionActivity: Array<ActivityLogEntry>;
  /**
   * Presigned download URL for a requisition document (position description or
   * supporting document). Returns null if the file is not on that requisition.
   */
  requisitionDocumentDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** List requisitions for the caller's organisation. */
  requisitions: RequisitionsResult;
  sharePageLinks?: Maybe<Array<Maybe<SharePage>>>;
  ssoConfig?: Maybe<SsoConfig>;
  ssoConnection?: Maybe<SsoConnection>;
  ssoConnections: Array<SsoConnection>;
  /** Get a standalone CV by ID */
  standaloneCV?: Maybe<StandaloneCv>;
  systemTags: Array<SystemTag>;
  /**
   * Hiring teams for the caller's current organisation. Callers whose role is
   * scoped to their own teams see only the teams they belong to.
   */
  teams: TeamsResult;
  /** Get an upload request by ID */
  uploadRequest?: Maybe<UploadRequest>;
  /**
   * Retrieve a single user by ID within the caller's organisation.
   * - **Required Scopes:** `user:read`.
   */
  user?: Maybe<PublicUser>;
  userGroupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  /**
   * List all users in the caller's organisation.
   * - **Required Scopes:** `user:list`.
   */
  users: UsersResult;
};


export type QueryApplicantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicantCountsArgs = {
  filter: ApplicantFilter;
};


export type QueryApplicantsArgs = {
  filter: ApplicantFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationsArgs = {
  filter?: InputMaybe<ApplicationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryApplicationsByListingArgs = {
  listingId: Scalars['ID']['input'];
  pagination?: InputMaybe<Pagination>;
  stageId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryApprovalsArgs = {
  filter?: InputMaybe<ApprovalFilter>;
};


export type QueryAssessmentSuggestionsArgs = {
  interviewId: Scalars['ID']['input'];
};


export type QueryCultureHotspotsArgs = {
  campaignSk?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCulturePerceptionArgs = {
  assessmentSk: Scalars['String']['input'];
  filters?: InputMaybe<Array<InputMaybe<CulturePerceptionFilterInput>>>;
};


export type QueryCultureReportArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryFeedbackThemesArgs = {
  campaignSk: Scalars['String']['input'];
};


export type QueryGetComponoAssistReactionArgs = {
  input: GetComponoAssistReactionInput;
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupMemberArgs = {
  input?: InputMaybe<GroupMemberInput>;
};


export type QueryGroupMembersArgs = {
  input?: InputMaybe<GroupMembersInput>;
};


export type QueryGroupMembersPageArgs = {
  input?: InputMaybe<PublicGroupMembersInput>;
  pagination?: InputMaybe<GroupPagination>;
};


export type QueryGroupsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupsPageArgs = {
  pagination?: InputMaybe<GroupPagination>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHireReportProcessArgs = {
  params: ReportInput;
};


export type QueryHireReportResultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInterviewGuideArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInterviewGuidesArgs = {
  filter?: InputMaybe<InterviewGuideFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryInterviewScorecardsArgs = {
  interviewId: Scalars['ID']['input'];
};


export type QueryInterviewTranscriptArgs = {
  interviewId: Scalars['ID']['input'];
};


export type QueryIsProcessingListingMatchesArgs = {
  listingId: Scalars['ID']['input'];
};


export type QueryListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingsArgs = {
  filter?: InputMaybe<ListingFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageTemplateGenerateArgs = {
  additionalInstruction?: InputMaybe<Scalars['String']['input']>;
  previousAnswer?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessageTemplatesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMyScorecardArgs = {
  interviewId: Scalars['ID']['input'];
};


export type QueryOfferArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryOfferDocumentDownloadUrlArgs = {
  applicationId: Scalars['ID']['input'];
  fileKey: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganisationCampaignAggregatesArgs = {
  filter?: InputMaybe<CampaignAggregateFilter>;
};


export type QueryOrganisationPeopleArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganisationReferenceQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganisationTalentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganisationTalentsArgs = {
  input?: InputMaybe<OrganisationTalentSearchInput>;
};


export type QueryOrgHireUsersArgs = {
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonalityResultsArgs = {
  filters?: InputMaybe<Array<InputMaybe<PersonalityResultsQueryInput>>>;
};


export type QueryPublicGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionBankArgs = {
  filter?: InputMaybe<QuestionBankFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryRehydrateQualificationsArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type QueryRehydrateSkillsArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type QueryRehydrateWorkAreasArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type QueryRequisitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequisitionActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequisitionDocumentDownloadUrlArgs = {
  fileKey: Scalars['ID']['input'];
  requisitionId: Scalars['ID']['input'];
};


export type QueryRequisitionsArgs = {
  filter?: InputMaybe<RequisitionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QuerySsoConnectionArgs = {
  id: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type QuerySsoConnectionsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryStandaloneCvArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryUploadRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserGroupMembersArgs = {
  input?: InputMaybe<UserGroupMemberInput>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
  pagination?: InputMaybe<UsersPagination>;
};

/** A candidate matched to a specific job listing. */
export type Applicant = Node & {
  __typename?: 'Applicant';
  /** The application record for this match. Resolved via federation delegation to the applications service. */
  application?: Maybe<Application>;
  /** The date and time the underlying application was created. */
  applicationCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** All prior applications submitted by this candidate within the organisation. */
  applicationHistory: Array<Application>;
  /** Lazy-loaded assessment match breakdown for this applicant. */
  assessments?: Maybe<ApplicantAssessments>;
  /** True if the candidate is authorised to work at any of the listing's locations. Resolved from the candidate's visa requirements and the listing's locations. */
  authorizedForWork?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the candidate matched to this listing. */
  candidateId: Scalars['ID']['output'];
  /**
   * The match rank of this applicant among the listing's direct applicants, with the
   * talent pool excluded. Null for a talent pool candidate, who holds no position in
   * that set. Pairs with Listing.applicantCounts.direct for an "#n of m" reading.
   */
  directRank?: Maybe<Scalars['Int']['output']>;
  /** Candidate's email address. Only visible for direct applicants (isDirect); null otherwise, including talent pool candidates who have previously applied. */
  email?: Maybe<Scalars['String']['output']>;
  /** Candidate's first name. Masked for talent pool candidates who have not previously applied. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The listing the candidate was hired for, if hired. */
  hiredForListing?: Maybe<Listing>;
  /** Unique identifier for this applicant match record. */
  id: Scalars['ID']['output'];
  /** True if the candidate applied directly (not via talent pool). */
  isDirect: Scalars['Boolean']['output'];
  /** True if the employer has not yet viewed this applicant. */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** The listing this applicant is matched to. */
  listing: Listing;
  /** The ID of the listing this applicant is matched to. */
  listingId: Scalars['ID']['output'];
  /** The candidate's location. */
  location?: Maybe<ApplicantLocation>;
  /** True if the candidate's location matches the listing's location requirements. */
  locationMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Candidate's display name. Masked for talent pool candidates who have not previously applied. */
  name?: Maybe<Scalars['String']['output']>;
  /** Enriched pre-screening answers for this applicant, cross-referenced with the listing's questions. Null for talent pool candidates without a direct application. */
  preScreeningAnswers?: Maybe<Array<ApplicantPreScreeningAnswer>>;
  /** True if the applicant's answers match the listing's pre-screening questions. */
  preScreeningMatch?: Maybe<Scalars['Boolean']['output']>;
  /** True if this candidate has previously applied within this organisation. */
  previouslyApplied: Scalars['Boolean']['output'];
  profile?: Maybe<ApplicantProfile>;
  /** Protected profile stub for the CV summary federation chain. Uses the legacy type name for backward compatibility with the candidates subgraph. */
  protectedProfile?: Maybe<ListingApplicantProtectedProfile>;
  /** Lazy-loaded qualification match breakdown for this applicant. */
  qualifications?: Maybe<ApplicantQualifications>;
  /** The match rank of this applicant within the listing. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** Per-location relocation breakdown: each entry combines the candidate's visa-authorization split with the match result for that destination. */
  relocationLocations?: Maybe<Array<ApplicantRelocationLocation>>;
  /** True if this match has been removed (dropped) from the listing. */
  removed?: Maybe<Scalars['Boolean']['output']>;
  /** True if the candidate's salary expectation matches the listing's salary range. */
  salaryMatch?: Maybe<Scalars['Boolean']['output']>;
  /** Match scores for this applicant against the listing. */
  scores: ApplicantScores;
  /** Lazy-loaded skill match breakdown for this applicant. */
  skills?: Maybe<ApplicantSkills>;
  /** The pipeline stage this application is currently in. */
  stage?: Maybe<ApplicationStage>;
  /** Invitation status of this applicant. */
  status: ApplicantStatus;
  /** True if the applicant has been marked as unsuccessful. */
  unsuccessful?: Maybe<Scalars['Boolean']['output']>;
};

/** A node with a globally unique ID. All major business entities implement this interface. */
export type Node = {
  /** The unique identifier of this entity. */
  id: Scalars['ID']['output'];
};

/** A job application submitted by a candidate for a specific listing. */
export type Application = Node & {
  __typename?: 'Application';
  /** The matchmaker Applicant entity for this application. Resolved by matchmaker via the listing+candidate compound key. */
  applicant?: Maybe<Applicant>;
  /** The date and time the candidate submitted the application. */
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** IDs of any files attached to this application. */
  attachmentIds: Array<Scalars['ID']['output']>;
  attachments?: Maybe<Array<Maybe<ApplicantProfileAttachment>>>;
  /** The candidate who submitted this application. */
  candidate: Candidate;
  /** The ID of the candidate who submitted this application. */
  candidateId: Scalars['ID']['output'];
  /** True if the employer has reviewed the candidate's profile. */
  candidateReviewed: Scalars['Boolean']['output'];
  /** The date and time this application record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** True if the candidate has been hired for this listing. */
  hired: Scalars['Boolean']['output'];
  /** The date and time the candidate was hired. */
  hiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing the candidate was hired for, if they have been hired. */
  hiredForListing?: Maybe<Listing>;
  /** Unique identifier for this application. */
  id: Scalars['ID']['output'];
  /** True if this application was created via an external flow (e.g. Seek) and is not yet fully submitted. */
  incomplete: Scalars['Boolean']['output'];
  /** The date and time the candidate was invited to apply. */
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True if the employer has a pending action on this application. */
  isActionPending: Scalars['Boolean']['output'];
  /** True if the application has not yet been viewed by the employer. */
  isNew: Scalars['Boolean']['output'];
  /** True if the application has been marked as unsuccessful. */
  isUnsuccessful: Scalars['Boolean']['output'];
  /** The listing this application was submitted for. */
  listing: Listing;
  /** The offer for this application. Null until the offer process is started. */
  offer?: Maybe<Offer>;
  /** The organisation that owns the listing. */
  organisation: Organisation;
  /** Answers provided by the candidate to pre-screening questions. */
  preScreeningAnswers: Array<PreScreeningAnswer>;
  previewAttachments?: Maybe<Array<Maybe<ApplicantProfilePreviewAttachment>>>;
  /** All reference requests made for this application. */
  referenceRequests: Array<ReferenceRequest>;
  /** All references associated with this application. */
  references: Array<Reference>;
  /** A summary of reference statuses for this application. */
  referenceStatusSummary?: Maybe<ReferenceStatusSummary>;
  /** The attribution source describing how the candidate found this listing. */
  source: ApplicationSource;
  /** The pipeline stage the application is currently in. */
  stage?: Maybe<ApplicationStage>;
  /** The current lifecycle status of the application. */
  status: ApplicationStatus;
  /** True if the candidate has been hired for a different listing, making this application unavailable. */
  unavailable: Scalars['Boolean']['output'];
  /** The date and time this application record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantProfileAttachment = {
  __typename?: 'ApplicantProfileAttachment';
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A candidate profile. Owned by the candidates service; referenced here as a stub. */
export type Candidate = Node & {
  __typename?: 'Candidate';
  /** Unique identifier for this candidate. */
  id: Scalars['ID']['output'];
};

/** A job listing. Owned by the listings service; referenced here as a stub. */
export type Listing = {
  __typename?: 'Listing';
  /**
   * Aggregated applicant count breakdown for this listing, computed by matchmaker.
   * These are unfiltered listing-scoped counts (equivalent to applicants with no filter beyond listingId).
   */
  applicantCounts: ApplicantsCounts;
  /** The pipeline stages available for applications to this listing. */
  applicationStages: Array<ListingApplicationStage>;
  /** The date and time the listing was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The company name displayed on the listing. */
  company?: Maybe<Scalars['String']['output']>;
  /** The date and time this listing was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for this listing. */
  id: Scalars['ID']['output'];
  /** Whether the listing's match scores are currently being recalculated. */
  isProcessingMatches: Scalars['Boolean']['output'];
  /** Criteria for location-based candidate matching. */
  locationMatchingCriteria?: Maybe<ListingLocationMatchingCriteria>;
  /** The work locations for this listing. */
  locations: Array<ListingLocation>;
  /** The hiring manager assigned to this listing. */
  manager?: Maybe<User>;
  /**
   * Whether the last recalculation of this listing's match scores failed.
   *
   * When true, the scores and ranking on this listing are the ones from before the change
   * that triggered the recalculation, and nothing is coming to correct them — the queue has
   * stopped retrying. This is distinct from isProcessingMatches being false, which on its
   * own cannot tell a finished recalculation from one that never completed.
   *
   * Cleared by the next successful recalculation. Both fields are false for a listing that
   * has simply not been recalculated recently.
   */
  matchmakingFailed: Scalars['Boolean']['output'];
  /** The date and time this listing was opened. */
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The organisation that owns this listing. */
  organisation: Organisation;
  /** The user who owns this listing. */
  owner?: Maybe<User>;
  /** Action permissions the current user has on this listing. */
  permissions?: Maybe<ListingPermissions>;
  /** The pre-screening questions candidates must answer when applying. */
  preScreeningQuestions?: Maybe<Array<PreScreeningQuestion>>;
  /** Whether the listing is currently being processed (e.g. opening or closing). */
  processing?: Maybe<Scalars['Boolean']['output']>;
  /** The qualification requirements used for candidate matching. */
  qualifications: Array<ListingQualificationRequirement>;
  /** The assessment quizzes used for candidate evaluation. */
  quizzes: Array<ListingQuiz>;
  /** The job requisition this listing was created from; null for ad-hoc jobs. */
  requisitionId?: Maybe<Scalars['ID']['output']>;
  /** The advertised salary range. */
  salaryExpectation?: Maybe<ListingSalaryExpectation>;
  /** The relative score weights for candidate matching. */
  scoreWeights?: Maybe<ListingScoreWeights>;
  /** Indicates which configuration sections the employer has completed. */
  sectionsCompleted: ListingSectionsCompleted;
  /** The skill requirements used for candidate matching. */
  skills: Array<ListingSkillRequirement>;
  /** The skill subcategory identifiers used for candidate matching. */
  skillSubcategoryIds: Array<Scalars['ID']['output']>;
  /** The URL-safe slug for this listing. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The current lifecycle status of the listing. */
  status: ListingStatus;
  /**
   * Tag activities on this listing's applicants. Empty unless the caller may view
   * the listing's applicants: the listings service decides that from the caller's
   * organisation, role and team.
   */
  tagActivities: Array<TagActivity>;
  /** The hiring team this listing belongs to. */
  team?: Maybe<Team>;
  /** The job title. */
  title?: Maybe<Scalars['String']['output']>;
};


/** A job listing. Owned by the listings service; referenced here as a stub. */
export type ListingTagActivitiesArgs = {
  filter?: InputMaybe<ListingTagActivityFilter>;
};

/**
 * Listing overview counts.
 *
 * Every field here describes the **whole listing**: none is scoped by the
 * stage/search/match filters, and none by the hideTalentPool/hideUnsuccessful
 * visibility toggles either. For the number of applicants matching the current
 * view, use pageInfo.totalItems.
 */
export type ApplicantsCounts = {
  __typename?: 'ApplicantsCounts';
  /** Number of applicants with a pending employer action. */
  actionPending: Scalars['Int']['output'];
  /**
   * Total applicants for the listing.
   * @deprecated Always equal to total, which is no longer scoped by the visibility toggles. Use total.
   */
  allTotal: Scalars['Int']['output'];
  /** Applicant counts for completed states: hired and unsuccessful. The two partition the completed applicants — an application both hired for this listing and marked unsuccessful counts as hired. */
  completed: Array<ApplicantCompletedCount>;
  /** Number of applicants who applied directly. */
  direct: Scalars['Int']['output'];
  /** Number of applicants not yet viewed by the employer. */
  new: Scalars['Int']['output'];
  /** Number of talent pool candidates. */
  pool: Scalars['Int']['output'];
  /** Per-pipeline-stage applicant counts. */
  stages: Array<ApplicantStageCount>;
  /** Total applicants for the listing, talent pool included and pool-capped. */
  total: Scalars['Int']['output'];
};

/** Count of applicants in a completed state (hired or unsuccessful). */
export type ApplicantCompletedCount = {
  __typename?: 'ApplicantCompletedCount';
  /** Number of applicants in this completed state. */
  count: Scalars['Int']['output'];
  /** The completed state type: 'hired' or 'unsuccessful'. */
  type: Scalars['String']['output'];
};

/** Count of applicants in a specific pipeline stage. */
export type ApplicantStageCount = {
  __typename?: 'ApplicantStageCount';
  /** Number of applicants in this stage. */
  count: Scalars['Int']['output'];
  /** The stage ID, or null for applicants in the 'Applied' (no stage) state. */
  stageId?: Maybe<Scalars['ID']['output']>;
};

/**
 * A pipeline stage that an application can be moved into for this listing.
 * Currently a static system-wide list.
 */
export type ListingApplicationStage = {
  __typename?: 'ListingApplicationStage';
  /** The stable UUID identifier for this stage. */
  id: Scalars['ID']['output'];
  /** The human-readable label for this stage (e.g. 'Shortlist', 'Interview 1'). */
  name: Scalars['String']['output'];
};

/** Criteria used for location-based candidate matching. */
export type ListingLocationMatchingCriteria = {
  __typename?: 'ListingLocationMatchingCriteria';
  /** Whether candidates willing to relocate are accepted. */
  acceptRelocations?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum distance in kilometres within which candidates are matched. */
  distance?: Maybe<Scalars['Int']['output']>;
};

/** A physical or remote work location associated with a listing. */
export type ListingLocation = {
  __typename?: 'ListingLocation';
  /** The city name, if applicable. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country name. */
  country: Scalars['String']['output'];
  /** The location identifier. */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** The state or region name, if applicable. */
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * A user account. Owned by the users subgraph; referenced here as a stub —
 * display fields resolve via the federated entity.
 */
export type User = {
  __typename?: 'User';
  accesses?: Maybe<UserAccesses>;
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user. */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastSigninAt?: Maybe<Scalars['String']['output']>;
  orgAccesses?: Maybe<Array<UserOrgAccess>>;
  timezone?: Maybe<Scalars['String']['output']>;
  userPool?: Maybe<Scalars['String']['output']>;
};

export type UserAccesses = {
  __typename?: 'UserAccesses';
  genericApps?: Maybe<Array<UserAccessGenericApp>>;
};

export type UserAccessGenericApp = {
  __typename?: 'UserAccessGenericApp';
  appCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
};

export type UserOrgAccess = {
  __typename?: 'UserOrgAccess';
  apps?: Maybe<Array<UserOrganisationAppAccess>>;
};

export type UserOrganisationAppAccess = {
  __typename?: 'UserOrganisationAppAccess';
  appCode: Scalars['String']['output'];
  appLabel?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
};

/** An organisation (employer account). Owned by the organisations service; referenced here as a stub. */
export type Organisation = {
  __typename?: 'Organisation';
  /** The unique identifier of the organisation. */
  id: Scalars['ID']['output'];
};

/**
 * Action permissions the current user has on a specific listing.
 * Each field returns true if the user is authorised to perform the corresponding action.
 */
export type ListingPermissions = {
  __typename?: 'ListingPermissions';
  /** Whether the user can assign tags (including favourites) to applicants on this listing. */
  canAssignTag: Scalars['Boolean']['output'];
  /** Whether the user can create messages on this listing. */
  createMessages: Scalars['Boolean']['output'];
  /** Whether the user can drop (remove) applicants from this listing. */
  dropApplicants: Scalars['Boolean']['output'];
  /** Whether the user can edit this listing. */
  edit: Scalars['Boolean']['output'];
  /** Whether the user can invite talent pool candidates to apply for this listing. */
  inviteApplicants: Scalars['Boolean']['output'];
  /** Whether the user can mark an applicant as hired on this listing. */
  markAsHired: Scalars['Boolean']['output'];
  /** Whether the user can restore previously dropped applicants on this listing. */
  restoreApplicants: Scalars['Boolean']['output'];
  /** Whether the user can change applicant pipeline stages on this listing. */
  setStage: Scalars['Boolean']['output'];
  /**
   * Whether the user is restricted to moving applicants only to the Shortlist stage.
   * Returns true for roles below editor (e.g. hiringManager, viewer).
   */
  setStageToShortlistOnly: Scalars['Boolean']['output'];
  /**
   * Whether the user can change the candidate score weights on this listing.
   * Requires editor or above on the listing's team (admins and owners on any
   * team), and is false for a closed listing or, below admin, a listing with no team.
   */
  updateScoreWeights: Scalars['Boolean']['output'];
  /** Whether the user can view this listing. */
  view: Scalars['Boolean']['output'];
  /** Whether the user can view all notes on applicants for this listing. */
  viewAllNotes: Scalars['Boolean']['output'];
  /** Whether the user can view applicants for this listing. */
  viewApplicants: Scalars['Boolean']['output'];
  /** Whether the user can view messages on this listing. */
  viewMessages: Scalars['Boolean']['output'];
};

/** A pre-screening question attached to a listing that candidates must answer when applying. */
export type PreScreeningQuestion = {
  __typename?: 'PreScreeningQuestion';
  /** The answer the employer considers ideal. */
  desiredAnswer: Scalars['Boolean']['output'];
  /** Unique identifier for this question. */
  id: Scalars['ID']['output'];
  /** The question text presented to candidates. */
  question: Scalars['String']['output'];
};

/** A qualification requirement on a listing, used for candidate matching. */
export type ListingQualificationRequirement = {
  __typename?: 'ListingQualificationRequirement';
  /** The importance weighting for this requirement group. */
  importance: Scalars['Int']['output'];
  /** Whether related qualifications are included in matching. */
  includeRelated: Scalars['Boolean']['output'];
  /** The IDs of the qualifications in this requirement group. */
  qualificationIds: Array<Scalars['ID']['output']>;
  /** Row identifier for this requirement group. */
  rowId: Scalars['ID']['output'];
};

/** An assessment quiz attached to a listing for candidate evaluation. */
export type ListingQuiz = {
  __typename?: 'ListingQuiz';
  /** The campaign aggregate identifier, if applicable. */
  campaignAggregateId?: Maybe<Scalars['String']['output']>;
  /** The importance weighting for this quiz. */
  importance: Scalars['Int']['output'];
  /** The questions and ideal answers configured for this quiz. */
  questions: Array<ListingQuizQuestion>;
  /**
   * The quiz type identifier. Uses the legacy spelling 'quizzId' for compatibility.
   * One of: work-environment-measure, job-characteristics-measure, work-preferences-measure.
   */
  quizzId: Scalars['String']['output'];
};

/** A single question within a listing quiz, with the employer's ideal answer. */
export type ListingQuizQuestion = {
  __typename?: 'ListingQuizQuestion';
  /**
   * The ideal answer value. Numeric answers (from culture-fit and job-fit quizzes)
   * are coerced to strings.
   */
  answer: Scalars['String']['output'];
  /** The question text. */
  question: Scalars['String']['output'];
};

/** The salary range advertised on a listing. */
export type ListingSalaryExpectation = {
  __typename?: 'ListingSalaryExpectation';
  /** The maximum salary amount. */
  max?: Maybe<Scalars['Int']['output']>;
  /** The minimum salary amount. */
  min?: Maybe<Scalars['Int']['output']>;
  /** Whether the salary range is revealed to candidates. */
  reveal?: Maybe<Scalars['Boolean']['output']>;
};

/** The relative score weights used for candidate matching. */
export type ListingScoreWeights = {
  __typename?: 'ListingScoreWeights';
  /** Weight applied to assessment scoring. */
  assessments?: Maybe<Scalars['Int']['output']>;
  /** Weight applied to qualifications scoring. */
  qualifications?: Maybe<Scalars['Int']['output']>;
  /** Weight applied to skills scoring. */
  skills?: Maybe<Scalars['Int']['output']>;
};

/** Indicates which listing configuration sections have been completed by the employer. */
export type ListingSectionsCompleted = {
  __typename?: 'ListingSectionsCompleted';
  /** Whether the assessments section has been configured. */
  assessments: Scalars['Boolean']['output'];
  /** Whether the basic details section has been completed. Always true. */
  details: Scalars['Boolean']['output'];
  /** Whether the pre-screening section has been configured. */
  prescreening: Scalars['Boolean']['output'];
  /** Whether the qualifications section has been configured. */
  qualifications: Scalars['Boolean']['output'];
  /** Whether the skills section has been configured. */
  skills: Scalars['Boolean']['output'];
};

/** A skill requirement on a listing, used for candidate matching. */
export type ListingSkillRequirement = {
  __typename?: 'ListingSkillRequirement';
  /** The importance weighting for this requirement group. */
  importance: Scalars['Int']['output'];
  /** The IDs of the skills in this requirement group. */
  skillIds: Array<Scalars['ID']['output']>;
  /** Minimum years of experience required. */
  years: Scalars['Int']['output'];
};

/** The lifecycle status of a job listing. */
export enum ListingStatus {
  /** The listing has been archived. */
  Archived = 'ARCHIVED',
  /** The listing has been closed and is no longer accepting applications. */
  Closed = 'CLOSED',
  /** The listing is being drafted and is not yet visible to candidates. */
  Draft = 'DRAFT',
  /** The listing is published and accepting applications. */
  Open = 'OPEN'
}

export type ListingTagActivityFilter = {
  candidateId?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<TagCategory>;
  tagId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum TagCategory {
  Activity = 'ACTIVITY',
  Candidate = 'CANDIDATE'
}

export type TagActivity = {
  __typename?: 'TagActivity';
  action: TagActivityAction;
  actionedByUser?: Maybe<TagActivityActionedByUser>;
  history: Array<TagActivityHistory>;
  /**
   * Stable identity for this activity: one row exists per (tag, target), and
   * assigning then unassigning the same tag on the same applicant updates it in
   * place rather than adding another. Composed from the public tag id and the
   * target it applies to.
   */
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tag: Tag;
  targetApplicant?: Maybe<Applicant>;
};

export enum TagActivityAction {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED'
}

export type TagActivityActionedByUser = {
  __typename?: 'TagActivityActionedByUser';
  timestamp?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type TagActivityHistory = {
  __typename?: 'TagActivityHistory';
  action: TagActivityAction;
  actionedByUser?: Maybe<TagActivityActionedByUser>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type Tag = OrganisationTag | SystemTag;

export type OrganisationTag = {
  __typename?: 'OrganisationTag';
  assignedCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tagCategory?: Maybe<Scalars['String']['output']>;
};

export type SystemTag = {
  __typename?: 'SystemTag';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

/** A hiring team. Owned by the organisations service. */
export type Team = Node & {
  __typename?: 'Team';
  /** Unique identifier for this team. */
  id: Scalars['ID']['output'];
  /** The people who belong to this team. Empty when the team has no members. */
  members: Array<TeamMember>;
  /** The team's display name. */
  name: Scalars['String']['output'];
  /** The organisation this team belongs to. */
  organisation: Organisation;
  /** @deprecated Use organisation instead. */
  organisationId: Scalars['ID']['output'];
};

/** A person's membership of a hiring team. */
export type TeamMember = {
  __typename?: 'TeamMember';
  /**
   * The employer holding this membership. Null when the user record no longer
   * exists.
   */
  employer?: Maybe<User>;
};

/**
 * An offer extended to a candidate's application. One per application;
 * created when the offer process is started.
 */
export type Offer = {
  __typename?: 'Offer';
  /** The application this offer belongs to. */
  application: Application;
  /** The id of the application this offer belongs to. */
  applicationId: Scalars['ID']['output'];
  /**
   * The Approval to Hire workflow state. Null when the organisation has the
   * workflow disabled and no approval was ever started; NOT_STARTED when
   * enabled but not yet initiated.
   */
  approvalToHire?: Maybe<OfferApproval>;
  compensation?: Maybe<OfferCompensation>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Whether the documentation panel is usable. Also server-computed. When
   * false the panel is still visible, just locked.
   */
  documentationUnlocked: Scalars['Boolean']['output'];
  documents: Array<OfferDocument>;
  /**
   * Whether offer details may be edited right now. Computed on the server —
   * the rule also depends on the org's approval configuration, so the client
   * must not re-derive it from status.
   */
  editable: Scalars['Boolean']['output'];
  /** Unique identifier (ULID). */
  id: Scalars['ID']['output'];
  jobDetails?: Maybe<OfferJobDetails>;
  /** The id of the organisation that owns this offer. */
  organisationId: Scalars['ID']['output'];
  /** Action permissions the current user has on this offer. */
  permissions: OfferPermissions;
  /** Human-facing sequential reference, e.g. 'ATH-001'. */
  reference: Scalars['String']['output'];
  status: OfferStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The Approval to Hire workflow state on an offer. */
export type OfferApproval = {
  __typename?: 'OfferApproval';
  /** Summary of amendments given on the most recent resubmission. */
  amendmentsSummary?: Maybe<Scalars['String']['output']>;
  /** How the approvers are asked. PARALLEL unless chosen otherwise. */
  approvalMode: OfferApprovalMode;
  approvers: Array<OfferApprover>;
  headcount?: Maybe<OfferHeadcount>;
  status: OfferApprovalStatus;
  /** When the approval was (re)submitted (ISO-8601). */
  submittedAt?: Maybe<Scalars['String']['output']>;
  submittedBy?: Maybe<User>;
  supportingDocuments: Array<OfferFile>;
  supportingNotes?: Maybe<Scalars['String']['output']>;
};

/** How the named approvers are asked. */
export enum OfferApprovalMode {
  /** Everyone is notified at once and may decide in any order. */
  Parallel = 'PARALLEL',
  /** Approvers are asked one at a time, in the order they are listed. */
  Sequential = 'SEQUENTIAL'
}

/**
 * An approver named on an offer's Approval to Hire. Any active Hire user can
 * be named, independent of role; display fields resolve via the federated
 * User entity.
 */
export type OfferApprover = {
  __typename?: 'OfferApprover';
  /** The approval-type labels this approver is responsible for. */
  approvalTypes: Array<Scalars['String']['output']>;
  /** Required when declining, optional when approving. */
  comment?: Maybe<Scalars['String']['output']>;
  /** When the decision was made (ISO-8601). */
  decidedAt?: Maybe<Scalars['String']['output']>;
  decision: OfferApproverDecision;
  /** Where this approver stands; always ACTIVE on a parallel approval. */
  turn: OfferApproverTurn;
  user: User;
};

/**
 * One approver's decision. NOT_SUBMITTED covers an approver added before the
 * approval was submitted — they have not been asked yet.
 */
export enum OfferApproverDecision {
  /** This approver approved. */
  Approved = 'APPROVED',
  /** This approver declined. */
  Declined = 'DECLINED',
  /** The approval has not been submitted; this approver has not been asked yet. */
  NotSubmitted = 'NOT_SUBMITTED',
  /** Awaiting this approver's decision. */
  Pending = 'PENDING'
}

/** Where an approver stands — what the form and the inbox render from. */
export enum OfferApproverTurn {
  /** It is this approver's turn; they may decide now. */
  Active = 'ACTIVE',
  /** Has already decided. */
  Decided = 'DECIDED',
  /** Not yet asked — the approval has not been submitted. */
  NotAsked = 'NOT_ASKED',
  /** Queued behind an earlier approver on a sequential chain. */
  Waiting = 'WAITING'
}

/** Headcount details on an Approval to Hire. */
export type OfferHeadcount = {
  __typename?: 'OfferHeadcount';
  budgetNotes?: Maybe<Scalars['String']['output']>;
  /** Number of full-time-equivalent positions. */
  fte: Scalars['Int']['output'];
  /** Optional headcount reference, e.g. 'HC-2026-0042'. */
  positionNumber?: Maybe<Scalars['String']['output']>;
  /** Who is being replaced (Replacement requests). */
  replacingWho?: Maybe<Scalars['String']['output']>;
  requestType: OfferRequestType;
  /** Justification for unplanned headcount (Out of Budget requests). */
  unplannedReason?: Maybe<Scalars['String']['output']>;
};

/** Why the headcount is being requested. */
export enum OfferRequestType {
  /** New, budgeted headcount. */
  NewBudgeted = 'NEW_BUDGETED',
  /** New headcount that was not budgeted for. */
  NewUnbudgeted = 'NEW_UNBUDGETED',
  /** Backfilling an existing role. */
  Replacement = 'REPLACEMENT'
}

/**
 * Status of the Approval to Hire workflow on an offer. NOT_STARTED means the
 * org has the workflow enabled but nobody has initiated it yet; an offer in
 * an org with the workflow disabled has no approval at all.
 */
export enum OfferApprovalStatus {
  /** Every approver has signed off. */
  Approved = 'APPROVED',
  /** At least one approver declined. */
  Declined = 'DECLINED',
  /** The workflow is enabled but has not been initiated. */
  NotStarted = 'NOT_STARTED',
  /** Submitted and awaiting approver decisions. */
  Pending = 'PENDING',
  /** Withdrawn by the requester; the offer is editable again. */
  Withdrawn = 'WITHDRAWN'
}

/** A file held by the uploads service. */
export type OfferFile = {
  __typename?: 'OfferFile';
  fileKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSizeBytes?: Maybe<Scalars['Int']['output']>;
};

/** Compensation captured on an offer. */
export type OfferCompensation = {
  __typename?: 'OfferCompensation';
  baseSalaryMax?: Maybe<Scalars['Int']['output']>;
  baseSalaryMin?: Maybe<Scalars['Int']['output']>;
  benefits?: Maybe<Scalars['String']['output']>;
  bonuses?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  otherCompensation?: Maybe<Scalars['String']['output']>;
  paymentSchedule?: Maybe<OfferPaymentSchedule>;
  salaryConditions?: Maybe<Scalars['String']['output']>;
  salaryPeriod?: Maybe<OfferSalaryPeriod>;
  superannuation?: Maybe<Scalars['String']['output']>;
};

/** How often pay is disbursed. */
export enum OfferPaymentSchedule {
  Annually = 'ANNUALLY',
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY'
}

/** Basis the base salary is quoted on. */
export enum OfferSalaryPeriod {
  PerDay = 'PER_DAY',
  PerFortnight = 'PER_FORTNIGHT',
  PerMonth = 'PER_MONTH',
  PerYear = 'PER_YEAR'
}

/** A document prepared for, sent to, or returned by the candidate. */
export type OfferDocument = {
  __typename?: 'OfferDocument';
  category: OfferDocumentCategory;
  documentTypeId: Scalars['ID']['output'];
  /** Denormalised for display, so a row renders without a second lookup. */
  documentTypeName: Scalars['String']['output'];
  /**
   * Key of the downloadable file — the rendered PDF for template-generated
   * documents. Null while generation is pending or failed.
   */
  fileKey?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  fileSizeBytes?: Maybe<Scalars['Int']['output']>;
  /** Populated when generationStatus is FAILED. */
  generationError?: Maybe<Scalars['String']['output']>;
  generationStatus: OfferDocumentGenerationStatus;
  id: Scalars['ID']['output'];
  /**
   * The message this document went out on. Documents sent together share it —
   * sentAt does NOT, because each document is stamped by its own mutation.
   */
  messageId?: Maybe<Scalars['String']['output']>;
  /** The package the template came in, when added via a package. */
  packageId?: Maybe<Scalars['ID']['output']>;
  /**
   * The highlighted-values PDF for the preview dialog. Present only on
   * generated documents once the preview render lands; never sent to
   * candidates.
   */
  previewFileKey?: Maybe<Scalars['String']['output']>;
  /**
   * Null on documents generated before the preview twin shipped, and on
   * uploads — neither has a preview coming, so clients must not wait on one.
   */
  previewStatus?: Maybe<OfferDocumentPreviewStatus>;
  /** When the document went to the candidate (ISO-8601). */
  sentAt?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<User>;
  signatureStatus: OfferSignatureStatus;
  source: OfferDocumentSource;
  /** The template this document was generated from, when template-sourced. */
  templateId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Where a document sits in the flow. PREPARED documents are staged but not
 * yet with the candidate; SENT have gone out; REPOSITORY are signed copies
 * returned by the candidate and uploaded back in.
 */
export enum OfferDocumentCategory {
  Prepared = 'PREPARED',
  Repository = 'REPOSITORY',
  Sent = 'SENT'
}

/**
 * Template-sourced documents are rendered asynchronously, so they start
 * PENDING. Uploaded documents are READY immediately.
 */
export enum OfferDocumentGenerationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY'
}

/**
 * Whether the highlighted preview twin is still converting. It renders as a
 * second, independent job, so a document is READY before its preview exists.
 * UNAVAILABLE is terminal — the preview failed and no retry is coming.
 */
export enum OfferDocumentPreviewStatus {
  Pending = 'PENDING',
  Ready = 'READY',
  Unavailable = 'UNAVAILABLE'
}

/**
 * E-signature seam. Nothing writes anything but NOT_REQUIRED in this phase —
 * the field exists so a provider can be added later without reshaping the
 * document model.
 */
export enum OfferSignatureStatus {
  Awaiting = 'AWAITING',
  NotRequired = 'NOT_REQUIRED',
  Signed = 'SIGNED'
}

export enum OfferDocumentSource {
  Template = 'TEMPLATE',
  Upload = 'UPLOAD'
}

/** Job details captured on an offer. */
export type OfferJobDetails = {
  __typename?: 'OfferJobDetails';
  /** Finance reference, e.g. 'CC-4200'. */
  costCentre?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<OfferEmploymentType>;
  jobTitle: Scalars['String']['output'];
  /** Reference to the org's job title; jobTitle holds the resolved name. */
  jobTitleId?: Maybe<Scalars['ID']['output']>;
  reportingManager?: Maybe<Scalars['String']['output']>;
  /** Proposed commencement date, yyyy-mm-dd. */
  startDate?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Scalars['String']['output']>;
  workSetting?: Maybe<OfferWorkSetting>;
};

export enum OfferEmploymentType {
  Casual = 'CASUAL',
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

export enum OfferWorkSetting {
  Hybrid = 'HYBRID',
  OnPremise = 'ON_PREMISE',
  Remote = 'REMOTE'
}

/** Action permissions the current user has on a specific offer. */
export type OfferPermissions = {
  __typename?: 'OfferPermissions';
  /** Named approver on a still-pending approval. Independent of role. */
  approve: Scalars['Boolean']['output'];
  /** Edit details, run the approval, prepare and send documents. */
  manage: Scalars['Boolean']['output'];
  /** Whether the user can view this offer. */
  view: Scalars['Boolean']['output'];
};

/**
 * Lifecycle status of an offer. An application has at most one offer, so
 * amendments (decline, change, resubmit) move this status rather than
 * creating a second record.
 */
export enum OfferStatus {
  /** Every approver has signed off. */
  Approved = 'APPROVED',
  /** At least one approver declined. */
  Declined = 'DECLINED',
  /** Being drafted; approval not yet requested. */
  Draft = 'DRAFT',
  /** Submitted for Approval to Hire and awaiting decisions. */
  Pending = 'PENDING',
  /** Withdrawn from approval; editable again. */
  Withdrawn = 'WITHDRAWN'
}

/** A single pre-screening question answer submitted with an application. */
export type PreScreeningAnswer = {
  __typename?: 'PreScreeningAnswer';
  /** The candidate's boolean answer to the question. */
  answer: Scalars['Boolean']['output'];
  /** The ID of the pre-screening question this answer relates to. */
  questionId: Scalars['ID']['output'];
};

export type ApplicantProfilePreviewAttachment = {
  __typename?: 'ApplicantProfilePreviewAttachment';
  filename?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Array<ApplicantProfilePreviewCvFormat>>;
  id: Scalars['ID']['output'];
};

export type ApplicantProfilePreviewCvFormat = {
  __typename?: 'ApplicantProfilePreviewCvFormat';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
};

/**
 * A request to collect references for an application. Records the
 * parameters specified by the employer when initiating the reference check.
 */
export type ReferenceRequest = {
  __typename?: 'ReferenceRequest';
  /** The deadline by which references must be submitted. */
  deadline: Scalars['DateTime']['output'];
  /** Unique identifier for this reference request. */
  id: Scalars['ID']['output'];
  /** The body of the notification email sent to the candidate. */
  messageBody: Scalars['String']['output'];
  /** The subject line of the notification email sent to the candidate. */
  messageSubject: Scalars['String']['output'];
  /** The date and time the reference check was requested. */
  requestedAt: Scalars['DateTime']['output'];
  /** The ID of the user who requested the reference check. */
  requestedBy: Scalars['ID']['output'];
  /** The number of references required from the candidate. */
  requiredCount: Scalars['Int']['output'];
};

/** A reference check for a candidate. */
export type Reference = {
  __typename?: 'Reference';
  /** Any additional notes provided by the referee or the employer. */
  additionalNotes?: Maybe<Scalars['String']['output']>;
  /** The company where the referee and candidate worked together. */
  company: Scalars['String']['output'];
  /** The date and time the reference was first completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the user who completed or recorded this reference. */
  completedBy?: Maybe<Scalars['ID']['output']>;
  /** The date and time this reference record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date the referee was contacted. */
  dateContacted?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time the reference results were last edited. */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The referee's email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** Snapshot of guide questions with the referee's responses. */
  guideQuestions: Array<ReferenceGuideQuestionSnapshot>;
  /** Unique identifier for this reference. */
  id: Scalars['ID']['output'];
  /** The full name of the referee. */
  name: Scalars['String']['output'];
  /** The referee's overall rating of the candidate. */
  overallRating?: Maybe<OverallRating>;
  /** The referee's phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The professional relationship between the referee and the candidate. */
  relationship: ReferenceRelationship;
  /** The ID of the reference request this reference belongs to, if any. */
  requestId?: Maybe<Scalars['ID']['output']>;
  /** How this reference was collected. */
  source: ReferenceSource;
  /** The current status of this reference check. */
  status: ReferenceStatus;
  /** The date and time the referee submitted their response. */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time this reference record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Whether the referee would rehire or work with the candidate again. */
  wouldRehire?: Maybe<WouldRehire>;
};

/**
 * A snapshot of an organisation's guide question, captured at the time a
 * reference was requested. Responses are filled in by the referee.
 */
export type ReferenceGuideQuestionSnapshot = {
  __typename?: 'ReferenceGuideQuestionSnapshot';
  /** Optional helper text providing context for answering the question. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** The display order of this question within the reference form. */
  order: Scalars['Int']['output'];
  /** Optional placeholder text displayed in the response input. */
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The ID of the original guide question. */
  questionId: Scalars['ID']['output'];
  /** The question text shown to the referee. */
  questionLabel: Scalars['String']['output'];
  /** The referee's response to this question. Null until answered. */
  response?: Maybe<Scalars['String']['output']>;
};

/** The referee's overall rating of the candidate. */
export enum OverallRating {
  /** The candidate is rated as excellent. */
  Excellent = 'EXCELLENT',
  /** The candidate is rated as fair. */
  Fair = 'FAIR',
  /** The candidate is rated as good. */
  Good = 'GOOD',
  /** The candidate is rated as poor. */
  Poor = 'POOR',
  /** The candidate is rated as very good. */
  VeryGood = 'VERY_GOOD'
}

/** The professional relationship between the referee and the candidate. */
export enum ReferenceRelationship {
  /** The referee provides a character reference for the candidate. */
  CharacterReference = 'CHARACTER_REFERENCE',
  /** The referee worked with the candidate across different teams or departments. */
  CrossFunctionalColleague = 'CROSS_FUNCTIONAL_COLLEAGUE',
  /** The referee was a department head or executive overseeing the candidate. */
  DepartmentHead = 'DEPARTMENT_HEAD',
  /** The referee reported directly to the candidate. */
  DirectReport = 'DIRECT_REPORT',
  /** The referee was an external client of the candidate. */
  ExternalClient = 'EXTERNAL_CLIENT',
  /** The referee reported indirectly to the candidate. */
  IndirectReport = 'INDIRECT_REPORT',
  /** The referee was the candidate's direct line manager or supervisor. */
  LineManager = 'LINE_MANAGER',
  /** The referee served as a professional mentor to the candidate. */
  ProfessionalMentor = 'PROFESSIONAL_MENTOR',
  /** The referee was a professor or faculty member who taught or supervised the candidate. */
  Professor = 'PROFESSOR',
  /** The referee worked alongside the candidate as a team member or peer. */
  TeamMember = 'TEAM_MEMBER',
  /** The referee was a vendor or service provider to the candidate. */
  Vendor = 'VENDOR'
}

/** How the reference was collected. */
export enum ReferenceSource {
  /** The reference was added manually by an employer user. */
  Manual = 'MANUAL',
  /** The reference was submitted through the self-service portal by the referee. */
  Portal = 'PORTAL'
}

/** The current status of a reference check within the workflow. */
export enum ReferenceStatus {
  /** The referee has completed the reference check. */
  Completed = 'COMPLETED',
  /** The referee declined to provide a reference. */
  Declined = 'DECLINED',
  /** The reference has been created but not yet sent to the referee. */
  Pending = 'PENDING',
  /** The reference request has been sent to the referee. */
  Sent = 'SENT'
}

/** Whether the referee would rehire or work with the candidate again. */
export enum WouldRehire {
  /** The referee would not rehire the candidate. */
  No = 'NO',
  /** The referee is unsure whether they would rehire the candidate. */
  Unsure = 'UNSURE',
  /** The referee would rehire the candidate but with some reservations. */
  YesWithReservations = 'YES_WITH_RESERVATIONS',
  /** The referee would rehire the candidate without any hesitation. */
  YesWithoutHesitation = 'YES_WITHOUT_HESITATION'
}

/** A summary of reference statuses for an application. */
export type ReferenceStatusSummary = {
  __typename?: 'ReferenceStatusSummary';
  /** The number of references with COMPLETED status. */
  completed: Scalars['Int']['output'];
  /** The number of references with DECLINED status. */
  declined: Scalars['Int']['output'];
  /** The number of references with PENDING status. */
  pending: Scalars['Int']['output'];
  /** The number of references with SENT status. */
  sent: Scalars['Int']['output'];
  /** The total number of references. */
  total: Scalars['Int']['output'];
};

/** The attribution source of an application, describing how the candidate found the listing. */
export type ApplicationSource = {
  __typename?: 'ApplicationSource';
  /** The third-party job board identifier, if the application originated from a job board. */
  jobBoardId?: Maybe<Scalars['ID']['output']>;
  /** The name of the job board provider (e.g. 'Seek', 'Indeed'). */
  jobBoardProvider?: Maybe<Scalars['String']['output']>;
  /** The resolved human-readable source name (e.g. 'Seek', 'LinkedIn', 'Talent Pool'). */
  name: Scalars['String']['output'];
  /** The referrer URL captured when the candidate clicked through to the listing. */
  referrerUrl?: Maybe<Scalars['URL']['output']>;
};

/** The current pipeline stage an application has been placed in. */
export type ApplicationStage = {
  __typename?: 'ApplicationStage';
  /** The ID of the stage. */
  id: Scalars['ID']['output'];
  /** The human-readable name of the stage (e.g. 'Shortlist', 'Interview 1', 'Hired'). */
  name: Scalars['String']['output'];
};

/** The lifecycle status of an application within the hiring pipeline. */
export enum ApplicationStatus {
  /** The application has been submitted and is under review. */
  Active = 'ACTIVE',
  /** The application was withdrawn or removed before being considered. */
  Cancelled = 'CANCELLED',
  /** The listing associated with this application has been closed. */
  Closed = 'CLOSED',
  /** The application has been started but not yet submitted by the candidate. */
  Draft = 'DRAFT'
}

/** Assessment match analysis for an applicant against a listing. */
export type ApplicantAssessments = {
  __typename?: 'ApplicantAssessments';
  /** Culture fit assessment comparison. */
  cultureFit?: Maybe<ApplicantCultureFit>;
  /** Job fit assessment comparison. */
  jobFit?: Maybe<ApplicantJobFit>;
  /** Personality fit assessment comparison. */
  personalityFit?: Maybe<ApplicantPersonalityFit>;
};

/** Culture fit assessment comparison between candidate and listing. */
export type ApplicantCultureFit = {
  __typename?: 'ApplicantCultureFit';
  /** Per-question comparison results. */
  comparisons: Array<ApplicantCultureFitComparison>;
  /** The importance weight assigned to culture fit for this listing. */
  importance?: Maybe<Scalars['Int']['output']>;
  /** The culture fit match percentage. */
  percentage?: Maybe<Scalars['Float']['output']>;
};

/** A single culture fit question comparison between candidate and listing responses. */
export type ApplicantCultureFitComparison = {
  __typename?: 'ApplicantCultureFitComparison';
  /** The candidate's and listing's answers to this question. */
  answer?: Maybe<ApplicantAssessmentAnswer>;
  /** The display labels for this question's scale. */
  label?: Maybe<ApplicantCultureFitLabel>;
};

/** A candidate/listing answer pair for a single assessment question. */
export type ApplicantAssessmentAnswer = {
  __typename?: 'ApplicantAssessmentAnswer';
  /** The candidate's answer value. */
  candidate?: Maybe<Scalars['Float']['output']>;
  /** The listing's expected answer value. */
  listing?: Maybe<Scalars['Float']['output']>;
};

/** The left/right scale labels for a culture fit question. */
export type ApplicantCultureFitLabel = {
  __typename?: 'ApplicantCultureFitLabel';
  /** Label for the left end of the scale. */
  left?: Maybe<Scalars['String']['output']>;
  /** Label for the right end of the scale. */
  right?: Maybe<Scalars['String']['output']>;
};

/** Job fit assessment comparison between candidate and listing. */
export type ApplicantJobFit = {
  __typename?: 'ApplicantJobFit';
  /** Per-question comparison results. */
  comparisons: Array<ApplicantJobFitComparison>;
  /** The importance weight assigned to job fit for this listing. */
  importance?: Maybe<Scalars['Int']['output']>;
  /** The job fit match percentage. */
  percentage?: Maybe<Scalars['Float']['output']>;
};

/** A single job fit question comparison between candidate and listing responses. */
export type ApplicantJobFitComparison = {
  __typename?: 'ApplicantJobFitComparison';
  /** The candidate's and listing's answers to this question. */
  answer?: Maybe<ApplicantAssessmentAnswer>;
  /** The display label for this question. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Personality fit assessment comparison between candidate and listing. */
export type ApplicantPersonalityFit = {
  __typename?: 'ApplicantPersonalityFit';
  /** The importance weight assigned to personality fit for this listing. */
  importance?: Maybe<Scalars['Int']['output']>;
  /** The personality fit match percentage. */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** The candidate's and listing's personality type classifications. */
  personalityTypes?: Maybe<ApplicantPersonalityTypes>;
};

/** Personality type classifications for candidate and listing. */
export type ApplicantPersonalityTypes = {
  __typename?: 'ApplicantPersonalityTypes';
  /** The candidate's personality type classifications. */
  candidate: Array<Scalars['String']['output']>;
  /** The listing's required personality type classifications. */
  listing: Array<Scalars['String']['output']>;
};

/** The candidate's location information. */
export type ApplicantLocation = {
  __typename?: 'ApplicantLocation';
  /** City or suburb. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name or code. */
  country?: Maybe<Scalars['String']['output']>;
  /** True if the candidate's preferred location matches the listing's location. Null when not determinable. */
  match?: Maybe<Scalars['Boolean']['output']>;
  /** State or region. */
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * A single pre-screening answer enriched with the original question and desired answer
 * from the listing. Resolved by cross-referencing the application's answers with the
 * listing's pre-screening questions.
 */
export type ApplicantPreScreeningAnswer = {
  __typename?: 'ApplicantPreScreeningAnswer';
  /** The candidate's boolean answer to the question. */
  answer: Scalars['Boolean']['output'];
  /** True if the candidate's answer matches the employer's desired answer. */
  match: Scalars['Boolean']['output'];
  /** The text of the pre-screening question from the listing. Null when the question was removed from the listing after the candidate answered it. */
  question?: Maybe<Scalars['String']['output']>;
  /** The ID of the pre-screening question this answer relates to. */
  questionId: Scalars['ID']['output'];
};

export type ApplicantProfile = {
  __typename?: 'ApplicantProfile';
  attachments?: Maybe<Array<Maybe<ApplicantProfileAttachment>>>;
  contactDetails?: Maybe<ApplicantProfileContactDetails>;
  cvId?: Maybe<Scalars['String']['output']>;
  latestJob?: Maybe<ApplicantProfileJob>;
  prePopulate?: Maybe<ApplicantProfilePrePopulate>;
  previewAttachments?: Maybe<Array<Maybe<ApplicantProfilePreviewAttachment>>>;
  previewCv?: Maybe<ApplicantProfilePreviewCvResult>;
  professionalLinks?: Maybe<Array<Maybe<ApplicantProfileProfessionalLink>>>;
  relocation?: Maybe<ApplicantProfileRelocation>;
  workPreferences?: Maybe<ApplicantProfileWorkPreferences>;
};

export type ApplicantProfileContactDetails = {
  __typename?: 'ApplicantProfileContactDetails';
  email?: Maybe<Scalars['String']['output']>;
  phone1?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
};

export type ApplicantProfileJob = {
  __typename?: 'ApplicantProfileJob';
  company?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  skillIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ApplicantProfilePrePopulate = {
  __typename?: 'ApplicantProfilePrePopulate';
  allowed?: Maybe<Scalars['Boolean']['output']>;
  isPrePopulated?: Maybe<Scalars['Boolean']['output']>;
  userConfirmed?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicantProfilePreviewCvResult = {
  __typename?: 'ApplicantProfilePreviewCvResult';
  filename?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Array<ApplicantProfilePreviewCvFormat>>;
  id: Scalars['ID']['output'];
};

export type ApplicantProfileProfessionalLink = {
  __typename?: 'ApplicantProfileProfessionalLink';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ApplicantProfileRelocation = {
  __typename?: 'ApplicantProfileRelocation';
  authorized?: Maybe<Array<Maybe<ApplicantProfileLocation>>>;
  unauthorized?: Maybe<Array<Maybe<ApplicantProfileLocation>>>;
};

export type ApplicantProfileLocation = {
  __typename?: 'ApplicantProfileLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ApplicantProfileWorkPreferences = {
  __typename?: 'ApplicantProfileWorkPreferences';
  remote?: Maybe<Scalars['Boolean']['output']>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * Backward-compat stub for the candidate CV-summary entity.
 * Owned and resolved by the candidates subgraph.
 * @deprecated Use ApplicantProtectedProfile. Remove after frontend migration.
 */
export type ListingApplicantProtectedProfile = {
  __typename?: 'ListingApplicantProtectedProfile';
  candidateId: Scalars['ID']['output'];
  cvId?: Maybe<Scalars['ID']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryId?: Maybe<Scalars['ID']['output']>;
};

/** Qualification match analysis for an applicant against a listing. */
export type ApplicantQualifications = {
  __typename?: 'ApplicantQualifications';
  /** Qualifications the candidate holds. */
  candidate: Array<ApplicantCandidateQualification>;
  /** Qualifications the listing requested. */
  requested: Array<ApplicantRequestedQualification>;
};

/** A qualification held by the candidate. */
export type ApplicantCandidateQualification = {
  __typename?: 'ApplicantCandidateQualification';
  /** True if the candidate has completed this qualification. */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** The date the candidate completed this qualification. */
  completedAt?: Maybe<Scalars['String']['output']>;
  /** The institution where the qualification was obtained. */
  institution?: Maybe<Institution>;
  /** The ID of the institution where the qualification was obtained. */
  institutionId?: Maybe<Scalars['String']['output']>;
  /** The free-text institution name, set only when the candidate chose 'Other'. */
  institutionName?: Maybe<Scalars['String']['output']>;
  /** The qualification entity. */
  qualification?: Maybe<Qualification>;
  /** The date the candidate started studying for this qualification. */
  startedAt?: Maybe<Scalars['String']['output']>;
  /** True if the candidate is currently studying for this qualification. */
  studying?: Maybe<Scalars['Boolean']['output']>;
};

/** An educational institution. Owned by the options service; referenced here as a stub for federation delegation. */
export type Institution = {
  __typename?: 'Institution';
  /** Unique identifier for this institution. */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A qualification. Owned by the options service; matchmaker extends with subCategoryIds. */
export type Qualification = Node & {
  __typename?: 'Qualification';
  /** Unique identifier for this qualification. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** IDs of the sub-categories associated with this qualification. */
  subCategoryIds: Array<Scalars['String']['output']>;
  typeId: Scalars['ID']['output'];
  typeName: Scalars['String']['output'];
};

/** A listing-requested qualification group and whether the candidate matches it. */
export type ApplicantRequestedQualification = {
  __typename?: 'ApplicantRequestedQualification';
  /** Relative importance of this qualification requirement. */
  importance?: Maybe<Scalars['Int']['output']>;
  /** True if related qualifications (via sub-categories) are also accepted. */
  includeRelated?: Maybe<Scalars['Boolean']['output']>;
  /** True if the candidate's qualifications satisfy this requirement. */
  isMatch?: Maybe<Scalars['Boolean']['output']>;
  /** IDs of the acceptable qualifications. */
  qualificationIds: Array<Scalars['String']['output']>;
  /** The qualifications acceptable for this requirement. */
  qualifications: Array<Qualification>;
  /** Row identifier for this qualification requirement. */
  rowId?: Maybe<Scalars['String']['output']>;
};

/**
 * A single entry in the candidate's willRelocateTo list, enriched with
 * visa-authorization status and per-location match result for the listing.
 */
export type ApplicantRelocationLocation = {
  __typename?: 'ApplicantRelocationLocation';
  /** True if the candidate is authorised to work in this country (no visa required). */
  authorized: Scalars['Boolean']['output'];
  /** City or suburb of the relocation destination. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of the relocation destination. */
  country: Scalars['String']['output'];
  /** True if this destination matches the listing's location. Null when match data is not yet available. */
  match?: Maybe<Scalars['Boolean']['output']>;
  /** State or region of the relocation destination. */
  state?: Maybe<Scalars['String']['output']>;
};

/** Match scores for an applicant against a listing. */
export type ApplicantScores = {
  __typename?: 'ApplicantScores';
  /** Assessment match score as a percentage (0–100), or -1 if no assessments are required. */
  assessments?: Maybe<Scalars['Float']['output']>;
  /** Qualification match score as a percentage (0–100), or -1 if no qualifications are required. */
  qualifications?: Maybe<Scalars['Float']['output']>;
  /** Skill match score as a percentage (0–100), or -1 if no skills are required. */
  skills?: Maybe<Scalars['Float']['output']>;
  /** Overall weighted match score. */
  total?: Maybe<Scalars['Float']['output']>;
};

/** Skill match analysis for an applicant against a listing. */
export type ApplicantSkills = {
  __typename?: 'ApplicantSkills';
  /** Work history entries relevant to this match. */
  jobs: Array<ApplicantJob>;
  /** Grouped skill match results. */
  skills?: Maybe<ApplicantMatchedSkills>;
  /** Work area match results. */
  workAreas?: Maybe<ApplicantWorkAreaLists>;
};

/** A work history entry for an applicant, as used in skill-match analysis. */
export type ApplicantJob = {
  __typename?: 'ApplicantJob';
  /** Name of the employer. */
  company?: Maybe<Scalars['String']['output']>;
  /** End date of the role. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Skills used in this role. */
  skills: Array<Skill>;
  /** Start date of the role. */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Job title held. */
  title?: Maybe<Scalars['String']['output']>;
};

/** A skill. Owned by the options service; referenced here as a stub for federation delegation. */
export type Skill = Node & {
  __typename?: 'Skill';
  /** Unique identifier for this skill. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Grouped skill match results for an applicant. */
export type ApplicantMatchedSkills = {
  __typename?: 'ApplicantMatchedSkills';
  /** Other skills the candidate has that did not match any request. */
  other: Array<ApplicantOtherSkill>;
  /** Skills the listing explicitly requested. */
  requested: Array<ApplicantRequestedSkill>;
  /** Skills the candidate has that match a requested work area. */
  workAreaMatch: Array<ApplicantWorkAreaMatchSkill>;
};

/** A candidate skill that did not match any listing request. */
export type ApplicantOtherSkill = {
  __typename?: 'ApplicantOtherSkill';
  /** The number of years of experience the candidate has with this skill. */
  candidateYears?: Maybe<Scalars['Float']['output']>;
  /** The skill. */
  skill?: Maybe<Skill>;
};

/** A listing-requested skill group and the candidate's coverage of it. */
export type ApplicantRequestedSkill = {
  __typename?: 'ApplicantRequestedSkill';
  /** The number of years of experience the candidate has. */
  candidateYears?: Maybe<Scalars['Float']['output']>;
  /** IDs of the skills in this group. */
  ids: Array<Scalars['String']['output']>;
  /** Relative importance of this skill group. */
  importance?: Maybe<Scalars['Int']['output']>;
  /** The number of years of experience the listing requires. */
  requestedYears?: Maybe<Scalars['Float']['output']>;
  /** The skills in this requested group. */
  skills: Array<Skill>;
};

/** A candidate skill that matches a requested work area. */
export type ApplicantWorkAreaMatchSkill = {
  __typename?: 'ApplicantWorkAreaMatchSkill';
  /** The number of years of experience the candidate has with this skill. */
  candidateYears?: Maybe<Scalars['Float']['output']>;
  /** The skill. */
  skill?: Maybe<Skill>;
};

/** Work area match results grouped into requested and other. */
export type ApplicantWorkAreaLists = {
  __typename?: 'ApplicantWorkAreaLists';
  /** Other work areas the candidate has that the listing did not request. */
  other: Array<ApplicantOtherWorkArea>;
  /** Work areas the listing requested. */
  requested: Array<ApplicantRequestedWorkArea>;
};

/** A candidate work area that the listing did not request. */
export type ApplicantOtherWorkArea = {
  __typename?: 'ApplicantOtherWorkArea';
  /** The ID of this work area. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The work area entity. */
  workArea?: Maybe<WorkArea>;
};

/** A work area (skill subcategory). Owned by the options service; referenced here as a stub for federation delegation. */
export type WorkArea = Node & {
  __typename?: 'WorkArea';
  fieldId: Scalars['ID']['output'];
  fieldName?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for this work area. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A listing-requested work area and whether the candidate matches it. */
export type ApplicantRequestedWorkArea = {
  __typename?: 'ApplicantRequestedWorkArea';
  /** The ID of the requested work area. */
  id?: Maybe<Scalars['ID']['output']>;
  /** True if the candidate's work areas include this one. */
  match?: Maybe<Scalars['Boolean']['output']>;
  /** The work area entity. */
  workArea?: Maybe<WorkArea>;
};

/** Invitation status of an applicant. */
export type ApplicantStatus = {
  __typename?: 'ApplicantStatus';
  /** True if the talent pool candidate has been invited to apply. */
  invited: Scalars['Boolean']['output'];
};

/** Filter criteria for listing applicants. */
export type ApplicantFilter = {
  /**
   * Narrow the page to specific applicants by id. An empty list is no filter.
   *
   * For reading a known set back through search rather than by document id — a
   * client that has just mutated these applicants and needs to know when the
   * change is visible to the list. The single-applicant query answers a different
   * question: it resolves by document id, which is realtime, while the list only
   * sees a write once the index has refreshed.
   *
   * Cannot be combined with selecting Applicant.rank, which is a position in the
   * listing's canonical order that a page narrowed to an arbitrary set does not
   * carry.
   */
  applicantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by application completion status ('hired' or 'unsuccessful'). */
  completed?: InputMaybe<Scalars['String']['input']>;
  /** When true, exclude talent pool candidates. */
  hideTalentPool?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, exclude applicants marked as unsuccessful. */
  hideUnsuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applicants with a pending employer action. */
  isActionPending?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applicants whose location matches. */
  isLocationMatch?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applicants not yet viewed by the employer. */
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applicants whose pre-screening answers match. */
  isPreScreenMatch?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applicants whose profile is incomplete. */
  isProfileIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applicants whose salary expectation matches. */
  isSalaryMatch?: InputMaybe<Scalars['Boolean']['input']>;
  /** The listing to fetch applicants for. Either listingId or listingIds must be provided. */
  listingId?: InputMaybe<Scalars['ID']['input']>;
  /** Multiple listing IDs to fetch applicants across. Either listingId or listingIds must be provided. */
  listingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free-text search across applicant names. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by pipeline stage. */
  stageId?: InputMaybe<Scalars['ID']['input']>;
  /** Tag activity filter. */
  tagActivity?: InputMaybe<Scalars['String']['input']>;
  /** Filter by candidate tag IDs. */
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Pagination input for list queries. */
export type Pagination = {
  /** The page number to fetch, 1-indexed. Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items per page. Defaults to service-defined max. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of applicants for a listing. */
export type ApplicantsResult = {
  __typename?: 'ApplicantsResult';
  /** Listing overview count breakdown. Describes the whole listing, unscoped by the filters and the visibility toggles alike — use pageInfo.totalItems for the count matching this view. */
  counts: ApplicantsCounts;
  /** The applicants on the current page. */
  items: Array<Applicant>;
  /** Pagination metadata for this result. */
  pageInfo: PageInfo;
};

/** Pagination metadata returned alongside a paginated list result. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The current page number, 1-indexed. */
  page: Scalars['Int']['output'];
  /** The number of items per page. */
  pageSize: Scalars['Int']['output'];
  /** The total number of items matching the query. */
  totalItems: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Filter criteria for querying applications. */
export type ApplicationFilter = {
  /** When true, return only applications that are hires (the candidate was hired for this application's listing, matching Application.hired). When false, return applications that are not hires, including candidates hired for a different listing. */
  hired?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applications with a pending employer action. */
  isActionPending?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applications not yet viewed by the employer. */
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, return only applications marked as unsuccessful. */
  isUnsuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the listing the application was submitted for. */
  listingId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the organisation that owns the listing. */
  organisationId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the pipeline stage the application is in. */
  stageId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by lifecycle status. Multiple values are combined with OR. */
  status?: InputMaybe<Array<ApplicationStatus>>;
};

/** A paginated list of applications. */
export type ApplicationsResult = {
  __typename?: 'ApplicationsResult';
  /** The applications on the current page. */
  items: Array<Application>;
  /** Pagination metadata for this result. */
  pageInfo: PageInfo;
};

/** Per-organisation approval-workflow configuration (org singleton). */
export type ApprovalConfig = {
  __typename?: 'ApprovalConfig';
  /** The configured approval-type labels (e.g. 'Budget Approval'). */
  approvalTypes: Array<Scalars['String']['output']>;
  /** The curated pool of users selectable as approvers on requisitions. */
  approvers: Array<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the requisition approval workflow is enabled for the org. */
  enabled: Scalars['Boolean']['output'];
  /** The organisation this config belongs to. */
  organisation: Organisation;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Filter criteria for the generic approvals inbox. */
export type ApprovalFilter = {
  /** Restrict to a single approval-item type. */
  type?: InputMaybe<ApprovalItemType>;
};

/** The kind of item surfaced in the generic approvals inbox. */
export enum ApprovalItemType {
  /** A job requisition awaiting approval. */
  JobRequisition = 'JOB_REQUISITION'
}

/**
 * A generic approval-inbox item. Deliberately domain-agnostic so other
 * approval sources (e.g. Approval-to-Hire) can populate the same inbox later.
 */
export type ApprovalItem = {
  __typename?: 'ApprovalItem';
  /** Whether the caller can act on this item now — false while waiting their turn on a sequential chain, or once decided. */
  actionable: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Stable identifier for the underlying item (e.g. the requisition id). */
  id: Scalars['ID']['output'];
  /** The organisation the item belongs to. */
  organisation: Organisation;
  /** The caller's 1-based position in the item's approver sequence. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The user who raised the item. */
  requestedBy?: Maybe<User>;
  /** The requisition, populated when type is JOB_REQUISITION. */
  requisition?: Maybe<Requisition>;
  /** The underlying item's status, as a string (domain-specific). */
  status: Scalars['String']['output'];
  /** A short human-readable title (e.g. the job title). */
  title?: Maybe<Scalars['String']['output']>;
  /** Which kind of item this is. */
  type: ApprovalItemType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A job requisition — a governance gate captured before a job is created. */
export type Requisition = {
  __typename?: 'Requisition';
  /** The requisition's chronological activity log. */
  activity: Array<ActivityLogEntry>;
  /** Summary of amendments provided on the most recent resubmission. */
  amendmentsSummary?: Maybe<Scalars['String']['output']>;
  /** How the approvers are asked. PARALLEL unless chosen otherwise. */
  approvalMode: ApprovalMode;
  /** The named approvers and their decisions. */
  approvers: Array<Approver>;
  /** Whether the requisition has been archived from the active list. */
  archived: Scalars['Boolean']['output'];
  compensation?: Maybe<Compensation>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  headcount?: Maybe<Headcount>;
  /** Unique identifier (ULID). */
  id: Scalars['ID']['output'];
  jobDetails?: Maybe<JobDetails>;
  /** Jobs (listings) created from this requisition. */
  linkedJobs: Array<Listing>;
  /** The organisation that owns this requisition. */
  organisation: Organisation;
  /** The id of the organisation that owns this requisition. */
  organisationId: Scalars['ID']['output'];
  /** Action permissions the current user has on this requisition. */
  permissions: RequisitionPermissions;
  positionDescription?: Maybe<RequisitionFile>;
  recruitmentStrategy?: Maybe<RecruitmentStrategy>;
  /** Human-facing sequential reference (e.g. 'REQ-001'); absent on legacy rows. */
  reference?: Maybe<Scalars['String']['output']>;
  /** The user who raised the requisition. */
  requester: User;
  /** The current lifecycle status. */
  status: RequisitionStatus;
  supportingDocuments: Array<RequisitionFile>;
  supportingNotes?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A single append-only entry in a requisition's activity log. */
export type ActivityLogEntry = {
  __typename?: 'ActivityLogEntry';
  /** The action that occurred (e.g. 'Submitted for Approval'). */
  action: Scalars['String']['output'];
  /** Display name of the actor, or 'System' for automated transitions. */
  actor: Scalars['String']['output'];
  /** The acting user's Hire role at the time, when applicable. */
  actorRole?: Maybe<Scalars['String']['output']>;
  /** The acting user, when there was one. */
  actorUser?: Maybe<User>;
  /** Human-readable detail about the entry. */
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When the entry was recorded (ISO-8601 UTC). */
  timestamp: Scalars['String']['output'];
};

/**
 * How a requisition's approvers are asked: all at once, or one after another
 * in approver order. Chosen per requisition; fixed once it has been submitted.
 */
export enum ApprovalMode {
  Parallel = 'PARALLEL',
  Sequential = 'SEQUENTIAL'
}

/**
 * An approver named on a requisition. A reference to an existing Hire
 * owner/admin user; display fields resolve via the federated User entity.
 */
export type Approver = {
  __typename?: 'Approver';
  /** The approval-type labels this approver is responsible for. */
  approvalTypes: Array<Scalars['String']['output']>;
  /** Optional comment left with the decision. */
  comment?: Maybe<Scalars['String']['output']>;
  /** When the decision was made (ISO-8601). */
  decidedAt?: Maybe<Scalars['String']['output']>;
  /** This approver's current decision. */
  decision: ApproverDecision;
  /** 1-based position in the approver list — the chain order on a sequential requisition. */
  position: Scalars['Int']['output'];
  /** Whether this approver may decide now, is waiting their turn, has decided, or hasn't been asked. */
  turn: ApproverTurn;
  /** The approver user. */
  user: User;
};

/** A single approver's decision on a requisition. */
export enum ApproverDecision {
  /** This approver approved. */
  Approved = 'APPROVED',
  /** This approver declined. */
  Declined = 'DECLINED',
  /** The requisition is still a draft; this approver has not been asked yet. */
  NotSubmitted = 'NOT_SUBMITTED',
  /** Awaiting this approver's decision. */
  Pending = 'PENDING'
}

/**
 * Where an approver stands in the approval process. On a parallel requisition
 * every pending approver is ACTIVE; on a sequential one only the first pending
 * approver is, the rest are WAITING their turn.
 */
export enum ApproverTurn {
  /** May decide now. */
  Active = 'ACTIVE',
  /** Has approved or declined. */
  Decided = 'DECIDED',
  /** Not yet asked — the requisition hasn't been submitted. */
  NotAsked = 'NOT_ASKED',
  /** Pending, but behind an earlier approver in a sequential chain. */
  Waiting = 'WAITING'
}

/** Compensation details for a requisition. */
export type Compensation = {
  __typename?: 'Compensation';
  baseSalaryMax: Scalars['Int']['output'];
  baseSalaryMin: Scalars['Int']['output'];
  benefits?: Maybe<Scalars['String']['output']>;
  bonuses?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  otherCompensation?: Maybe<Scalars['String']['output']>;
  paymentSchedule?: Maybe<Scalars['String']['output']>;
  salaryConditions?: Maybe<Scalars['String']['output']>;
  salaryPeriod: Scalars['String']['output'];
  superannuation?: Maybe<Scalars['String']['output']>;
};

/** Headcount details for a requisition. */
export type Headcount = {
  __typename?: 'Headcount';
  /** Budget notes (Budgeted requests). */
  budgetNotes?: Maybe<Scalars['String']['output']>;
  /** Number of full-time-equivalent positions requested. */
  fte: Scalars['Int']['output'];
  /** Optional headcount reference, e.g. 'HC-2026-0042'. */
  positionNumber?: Maybe<Scalars['String']['output']>;
  /** Who is being replaced (Replacement requests). */
  replacingWho?: Maybe<Scalars['String']['output']>;
  /** The nature of the headcount request. */
  requestType: RequestType;
  /** Justification for unplanned headcount (Out of Budget requests). */
  unplannedReason?: Maybe<Scalars['String']['output']>;
};

/** The nature of the headcount being requested. */
export enum RequestType {
  /** New, budgeted headcount. */
  NewHeadcountBudgeted = 'NEW_HEADCOUNT_BUDGETED',
  /** New headcount that was not budgeted for. */
  NewHeadcountOutOfBudget = 'NEW_HEADCOUNT_OUT_OF_BUDGET',
  /** Backfilling an existing role. */
  Replacement = 'REPLACEMENT'
}

/** Job details for a requisition. */
export type JobDetails = {
  __typename?: 'JobDetails';
  costCentre?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  employmentType: Scalars['String']['output'];
  /** The hiring team this requisition is raised for (same teams as job creation). */
  hiringTeamId?: Maybe<Scalars['ID']['output']>;
  /** Denormalised team name for display, resolved when the team was picked. */
  hiringTeamName?: Maybe<Scalars['String']['output']>;
  idealStartDate?: Maybe<Scalars['String']['output']>;
  jobTitle: Scalars['String']['output'];
  /** Reference to the selected JobTitle in the org structure; jobTitle holds the resolved name for display. */
  jobTitleId?: Maybe<Scalars['ID']['output']>;
  reportingManager?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Scalars['String']['output']>;
  workSetting?: Maybe<Scalars['String']['output']>;
};

/** Action permissions the current user has on a specific requisition. */
export type RequisitionPermissions = {
  __typename?: 'RequisitionPermissions';
  /** Whether the user can approve or decline it right now (named approver, still Pending). */
  approve: Scalars['Boolean']['output'];
  /** Whether the user can create a Job from it (excludes Hiring Managers). */
  createJob: Scalars['Boolean']['output'];
  /** Whether the user can edit / submit / withdraw / resubmit / close it. */
  manage: Scalars['Boolean']['output'];
  /** Whether the user can view this requisition. */
  view: Scalars['Boolean']['output'];
};

/** A single uploaded file (uploads-service backed). */
export type RequisitionFile = {
  __typename?: 'RequisitionFile';
  fileKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSizeBytes?: Maybe<Scalars['Int']['output']>;
};

/** Recruitment strategy for a requisition. */
export type RecruitmentStrategy = {
  __typename?: 'RecruitmentStrategy';
  estimatedCost?: Maybe<Scalars['Int']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
};

/** The lifecycle status of a job requisition. */
export enum RequisitionStatus {
  /** Every approver has signed off. */
  Approved = 'APPROVED',
  /** Closed — no further jobs can be created from it. */
  Closed = 'CLOSED',
  /** At least one approver declined. */
  Declined = 'DECLINED',
  /** Being drafted; not yet sent for approval. */
  Draft = 'DRAFT',
  /** Submitted and awaiting approver decisions. */
  Pending = 'PENDING',
  /** Withdrawn by the requester before a decision was finalised. */
  Withdrawn = 'WITHDRAWN'
}

/**
 * The persisted assessment-suggestion set for a candidate + listing, shared across
 * all of that candidate/role's interviews and generated once (async) at
 * guide-assignment. Read via the assessmentSuggestions query; the UI polls until
 * status is READY.
 */
export type AssessmentSuggestionSet = {
  __typename?: 'AssessmentSuggestionSet';
  /** When generation was requested (ISO 8601 string); shown in the panel subheader. */
  generatedAt?: Maybe<Scalars['String']['output']>;
  /** Generation lifecycle status. */
  status: AssessmentSuggestionStatus;
  /** Suggestions in display order (Work Personality first, then by gap size). Empty until READY. */
  suggestions: Array<AssessmentSuggestion>;
};

/** Generation lifecycle of a candidate + listing's suggestion set. */
export enum AssessmentSuggestionStatus {
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Ready = 'READY'
}

/**
 * One assessment-based suggestion: the qualifying gap the frontend computed plus
 * the AI question generated for it, with its added-state for the viewed interview.
 * A value type embedded under its parent AssessmentSuggestionSet (no standalone
 * identity) — deliberately has NO `id`, so Apollo clients store it inline and
 * never normalise/merge suggestions across the candidate's interviews (whose
 * addedState differs). Matched to added scorecard questions by gapKey.
 */
export type AssessmentSuggestion = {
  __typename?: 'AssessmentSuggestion';
  /** Added-state for the interview in the query. */
  addedState: AssessmentSuggestionAddedState;
  /** Which assessment the gap is from. */
  assessment: AssessmentType;
  /** Role benchmark 1-5 score (null for a work-personality type mismatch). */
  benchmarkScore?: Maybe<Scalars['Float']['output']>;
  /** Candidate's 1-5 score (null for a work-personality type mismatch). */
  candidateScore?: Maybe<Scalars['Float']['output']>;
  /** Work Personality only: candidate's dominant work-style type. */
  candidateType?: Maybe<Scalars['String']['output']>;
  /** Human-readable dimension label. */
  dimension: Scalars['String']['output'];
  /** Signed gap (candidate minus benchmark); null for a type mismatch. */
  gap?: Maybe<Scalars['Float']['output']>;
  /** Plain-language description of the gap, used to calibrate the question. */
  gapDirection: Scalars['String']['output'];
  /**
   * Opaque gap key (matches the added scorecard question's assessmentGapKey).
   * Shared across the candidate's interviews and across candidates, so it is a
   * match key, NOT an identity.
   */
  gapKey: Scalars['ID']['output'];
  /** Culture Fit only: left bipolar pole label. */
  leftLabel?: Maybe<Scalars['String']['output']>;
  /** Gap priority. */
  priority: AssessmentGapPriority;
  /** The generated interview question. Empty until the set is READY. */
  question: Scalars['String']['output'];
  /** Work Personality only: role's required work-style type. */
  requiredType?: Maybe<Scalars['String']['output']>;
  /** Culture Fit only: right bipolar pole label. */
  rightLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The question's 1-5 scoring rubric. Null when the question has no rubric —
   * the caller generates one when adding the suggestion to a scorecard.
   */
  scoringGuide?: Maybe<ScoringGuide>;
};

/** Whether a suggestion has already been added, relative to the viewed interview. */
export enum AssessmentSuggestionAddedState {
  /** Added to another interview of the same candidate + listing; still addable here. */
  AddedElsewhere = 'ADDED_ELSEWHERE',
  /** Added to the interview being viewed. */
  AddedHere = 'ADDED_HERE',
  /** Not added to any interview yet. */
  Available = 'AVAILABLE'
}

/** Which organisational-fit assessment a gap comes from. */
export enum AssessmentType {
  CultureFit = 'CULTURE_FIT',
  JobDuties = 'JOB_DUTIES',
  WorkPersonality = 'WORK_PERSONALITY'
}

/** How significant an assessment gap is (drives question calibration). */
export enum AssessmentGapPriority {
  High = 'HIGH',
  Moderate = 'MODERATE'
}

/** A 1-5 scoring rubric: what a response at each level looks like. */
export type ScoringGuide = {
  __typename?: 'ScoringGuide';
  /** What a level-1 (poor) response looks like. */
  level1: Scalars['String']['output'];
  /** What a level-2 response looks like. */
  level2: Scalars['String']['output'];
  /** What a level-3 response looks like. */
  level3: Scalars['String']['output'];
  /** What a level-4 response looks like. */
  level4: Scalars['String']['output'];
  /** What a level-5 (excellent) response looks like. */
  level5: Scalars['String']['output'];
};

export type AuthClient = {
  __typename?: 'AuthClient';
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  scopes: Array<AuthScope>;
};

export type AuthScope = {
  __typename?: 'AuthScope';
  description: Scalars['String']['output'];
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

/**
 * Standing context about an organisation, captured once and read into every culture
 * report. There is exactly one profile per organisation, so its identity is the
 * organisation's.
 */
export type BusinessProfile = Node & {
  __typename?: 'BusinessProfile';
  /** When the profile was first captured. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The organisation's priorities for the next twelve months, most important first.
   * At most three. Empty when none have been captured.
   */
  goals: Array<Scalars['String']['output']>;
  /** The unique identifier of the profile, which is the organisation's identifier. */
  id: Scalars['ID']['output'];
  /** What the organisation does, how big it is and where it operates. */
  identity?: Maybe<BusinessProfileIdentity>;
  /** The chief executive, or the most senior leader the organisation has nominated. */
  leader?: Maybe<BusinessProfileLeader>;
  /**
   * The rest of the leadership team, not including the nominated leader. Empty when none
   * have been named.
   */
  leadershipTeam: Array<BusinessProfileTeamMember>;
  /** Where the organisation sits in its lifecycle. */
  lifecycle?: Maybe<BusinessProfileLifecycle>;
  /** The organisation this profile describes. */
  organisation: Organisation;
  /** Why the organisation exists and what it is working towards. */
  purpose?: Maybe<BusinessProfilePurpose>;
  /** When the profile was last researched. Only set on researched profiles. */
  researchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** How the profile was gathered. */
  source?: Maybe<BusinessProfileSource>;
  /** How the organisation's leadership is arranged. */
  structure?: Maybe<BusinessProfileStructure>;
  /** When the profile was last changed. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Always null. The website now belongs to the organisation and is set in admin.
   * @deprecated Managed in admin. Use organisationWebsite.
   */
  website?: Maybe<Scalars['String']['output']>;
};

/** What an organisation does, how big it is and where it operates. */
export type BusinessProfileIdentity = {
  __typename?: 'BusinessProfileIdentity';
  /** The founding year, or how long the organisation has been operating. */
  founded?: Maybe<Scalars['String']['output']>;
  /** The business type and industry. */
  industry?: Maybe<Scalars['String']['output']>;
  /** Head office and other locations. */
  locations?: Maybe<Scalars['String']['output']>;
  /** The geographic spread of operations. */
  reach?: Maybe<BusinessReach>;
  /** Headcount and revenue band. */
  scale?: Maybe<Scalars['String']['output']>;
  /** Whether people work onsite, hybrid or remote. */
  workModel?: Maybe<Scalars['String']['output']>;
};

/** The geographic spread of an organisation's operations. */
export enum BusinessReach {
  /** Operating across more than one country. */
  International = 'INTERNATIONAL',
  /** Operating within a single city or region. */
  Local = 'LOCAL',
  /** Operating across one country. */
  National = 'NATIONAL'
}

/** The chief executive, or the most senior leader the organisation has nominated. */
export type BusinessProfileLeader = {
  __typename?: 'BusinessProfileLeader';
  /** The leader's work personality, if they have completed an assessment. */
  personality?: Maybe<WorkPersonality>;
  /** The person filling the role. */
  user: OrganisationPerson;
};

/**
 * Someone's work personality, derived from the answers they gave to the personality
 * assessment. The derivation — counting the answers into a four letter code and looking
 * that code up against the eight work preference types — belongs to this service, so no
 * consumer has to repeat it.
 */
export type WorkPersonality = {
  __typename?: 'WorkPersonality';
  /** The phrase that captures how the person works. Null when no assessment exists. */
  catchPhrase?: Maybe<Scalars['String']['output']>;
  /** When the person completed their assessment. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the person has completed a personality assessment. */
  hasProfile: Scalars['Boolean']['output'];
  /** The work personality type, for example The Advisor. */
  personalityType?: Maybe<Scalars['String']['output']>;
  /** The characteristics that describe the person. Empty when no assessment exists. */
  traits: Array<Scalars['String']['output']>;
};

/**
 * A person at the organisation. Anyone here can be nominated as the organisation's leader,
 * or named on its leadership team.
 */
export type OrganisationPerson = {
  __typename?: 'OrganisationPerson';
  /** The unique identifier of the person. */
  id: Scalars['ID']['output'];
  /** The person's job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The person's full name. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Someone on the leadership team beside the nominated leader. */
export type BusinessProfileTeamMember = {
  __typename?: 'BusinessProfileTeamMember';
  /** Their work personality, if they have completed an assessment. */
  personality?: Maybe<WorkPersonality>;
  /** The person on the team. */
  user: OrganisationPerson;
};

/** Where the organisation sits in its lifecycle. */
export type BusinessProfileLifecycle = {
  __typename?: 'BusinessProfileLifecycle';
  /** The standing copy for this stage. */
  descriptor: LifecycleStageDescriptor;
  /** The stage the organisation is in. */
  stage: LifecycleStage;
  /** The organisation's own description of its stage. Only set when stage is OTHER. */
  stageOther?: Maybe<Scalars['String']['output']>;
};

/**
 * The standing copy that describes a lifecycle stage. Identical for every organisation at
 * a given stage.
 */
export type LifecycleStageDescriptor = {
  __typename?: 'LifecycleStageDescriptor';
  /** The people challenge this stage typically brings. */
  challenge: Scalars['String']['output'];
  /** Where an organisation at this stage puts its attention. */
  focus: Scalars['String']['output'];
  /** What an organisation at this stage is trying to achieve. */
  goal: Scalars['String']['output'];
  /** The display name of the stage. */
  label: Scalars['String']['output'];
  /** Position of this stage in the lifecycle, starting at 1. */
  order: Scalars['Int']['output'];
  /** The stage this copy describes. */
  stage: LifecycleStage;
  /** A one-word gloss on the stage, such as 'Expansion'. */
  subtitle: Scalars['String']['output'];
};

/** Where an organisation sits in its lifecycle. Shapes what a culture report emphasises. */
export enum LifecycleStage {
  /** Stemming the losses and deciding what to keep. */
  Decline = 'DECLINE',
  /** Reaching a sale, merger or wind-down in good order. */
  Exit = 'EXIT',
  /** Scaling what is already working. */
  Growth = 'GROWTH',
  /** Defending the position and improving margins. */
  Maturity = 'MATURITY',
  /** Something the organisation describes in its own words. */
  Other = 'OTHER',
  /** Proving the idea is worth building. */
  Seed = 'SEED',
  /** Finding customers and staying solvent. */
  Startup = 'STARTUP',
  /** Rebuilding a business that can grow again. */
  Turnaround = 'TURNAROUND'
}

/** Why the organisation exists and what it is working towards. */
export type BusinessProfilePurpose = {
  __typename?: 'BusinessProfilePurpose';
  /** Why the organisation exists today. */
  mission?: Maybe<Scalars['String']['output']>;
  /** The values the organisation holds. Empty when none have been captured. */
  values: Array<BusinessValue>;
  /** Where the organisation is trying to get to. */
  vision?: Maybe<Scalars['String']['output']>;
};

/** A value the organisation holds, and what it means in practice. */
export type BusinessValue = {
  __typename?: 'BusinessValue';
  /** What living this value looks like day to day. */
  meaning?: Maybe<Scalars['String']['output']>;
  /** The name of the value. */
  name: Scalars['String']['output'];
};

/** How the standing context on a business profile was gathered. */
export enum BusinessProfileSource {
  /** Entered by someone at the organisation. */
  Entered = 'ENTERED',
  /** Gathered automatically from the organisation's public web presence. */
  Researched = 'RESEARCHED'
}

/** How the organisation's leadership is arranged. */
export type BusinessProfileStructure = {
  __typename?: 'BusinessProfileStructure';
  /** Reporting lines, direct reports and team leads. */
  shape?: Maybe<Scalars['String']['output']>;
};

export type CultureHotspot = {
  __typename?: 'CultureHotspot';
  aggregateFilter?: Maybe<Scalars['String']['output']>;
  aggregation?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['JSON']['output']>;
  desired?: Maybe<Scalars['JSON']['output']>;
  hasParent?: Maybe<Scalars['Boolean']['output']>;
  pk?: Maybe<Scalars['String']['output']>;
  responseCount?: Maybe<Scalars['Int']['output']>;
  sk?: Maybe<Scalars['String']['output']>;
};

export type CulturePerceptionFilterInput = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CulturePerceptionResult = {
  __typename?: 'CulturePerceptionResult';
  completedUsersCount?: Maybe<Scalars['Int']['output']>;
  perceptionAverage?: Maybe<AssessmentPerception>;
  perceptionList?: Maybe<Array<Maybe<AssessmentPerception>>>;
  totalUsersCompleted?: Maybe<Scalars['Int']['output']>;
};

export type AssessmentPerception = {
  __typename?: 'AssessmentPerception';
  customerQuality?: Maybe<Scalars['Float']['output']>;
  financial?: Maybe<Scalars['Float']['output']>;
  jobEngagement?: Maybe<Scalars['Float']['output']>;
  jobSatisfaction?: Maybe<Scalars['Float']['output']>;
  learningGrowth?: Maybe<Scalars['Float']['output']>;
  operational?: Maybe<Scalars['Float']['output']>;
  overallClimate?: Maybe<Scalars['Float']['output']>;
  turnoverIntention?: Maybe<Scalars['Float']['output']>;
  workMotivation?: Maybe<Scalars['Float']['output']>;
};

/** A generated culture report for one campaign. */
export type CultureReport = Node & {
  __typename?: 'CultureReport';
  /** The campaign the report was generated from. */
  campaign: Campaign;
  /**
   * The report itself, one key per section, each carrying the figures that section shows.
   * Null until report generation finishes, which is well before the report as a whole is READY.
   */
  content?: Maybe<Scalars['JSON']['output']>;
  /**
   * A summary for each division and group with enough respondents to say anything about.
   * Empty until the entity summaries stage starts landing them.
   */
  entitySummaries: Array<CultureEntitySummary>;
  /** Why generation failed. Null unless the status is FAILED. */
  failure?: Maybe<CultureReportFailure>;
  /** The unique identifier of the report. */
  id: Scalars['ID']['output'];
  /** One entry per stage, in the order the stages run. */
  progress: Array<CultureReportStageProgress>;
  /** When the report was asked for. */
  requestedAt: Scalars['DateTime']['output'];
  /** How far generation has got. */
  status: CultureReportStatus;
  /** When the report last changed. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A culture campaign: one round of asking an organisation's people about its culture. */
export type Campaign = Node & {
  __typename?: 'Campaign';
  /** When the campaign stopped accepting responses. Null while it is still open. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the campaign. */
  id: Scalars['ID']['output'];
  /** What the campaign is called. */
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * A culture summary for one division or group.
 *
 * Summaries belong to the campaign rather than to any one report, so a campaign generated
 * more than once keeps a single, refreshed set of them.
 */
export type CultureEntitySummary = Node & {
  __typename?: 'CultureEntitySummary';
  /** The campaign the summary was drawn from. */
  campaign: Campaign;
  /** The summary itself. Its shape is set by the model and may change between reports. */
  content: Scalars['JSON']['output'];
  /** The name of the division or group. */
  entityName: Scalars['String']['output'];
  /** Whether this summarises a division or a group. */
  entityType: CultureEntityType;
  /** When the summary was last written. */
  generatedAt: Scalars['DateTime']['output'];
  /** The unique identifier of the summary. */
  id: Scalars['ID']['output'];
};

/**
 * The kind of thing a culture summary describes.
 *
 * Only the first nests. A person sits in one division, in any number of groups, at one
 * location, in one tenure band and at one job level, so the rest cut across each other and
 * the counts do not sum.
 */
export enum CultureEntityType {
  /** A division of the organisation. */
  Division = 'DIVISION',
  /** A group people were placed in for the campaign. */
  Group = 'GROUP',
  /** How senior the people in it are. */
  JobLevel = 'JOB_LEVEL',
  /** The office the people in it work out of. */
  Location = 'LOCATION',
  /** How long the people in it have worked here. */
  TenureBand = 'TENURE_BAND'
}

/** Why a report could not be generated. */
export type CultureReportFailure = {
  __typename?: 'CultureReportFailure';
  /**
   * What to tell the reader, ready to display. Never the underlying error, which is written
   * for whoever is debugging the run rather than for the person waiting on the report.
   */
  message: Scalars['String']['output'];
  /** The stage that failed. */
  stage: CultureReportStage;
};

/** One of the three stages a culture report is generated in. */
export enum CultureReportStage {
  /** Writes one summary card per division and per group. */
  EntitySummaries = 'ENTITY_SUMMARIES',
  /** Draws the recurring themes out of every comment left in the campaign. */
  FeedbackThemes = 'FEEDBACK_THEMES',
  /** Writes the report from those themes, the campaign results and the business profile. */
  ReportGeneration = 'REPORT_GENERATION'
}

/**
 * How one stage of a report is going. Every report carries an entry for all four stages,
 * whether or not they have started.
 */
export type CultureReportStageProgress = {
  __typename?: 'CultureReportStageProgress';
  /** When the stage finished or failed. Null until then. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Which stage this describes. */
  stage: CultureReportStage;
  /** When the stage was handed to the model. Null until it starts. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** How far the stage has got. */
  status: CultureReportStageStatus;
};

export enum CultureReportStageStatus {
  /** Finished, and its output stored. */
  Done = 'DONE',
  /** Gave up on this stage. */
  Failed = 'FAILED',
  /** Not started. */
  Pending = 'PENDING',
  /** Handed to the model, waiting on a result. */
  Running = 'RUNNING'
}

/**
 * How far a culture report has got. Generation runs in four stages and takes minutes, so a
 * report is readable well before it is finished.
 */
export enum CultureReportStatus {
  /** A stage failed. See the failure field for which one and why. */
  Failed = 'FAILED',
  /** At least one stage is running. */
  Generating = 'GENERATING',
  /** Requested. No stage has started yet. */
  Queued = 'QUEUED',
  /** The document and every entity summary have been written. */
  Ready = 'READY'
}

export type Division = {
  __typename?: 'Division';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeedbackTheme = {
  __typename?: 'FeedbackTheme';
  id: Scalars['ID']['output'];
  intents: Array<FeedbackSentimentIntent>;
  isNoise: Scalars['Boolean']['output'];
  originalFeedbackSks: Array<OriginalFeedbackReference>;
  processed: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FeedbackSentimentIntent = {
  __typename?: 'FeedbackSentimentIntent';
  id?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type OriginalFeedbackReference = {
  __typename?: 'OriginalFeedbackReference';
  index: Scalars['Int']['output'];
  sk: Scalars['String']['output'];
};

export type GetComponoAssistReactionInput = {
  keys: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type ComponoAssistReaction = {
  __typename?: 'ComponoAssistReaction';
  data?: Maybe<Scalars['JSON']['output']>;
  feedback: FeedbackType;
};

export enum FeedbackType {
  Disliked = 'disliked',
  Liked = 'liked',
  Neutral = 'neutral'
}

export type Group = {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberCount?: Maybe<Scalars['Int']['output']>;
  members?: Maybe<Array<Maybe<User>>>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GroupMemberInput = {
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  memberType?: InputMaybe<MemberType>;
};

export enum MemberType {
  Candidate = 'candidate',
  Employer = 'employer'
}

export type GroupMember = {
  __typename?: 'GroupMember';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  member?: Maybe<User>;
  memberId: Scalars['ID']['output'];
  memberType?: Maybe<MemberType>;
  organisationId: Scalars['ID']['output'];
  role?: Maybe<GroupRole>;
  roleDisplayName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum GroupRole {
  Facilitator = 'facilitator',
  Learner = 'learner',
  Manager = 'manager'
}

export type GroupMembersInput = {
  groupId: Scalars['ID']['input'];
  memberType?: InputMaybe<MemberType>;
  role?: InputMaybe<GroupRole>;
};

export type PublicGroupMembersInput = {
  groupId: Scalars['ID']['input'];
};

export type GroupPagination = {
  /** Default: 1 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Default: 20, max: 100 */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicGroupMembersResult = {
  __typename?: 'PublicGroupMembersResult';
  items: Array<PublicGroupMember>;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PublicGroupMember = {
  __typename?: 'PublicGroupMember';
  member?: Maybe<PublicUserListItem>;
};

/**
 * Lightweight user returned in list queries.
 * Use the user query for full detail including groupMemberships.
 */
export type PublicUserListItem = PublicUserBase & {
  __typename?: 'PublicUserListItem';
  division?: Maybe<OrganisationDivision>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<OrganisationJobTitle>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<OrganisationLocation>;
  organisation?: Maybe<OrganisationInfo>;
  productAccess?: Maybe<Array<Maybe<ProductAccess>>>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
};

export type PublicUserBase = {
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  productAccess?: Maybe<Array<Maybe<ProductAccess>>>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
};

export type ProductAccess = {
  __typename?: 'ProductAccess';
  /** App code e.g. shortlyster, develop, retayner */
  appCode: Scalars['String']['output'];
  appLabel?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
};

export enum UserStatus {
  Active = 'active',
  Deactivated = 'deactivated',
  Deleted = 'deleted',
  Suspended = 'suspended'
}

export type OrganisationDivision = {
  __typename?: 'OrganisationDivision';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** ID of the parent division, if this division is nested under another. Null for a top-level division. */
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type OrganisationJobTitle = {
  __typename?: 'OrganisationJobTitle';
  id: Scalars['ID']['output'];
  jobLevel?: Maybe<OrganisationJobLevel>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrganisationJobLevel = {
  __typename?: 'OrganisationJobLevel';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OrganisationLocation = {
  __typename?: 'OrganisationLocation';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OrganisationInfo = {
  __typename?: 'OrganisationInfo';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PublicGroupsResult = {
  __typename?: 'PublicGroupsResult';
  items: Array<PublicGroup>;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PublicGroup = {
  __typename?: 'PublicGroup';
  id: Scalars['ID']['output'];
  memberCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
};

export type ReportInput = {
  endDate: Scalars['String']['input'];
  hiringTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate: Scalars['String']['input'];
  timezoneOffset: Scalars['Int']['input'];
};

export type HireReportProcess = {
  __typename?: 'HireReportProcess';
  id: Scalars['ID']['output'];
};

export type HireReportResult = {
  __typename?: 'HireReportResult';
  export: HireReportExport;
  id: Scalars['ID']['output'];
  report: HireReportStats;
};

export type HireReportExport = {
  __typename?: 'HireReportExport';
  csvUrl: Scalars['String']['output'];
  noOfEntries: Scalars['Int']['output'];
};

export type HireReportStats = {
  __typename?: 'HireReportStats';
  aggregates: HireReport;
  applicationSources: HireReportApplicationSources;
};

export type HireReport = {
  __typename?: 'HireReport';
  avgTimeToFillInDays: Scalars['Float']['output'];
  avgTimeToHireInDays: Scalars['Float']['output'];
  jobsClosedInPeriod: Scalars['Int']['output'];
  jobsOpenAtEndDate: Scalars['Int']['output'];
  jobsOpenAtStartDate: Scalars['Int']['output'];
  jobsOpenedInPeriod: Scalars['Int']['output'];
  totalApplications: Scalars['Int']['output'];
  totalHires: Scalars['Int']['output'];
};

export type HireReportApplicationSources = {
  __typename?: 'HireReportApplicationSources';
  all: Array<HireReportApplicationSourceCount>;
  hired: Array<HireReportApplicationSourceCount>;
};

export type HireReportApplicationSourceCount = {
  __typename?: 'HireReportApplicationSourceCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** An interview guide template used to structure and standardise interviews. */
export type InterviewGuide = {
  __typename?: 'InterviewGuide';
  /** True when the guide has been archived (hidden from the default list). */
  archived: Scalars['Boolean']['output'];
  /** The user who created the guide. */
  author: User;
  /** The pre-interview checklist items, in display order. */
  checklist: Array<ChecklistItem>;
  /** The key competencies, in display order. */
  competencies: Array<Competency>;
  /** When the guide was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Division/department the guide is intended for. */
  division?: Maybe<Scalars['String']['output']>;
  /** Lifecycle of async AI guide generation (the editor polls until READY/FAILED). */
  generationStatus: GuideGenerationStatus;
  /** Unique identifier for this guide. */
  id: Scalars['ID']['output'];
  /** Whether the pre-interview checklist section is enabled. */
  includeChecklist: Scalars['Boolean']['output'];
  /** Whether the key-competencies section is enabled. */
  includeCompetencies: Scalars['Boolean']['output'];
  /** Reviewers who have been asked to provide input on this guide. */
  inputRequestedFrom: Array<User>;
  /** Interview purpose tags (e.g. screening, technical, final). */
  interviewPurpose: Array<Scalars['String']['output']>;
  /** True when the guide is assigned to at least one interview (blocks deletion). */
  inUse: Scalars['Boolean']['output'];
  /** Job title the guide is intended for. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The guide's questions, in display order. */
  questions: Array<InterviewGuideQuestion>;
  /** Number of questions on the guide. */
  questionsCount: Scalars['Int']['output'];
  /** Response format questions are framed for (e.g. STAR). */
  responseFormat: ResponseFormat;
  /** Whether assessment-based question suggestions are shown in the editor. */
  showSuggestions: Scalars['Boolean']['output'];
  /** Name of the document this guide was recreated from; null when it wasn't. */
  sourceFileName?: Maybe<Scalars['String']['output']>;
  /** Lifecycle status: Draft or Published. */
  status: InterviewGuideStatus;
  /** The guide title. */
  title: Scalars['String']['output'];
  /** When the guide was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Guidance on when to use this guide. */
  whenToUse?: Maybe<Scalars['String']['output']>;
};

/** A pre-interview checklist item on a guide. */
export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  /** Unique identifier for this checklist item. */
  id: Scalars['ID']['output'];
  /** Display order within the checklist. */
  order: Scalars['Int']['output'];
  /** The checklist item text. */
  text: Scalars['String']['output'];
};

/** A key competency the guide assesses. */
export type Competency = {
  __typename?: 'Competency';
  /** Unique identifier for this competency. */
  id: Scalars['ID']['output'];
  /** The competency name. */
  name: Scalars['String']['output'];
  /** Optional note about how the competency is assessed. */
  note?: Maybe<Scalars['String']['output']>;
  /** Display order within the competencies list. */
  order: Scalars['Int']['output'];
};

/** Lifecycle of async AI guide generation (the editor polls until READY/FAILED). */
export enum GuideGenerationStatus {
  /** Generation failed; the user can retry. */
  Failed = 'FAILED',
  /** Generation is running in the background — poll until it leaves this state. */
  Generating = 'GENERATING',
  /** The guide was not AI-generated (or generation has not been requested). */
  None = 'NONE',
  /** Generation finished; the guide content is populated. */
  Ready = 'READY'
}

/** A question on an interview guide, with its 1-5 scoring rubric. */
export type InterviewGuideQuestion = {
  __typename?: 'InterviewGuideQuestion';
  /** The bank question this was saved to / added from, if any. */
  bankQuestionId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for this question. */
  id: Scalars['ID']['output'];
  /** The competency topic this question assesses. */
  kssartiTopic?: Maybe<KssartiTopic>;
  /** True when the question is locked against editing by reviewers. */
  locked: Scalars['Boolean']['output'];
  /** Display order within the guide. */
  order: Scalars['Int']['output'];
  /** True when the question has been saved to the question bank. */
  savedToBank: Scalars['Boolean']['output'];
  /** The 1-5 scoring rubric for this question. */
  scoringGuide: ScoringGuide;
  /** The question text. */
  text: Scalars['String']['output'];
};

/** Competency topics a question can assess (7 dimensions + rapport building). */
export enum KssartiTopic {
  Abilities = 'ABILITIES',
  Interests = 'INTERESTS',
  Knowledge = 'KNOWLEDGE',
  RapportBuilding = 'RAPPORT_BUILDING',
  Resources = 'RESOURCES',
  Skills = 'SKILLS',
  SocialQualities = 'SOCIAL_QUALITIES',
  Traits = 'TRAITS'
}

/** Response format interview questions are framed for. */
export enum ResponseFormat {
  /** Context, Action, Result. */
  Car = 'CAR',
  /** No specific format. */
  None = 'NONE',
  /** Situation, Task, Action, Result. */
  Star = 'STAR'
}

/** Lifecycle status of an interview guide. */
export enum InterviewGuideStatus {
  /** Being authored; edits are held until saved. Not assignable to interviews. */
  Draft = 'DRAFT',
  /** Assignable to interviews. Still editable — re-publish to save changes. */
  Published = 'PUBLISHED'
}

/** Filter criteria for querying interview guides. */
export type InterviewGuideFilter = {
  /** Filter by archived state. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by division/department. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** Filter by job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Free-text search over the guide title. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by lifecycle status. */
  status?: InputMaybe<InterviewGuideStatus>;
};

/** A paginated list of interview guides. */
export type InterviewGuidesResult = {
  __typename?: 'InterviewGuidesResult';
  /** The guides on the current page. */
  items: Array<InterviewGuide>;
  /** Pagination metadata for this result. */
  pageInfo: PageInfo;
};

/**
 * One interviewer's scorecard for one interview: their answers (scores, notes,
 * not-asked flags) against the interview's question set, plus their overall
 * recommendation. Question CONTENT comes from the interview's guide snapshot
 * and the shared candidate questions; only the answers are per-scorecard.
 */
export type Scorecard = {
  __typename?: 'Scorecard';
  /** Average score across candidate-specific questions (computed at submit; not-asked excluded). */
  candidateQuestionScore?: Maybe<Scalars['Float']['output']>;
  /** When the scorecard was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The interviewer's final free-text comment. */
  finalComment?: Maybe<Scalars['String']['output']>;
  /** The live guide this scorecard was provisioned from. Prefer guideSnapshot for display. */
  guide: InterviewGuide;
  /** Average score across guide questions (computed at submit; not-asked excluded). */
  guideScore?: Maybe<Scalars['Float']['output']>;
  /** Point-in-time copy of the guide template captured when it was assigned. */
  guideSnapshot?: Maybe<InterviewGuideSnapshot>;
  /** Unique identifier for this scorecard. */
  id: Scalars['ID']['output'];
  /** The ID of the interview this scorecard belongs to. (No Interview entity exists in the graph — the interview event is owned by the legacy trackyr API.) */
  interviewId: Scalars['ID']['output'];
  /** Average score across all scored questions (computed at submit; not-asked excluded). */
  overallScore?: Maybe<Scalars['Float']['output']>;
  /** The interview's question set (snapshot GUIDE + shared candidate questions) with this interviewer's answers overlaid. */
  questions: Array<ScorecardQuestionEntry>;
  /** The interviewer's overall recommendation, chosen at submit. */
  recommendation?: Maybe<ScorecardRecommendation>;
  /** Draft until the interviewer submits; submitted scorecards are read-only. */
  status: ScorecardStatus;
  /** When the scorecard was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The interviewer this scorecard belongs to. */
  user: User;
};

/**
 * Point-in-time copy of the guide's template, captured when the guide was
 * assigned to the interview. The interview reads its displayed guide data from
 * here, so later edits / archival / deletion of the guide don't change it.
 */
export type InterviewGuideSnapshot = {
  __typename?: 'InterviewGuideSnapshot';
  /** The checklist items at capture time. */
  checklist: Array<SnapshotChecklistItem>;
  /** The competencies at capture time. */
  competencies: Array<SnapshotCompetency>;
  /** Division/department at capture time. */
  division?: Maybe<Scalars['String']['output']>;
  /** The guide this was captured from (for a 'view current version' link). */
  guideId: Scalars['ID']['output'];
  /** Whether the pre-interview checklist was enabled at capture time. */
  includeChecklist: Scalars['Boolean']['output'];
  /** Whether the key-competencies section was enabled at capture time. */
  includeCompetencies: Scalars['Boolean']['output'];
  /** What the guide is for, at capture time. */
  interviewPurpose?: Maybe<Array<Scalars['String']['output']>>;
  /** Job title at capture time. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Number of guide questions at capture time. */
  questionCount: Scalars['Int']['output'];
  /** Whether assessment-based suggestions were enabled at capture time (gates the scorecard's Suggestions panel). */
  showSuggestions: Scalars['Boolean']['output'];
  /** The guide's status at capture time. */
  status?: Maybe<Scalars['String']['output']>;
  /** The guide title at capture time. */
  title: Scalars['String']['output'];
  /** Guidance on when to use this guide, at capture time. */
  whenToUse?: Maybe<Scalars['String']['output']>;
};

/** A pre-interview checklist item captured in the guide snapshot. */
export type SnapshotChecklistItem = {
  __typename?: 'SnapshotChecklistItem';
  /** The checklist item text. */
  text: Scalars['String']['output'];
};

/** A competency captured in the guide snapshot. */
export type SnapshotCompetency = {
  __typename?: 'SnapshotCompetency';
  /** The competency name. */
  name: Scalars['String']['output'];
  /** Optional note about how the competency is assessed. */
  note?: Maybe<Scalars['String']['output']>;
};

/**
 * One question as it appears on a scorecard: the shared question definition
 * with this interviewer's answer (score/notes/notAsked) overlaid. A value type
 * embedded under its parent Scorecard (no standalone identity) — deliberately
 * has NO `id`, so Apollo clients store it inline and never normalise/merge
 * entries across scorecards. Addressed for saves/removals by questionId.
 */
export type ScorecardQuestionEntry = {
  __typename?: 'ScorecardQuestionEntry';
  /**
   * For SUGGESTION questions, the opaque assessment-gap key (e.g.
   * "CULTURE_FIT:innovative|cautious") this question was generated from. Lets the
   * Suggestions panel mark a gap as already added. Null for non-suggestion questions.
   */
  assessmentGapKey?: Maybe<Scalars['String']['output']>;
  /** The competency topic this question assesses. */
  kssartiTopic?: Maybe<KssartiTopic>;
  /** True when the question wasn't asked/scored in this interview (excluded from averages). */
  notAsked: Scalars['Boolean']['output'];
  /** The interviewer's notes for this question. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Display order within the scorecard. */
  order: Scalars['Int']['output'];
  /**
   * The shared question-definition id (the same value appears on every panel
   * member's scorecard and across interviews using the same guide). Unique
   * within a single scorecard, so it is the key for saving answers / removing
   * candidate questions — an addressing key, NOT a global identity.
   */
  questionId: Scalars['ID']['output'];
  /** The question text. */
  questionText: Scalars['String']['output'];
  /** The interviewer's 1-5 score. Null while unscored or when notAsked. */
  score?: Maybe<Scalars['Int']['output']>;
  /** The 1-5 scoring rubric for this question. */
  scoringGuide: ScoringGuide;
  /** Where the question came from (guide template, ad-hoc candidate question, suggestion, or the question bank). */
  source: ScorecardQuestionSource;
};

/** Origin of a scorecard question. */
export enum ScorecardQuestionSource {
  /** Added from the question bank. */
  Bank = 'BANK',
  /** Added ad-hoc during the interview (shared with the whole panel). */
  Candidate = 'CANDIDATE',
  /** From the assigned guide's snapshot. */
  Guide = 'GUIDE',
  /** Added from an assessment-based suggestion. */
  Suggestion = 'SUGGESTION'
}

/** The interviewer's overall hire recommendation. */
export enum ScorecardRecommendation {
  DoNotRecommend = 'DO_NOT_RECOMMEND',
  Recommend = 'RECOMMEND'
}

/** Lifecycle of a scorecard. */
export enum ScorecardStatus {
  /** In progress — the interviewer can still edit. */
  Draft = 'DRAFT',
  /** Submitted — final, read-only. */
  Submitted = 'SUBMITTED'
}

/**
 * An interview's transcript — pasted text or an uploaded file — plus the AI
 * artefacts derived from it (summary and scorecard analysis). One per interview.
 */
export type Transcript = {
  __typename?: 'Transcript';
  /** AI scorecard analysis of the transcript, when one has been generated. */
  aiAnalysis?: Maybe<AiAnalysis>;
  /** Lifecycle of the async AI scorecard analysis. The UI polls this after triggering a score. */
  aiAnalysisStatus: AiAnalysisStatus;
  /** When the transcript was uploaded. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Fresh short-lived download URL for the uploaded transcript file (forces a
   * browser download). Null for pasted transcripts. Resolved on demand — fetch
   * it at click time rather than caching it.
   */
  fileDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Original file name when the transcript was uploaded as a file. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this transcript. */
  id: Scalars['ID']['output'];
  /** The ID of the interview this transcript belongs to. (No Interview entity exists in the graph — the interview event is owned by the legacy trackyr API.) */
  interviewId: Scalars['ID']['output'];
  /** AI-generated summary of the transcript, when one has been generated. */
  summary?: Maybe<TranscriptSummary>;
  /** Lifecycle of the async transcript summary. The UI polls this after triggering a summary (reuses the AiAnalysisStatus lifecycle). */
  summaryStatus: AiAnalysisStatus;
  /** Transcript text — pasted at upload, or AI-extracted from the uploaded file via transcriptExtractText. Plain text: this is what the AI reads and what drives word count and fallback display. */
  text?: Maybe<Scalars['String']['output']>;
  /** Rich-text (HTML) version of a pasted transcript, preserving the formatting the interviewer pasted. Null for file uploads and for transcripts pasted before rich text was supported — fall back to `text` when absent. */
  textHtml?: Maybe<Scalars['String']['output']>;
  /** The user who uploaded the transcript. */
  uploadedBy: User;
};

/**
 * AI scorecard analysis of the transcript: per-question scores against the
 * interview's question set, plus an overall assessment.
 */
export type AiAnalysis = {
  __typename?: 'AIAnalysis';
  /** Areas of concern the AI identified. */
  areasOfConcern: Array<Scalars['String']['output']>;
  /** Key strengths the AI identified. */
  keyStrengths: Array<Scalars['String']['output']>;
  /** The AI's overall comment supporting the recommendation. */
  overallComment: Scalars['String']['output'];
  /** Per-question scores against the interview's question set. */
  questionScores: Array<AiQuestionScore>;
  /** The AI's overall hire recommendation. */
  recommendation: ScorecardRecommendation;
  /** AI-generated overall summary of the candidate's performance. */
  summary: Scalars['String']['output'];
  /** Weighted average score across the scored questions (1-5). */
  weightedScore: Scalars['Float']['output'];
};

/** A single AI-produced score for one interview question. */
export type AiQuestionScore = {
  __typename?: 'AIQuestionScore';
  /** True when the question's topic wasn't discussed in the transcript — the AI panel shows 'Not Asked' instead of a score. Null on analyses generated before this field existed. */
  notAsked?: Maybe<Scalars['Boolean']['output']>;
  /** The question this score is for. */
  questionId: Scalars['ID']['output'];
  /** The question this score is for, denormalised at scoring time so the AI panel is self-contained. Null on analyses generated before this field existed. */
  questionText?: Maybe<Scalars['String']['output']>;
  /** The AI's reasoning for the score. */
  reasoning: Scalars['String']['output'];
  /** The 1-5 score. Null when the question wasn't covered in the interview (notAsked). */
  score?: Maybe<Scalars['Int']['output']>;
};

/** Lifecycle of an async AI job on the transcript (summary or scorecard analysis). */
export enum AiAnalysisStatus {
  /** Analysis finished; `aiAnalysis` is populated. */
  Complete = 'COMPLETE',
  /** Analysis failed; the user can retry. */
  Failed = 'FAILED',
  /** Analysis is running in the background — poll until it leaves this state. */
  Generating = 'GENERATING',
  /** No analysis has been generated. */
  None = 'NONE'
}

/** AI-generated summary of an interview transcript. */
export type TranscriptSummary = {
  __typename?: 'TranscriptSummary';
  /** Overall summary of the interview. */
  summary: Scalars['String']['output'];
  /** Per-topic breakdown of what was discussed. */
  topicSummaries: Array<TopicSummary>;
};

/** One topic/theme discussed in the interview, with its summary detail. */
export type TopicSummary = {
  __typename?: 'TopicSummary';
  /** What was discussed about this topic. */
  detail: Scalars['String']['output'];
  /** The topic or theme discussed. */
  topic: Scalars['String']['output'];
};

export type JobTitle = {
  __typename?: 'JobTitle';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  jobLevelId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Filter criteria for searching listings. */
export type ListingFilter = {
  /** Only these listings. Still scoped to the current organisation and, below admin, the caller's hiring teams. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by assigned hiring manager ID. Use 'unassigned' to find listings without a manager. */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter listings by organisation ID. A user only ever sees their current organisation, so any other returns nothing. */
  organisationId?: InputMaybe<Scalars['ID']['input']>;
  /** Search listings by title (case-insensitive, partial match). */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by listing status. */
  status?: InputMaybe<ListingStatus>;
  /** Filter by team ID. */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** A paginated list of listings. */
export type ListingsResult = {
  __typename?: 'ListingsResult';
  /** The listings on the current page. */
  items: Array<Listing>;
  /** Pagination metadata for this result. */
  pageInfo: PageInfo;
};

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['ID']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MessageTemplateGeneratedResult = {
  __typename?: 'MessageTemplateGeneratedResult';
  errors?: Maybe<Array<Maybe<MessageTemplateMutationError>>>;
  messageTemplateGenerated?: Maybe<MessageTemplateGenerated>;
};

export type MessageTemplateMutationError = {
  __typename?: 'MessageTemplateMutationError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplateGenerated = {
  __typename?: 'MessageTemplateGenerated';
  content: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type Course = {
  __typename?: 'Course';
  authorName?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  enrolmentStatus?: Maybe<Scalars['String']['output']>;
  hasAssessments?: Maybe<Scalars['Boolean']['output']>;
  hasEvents?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Per-organisation Approval to Hire configuration (org singleton). */
export type OfferApprovalConfig = {
  __typename?: 'OfferApprovalConfig';
  /** Free-text labels assignable to an approver, e.g. 'Budget Approval'. */
  approvalTypes: Array<Scalars['String']['output']>;
  /** Curated pool of users selectable as approvers. */
  approvers: Array<User>;
  /** Whether the Approval to Hire workflow is enabled for the org. */
  enabled: Scalars['Boolean']['output'];
  /**
   * Candidate sections hidden from the approval form for this organisation.
   * Hidden rather than shown so that an empty list means the whole form: an org
   * that has never configured this sees everything, and so does one that
   * configured it before a new section existed.
   */
  hiddenCandidateSections: Array<OfferCandidateSection>;
};

/**
 * A candidate insight section an approver can be shown on the approval form.
 * Each one is a fixed part of the form, so this is an enum rather than an
 * org-defined label like an approval type.
 */
export enum OfferCandidateSection {
  /** Rank against the other applicants, with the fit scores. */
  CandidateRank = 'CANDIDATE_RANK',
  /** Interview rounds, dates and attendees. */
  InterviewsConducted = 'INTERVIEWS_CONDUCTED',
  /** Formal qualifications and their completion status. */
  Qualifications = 'QUALIFICATIONS',
  /** Skills with years of experience. */
  Skills = 'SKILLS',
  /** Archetype profile, characteristics and blind spots. */
  WorkPersonality = 'WORK_PERSONALITY'
}

/** A named bundle of templates added to an offer in one action (org-configured). */
export type OfferDocumentPackage = {
  __typename?: 'OfferDocumentPackage';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  templateIds: Array<Scalars['ID']['output']>;
};

/** A .docx template an offer document can be generated from (org-configured). */
export type OfferDocumentTemplate = {
  __typename?: 'OfferDocumentTemplate';
  documentTypeId: Scalars['ID']['output'];
  fileKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSizeBytes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** An offer document type, e.g. 'Employment Contract' (org-configured). */
export type OfferDocumentType = {
  __typename?: 'OfferDocumentType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CampaignAggregateFilter = {
  /** Only include aggregates whose closingDate is on or after this date. */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganisationCampaignAggregate = {
  __typename?: 'OrganisationCampaignAggregate';
  aggregateId: Scalars['ID']['output'];
  aggregation?: Maybe<Scalars['String']['output']>;
  aggregationType?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignName: Scalars['String']['output'];
  closingDate: Scalars['DateTime']['output'];
  completionRate: Scalars['Float']['output'];
  dimensions: Array<Dimension>;
  organisationId?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['Boolean']['output']>;
  warningMessage?: Maybe<Scalars['String']['output']>;
};

export type Dimension = {
  __typename?: 'Dimension';
  questionId: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
};

/**
 * Reference data for an organisation: its divisions, job titles (with levels)
 * and office locations, each with the ID needed to populate divisionId,
 * jobTitleId and orgLocationId on createUser/updateUser.
 */
export type OrganisationDemographics = {
  __typename?: 'OrganisationDemographics';
  /** All divisions configured for the organisation, including nested sub-divisions. */
  divisions: Array<OrganisationDivision>;
  /** All job titles configured for the organisation, each with its job level. */
  jobTitles: Array<OrganisationJobTitle>;
  /** All office locations configured for the organisation. */
  locations: Array<OrganisationLocation>;
};

/**
 * A configurable guide question for reference checks at the organisation level.
 * When a reference request is sent, enabled questions are snapshot-copied onto
 * each reference — subsequent edits do not affect existing references.
 */
export type OrganisationReferenceQuestion = {
  __typename?: 'OrganisationReferenceQuestion';
  /** When the question was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the question is currently active. */
  enabled: Scalars['Boolean']['output'];
  /** Additional context shown below the question label. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the guide question. */
  id: Scalars['ID']['output'];
  /** Display order of the question. */
  order: Scalars['Int']['output'];
  /** The organisation this guide question belongs to. */
  organisation: Organisation;
  /** Placeholder text for the response text area. */
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The main question text displayed to the recruiter. */
  questionLabel: Scalars['String']['output'];
  /** When the question was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A candidate in the organisation's talent pool. */
export type OrganisationTalent = {
  __typename?: 'OrganisationTalent';
  /** History of applications this candidate has submitted within the organisation. */
  applicationHistory?: Maybe<Array<OrganisationTalentApplication>>;
  /** IDs of file attachments on this candidate's profile. */
  attachmentIds?: Maybe<Array<Scalars['String']['output']>>;
  contact?: Maybe<OrganisationTalentContact>;
  /** The candidate's current contact location. */
  contactLocation?: Maybe<OrganisationTalentLocation>;
  /** ID of the candidate's CV document. */
  cvId?: Maybe<Scalars['ID']['output']>;
  documents?: Maybe<Array<OrganisationTalentDocument>>;
  /** Education history entries for this candidate. */
  education?: Maybe<Array<OrganisationTalentEducation>>;
  email?: Maybe<Scalars['String']['output']>;
  /** The candidate's preferred employment types. */
  employmentOptions: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this talent pool entry (the candidate ID). */
  id: Scalars['ID']['output'];
  /** Work history entries for this candidate. */
  jobs?: Maybe<Array<OrganisationTalentJob>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSigninAt?: Maybe<Scalars['String']['output']>;
  /** Primary phone number of the candidate. */
  phone1?: Maybe<Scalars['String']['output']>;
  /** Data prepopulation status for this candidate. */
  prePopulate?: Maybe<PrePopulate>;
  /** Professional links (e.g. LinkedIn, portfolio) provided by the candidate. */
  professionalLinks?: Maybe<Array<OrganisationTalentProfessionalLink>>;
  /** The relevance score assigned by the talent pool search. */
  rankingScore?: Maybe<Scalars['Float']['output']>;
  /** Locations the candidate is willing to relocate to. */
  willRelocateTo?: Maybe<Array<OrganisationTalentLocation>>;
  /** The candidate's work personality type, derived from assessment responses. */
  workPersonalityType?: Maybe<Scalars['String']['output']>;
};

/** A record of a candidate's prior application within this organisation, as seen from the talent pool. */
export type OrganisationTalentApplication = {
  __typename?: 'OrganisationTalentApplication';
  applicantId: Scalars['ID']['output'];
  /** The date and time the candidate submitted this application. */
  appliedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the current user's team has permission to view this application. */
  canView?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for this application record. */
  id: Scalars['ID']['output'];
  /** The title of the job listing. */
  jobTitle: Scalars['String']['output'];
  /** The listing id this application was submitted for. */
  listingId: Scalars['ID']['output'];
  /** The ID of the pipeline stage this application is currently in. */
  stageId?: Maybe<Scalars['ID']['output']>;
  /** The name of the pipeline stage this application is currently in. */
  stageName?: Maybe<Scalars['String']['output']>;
  /** The hiring team associated with this listing. */
  team?: Maybe<Team>;
};

export type OrganisationTalentContact = {
  __typename?: 'OrganisationTalentContact';
  phone1?: Maybe<Scalars['String']['output']>;
};

/** A geographic location associated with a candidate. */
export type OrganisationTalentLocation = {
  __typename?: 'OrganisationTalentLocation';
  /** City or suburb. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name or code. */
  country?: Maybe<Scalars['String']['output']>;
  /** Whether the candidate requires a visa to work at this location. */
  requiresVisa?: Maybe<Scalars['Boolean']['output']>;
  /** State or region. */
  state?: Maybe<Scalars['String']['output']>;
};

export type OrganisationTalentDocument = {
  __typename?: 'OrganisationTalentDocument';
  availableFormats?: Maybe<Array<OrganisationTalentDocumentFormat>>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: OrganisationTalentDocumentType;
};

export type OrganisationTalentDocumentFormat = {
  __typename?: 'OrganisationTalentDocumentFormat';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  isOriginal?: Maybe<Scalars['Boolean']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
};

export enum OrganisationTalentDocumentType {
  CoverLetter = 'coverLetter',
  Cv = 'cv',
  Other = 'other'
}

/** An education history entry for an organisation talent candidate. */
export type OrganisationTalentEducation = {
  __typename?: 'OrganisationTalentEducation';
  /** True if the qualification was completed. */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** End date of the education. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** ID of the educational institution. */
  institutionId?: Maybe<Scalars['ID']['output']>;
  /** Name of the educational institution. */
  institutionName?: Maybe<Scalars['String']['output']>;
  /** The qualification obtained. */
  qualification?: Maybe<Qualification>;
  /** Start date of the education. */
  startDate?: Maybe<Scalars['String']['output']>;
};

/** A work history entry for an organisation talent candidate. */
export type OrganisationTalentJob = {
  __typename?: 'OrganisationTalentJob';
  /** Name of the employer. */
  company?: Maybe<Scalars['String']['output']>;
  /** True if this is the candidate's current job. */
  currentJob?: Maybe<Scalars['Boolean']['output']>;
  /** End date of the role. Null if still current. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Skills used in this role. */
  skills: Array<Skill>;
  /** Start date of the role. */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Job title held. */
  title?: Maybe<Scalars['String']['output']>;
  /** Total years in this role, computed from start/end dates. */
  years?: Maybe<Scalars['Float']['output']>;
};

/** Candidate data-prepopulation consent and status flags. */
export type PrePopulate = {
  __typename?: 'PrePopulate';
  /** Whether prepopulation is allowed for this candidate. */
  allowed?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the candidate profile has been prepopulated. */
  isPrePopulated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the candidate has confirmed the prepopulated data. */
  userConfirmed?: Maybe<Scalars['Boolean']['output']>;
};

/** A professional external link on a candidate's profile (e.g. LinkedIn, portfolio). */
export type OrganisationTalentProfessionalLink = {
  __typename?: 'OrganisationTalentProfessionalLink';
  /** Display label for the link. */
  label: Scalars['String']['output'];
  /** The URL of the link. */
  url: Scalars['String']['output'];
};

/** Filter criteria for the talent pool search. */
export type OrganisationTalentSearchInput = {
  /** When true, include candidates willing to relocate to the specified locations. */
  acceptRelocations?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, also match qualifications related via sub-categories. */
  includeRelatedQualifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-text keyword search across candidate profiles. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Location filters. Results must match at least one of the provided locations. */
  locations?: InputMaybe<Array<OrganisationTalentLocationSearchInput>>;
  /** Filter by qualification IDs. Candidates must hold at least one. */
  qualificationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Salary expectation filter. */
  salaryExpectation?: InputMaybe<OrganisationTalentSalaryExpectationSearchInput>;
  /** Filter by skill IDs. Candidates must have experience with at least one. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by skill sub-category IDs. */
  skillSubcategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A location filter for the talent pool search. */
export type OrganisationTalentLocationSearchInput = {
  /** City or suburb. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country name or code. Required. */
  country: Scalars['String']['input'];
  /** Radius in kilometres for distance-based matching. */
  distanceMatching?: InputMaybe<Scalars['Int']['input']>;
  /** State or region. */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Salary expectation range filter for the talent pool search. */
export type OrganisationTalentSalaryExpectationSearchInput = {
  /** Maximum salary expectation. */
  max: Scalars['Int']['input'];
  /** Minimum salary expectation. */
  min: Scalars['Int']['input'];
};

/**
 * An organisation user with Hire (shortlyster) access and their Hire roles.
 * Backs the interview-guide "Request Input" reviewer picker.
 */
export type HireOrgUser = {
  __typename?: 'HireOrgUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user's Hire roles in this organisation (e.g. owner, admin, user, hiringManager). */
  roles: Array<Scalars['String']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  learningPortal?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalityAssessment = {
  __typename?: 'PersonalityAssessment';
  answers: Array<PersonalityAssessmentAnswer>;
  catchPhrase: Scalars['String']['output'];
  characteristics: Array<Maybe<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  result: Scalars['String']['output'];
};

export type PersonalityAssessmentAnswer = {
  __typename?: 'PersonalityAssessmentAnswer';
  answer: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export type PersonalityResultsQueryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalityAssessmentResult = {
  __typename?: 'PersonalityAssessmentResult';
  completedDate?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  personalityType?: Maybe<Scalars['String']['output']>;
};

export type PublicGroupDetail = {
  __typename?: 'PublicGroupDetail';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
};

/** Filter criteria for querying the question bank. */
export type QuestionBankFilter = {
  /** Filter by division/department. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** Filter by job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Filter by competency topic. */
  kssartiTopic?: InputMaybe<KssartiTopic>;
  /** Free-text search over the question text. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A paginated list of bank questions. */
export type QuestionBankResult = {
  __typename?: 'QuestionBankResult';
  /** The bank questions on the current page. */
  items: Array<BankQuestion>;
  /** Pagination metadata for this result. */
  pageInfo: PageInfo;
};

/**
 * A reusable interview question stored in the organisation's question bank,
 * addable to any interview guide (or to a scorecard during an interview).
 */
export type BankQuestion = {
  __typename?: 'BankQuestion';
  /** The user who added this question to the bank. */
  addedBy: User;
  /** When the question was added to the bank. */
  createdAt: Scalars['DateTime']['output'];
  /** Division/department this question is categorised under. */
  division?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this bank question. */
  id: Scalars['ID']['output'];
  /** Job title this question is categorised under. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The competency topic this question assesses. */
  kssartiTopic?: Maybe<KssartiTopic>;
  /** The 1-5 scoring rubric for this question. */
  scoringGuide: ScoringGuide;
  /** The question text. */
  text: Scalars['String']['output'];
  /** When the question was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who last updated this question, if any. */
  updatedBy?: Maybe<User>;
};

/**
 * A reference request as seen by the candidate. Contains the employer's
 * request details and the candidate's submitted (or pending) references.
 */
export type CandidateReferenceRequest = {
  __typename?: 'CandidateReferenceRequest';
  /** The ID of the application this request belongs to. */
  applicationId: Scalars['ID']['output'];
  /** The deadline by which references must be submitted. */
  deadline: Scalars['DateTime']['output'];
  /** Whether the deadline has passed. */
  deadlinePassed: Scalars['Boolean']['output'];
  /** Unique identifier for this reference request. */
  id: Scalars['ID']['output'];
  /** The title of the job the candidate applied for. */
  jobTitle: Scalars['String']['output'];
  /** The ID of the listing the candidate applied for. */
  listingId: Scalars['ID']['output'];
  /** The message from the employer explaining the reference request. */
  message: Scalars['String']['output'];
  /** The name of the organisation that requested references. */
  organisationName: Scalars['String']['output'];
  /** The candidate's references for this request. */
  references: Array<CandidateReference>;
  /** The number of references required from the candidate. */
  requiredCount: Scalars['Int']['output'];
  /** The number of references the candidate has submitted so far. */
  submittedCount: Scalars['Int']['output'];
};

/**
 * A reference as seen by the candidate. Contains only the details
 * the candidate submitted — not the referee's responses or employer notes.
 */
export type CandidateReference = {
  __typename?: 'CandidateReference';
  /** The company where the referee and candidate worked together. */
  company?: Maybe<Scalars['String']['output']>;
  /** The date and time the candidate last edited this reference. */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The referee's email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this reference. */
  id: Scalars['ID']['output'];
  /** The full name of the referee. */
  name?: Maybe<Scalars['String']['output']>;
  /** The referee's phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The professional relationship between the referee and the candidate. */
  relationship?: Maybe<ReferenceRelationship>;
  /** The current status of this reference. */
  status: ReferenceStatus;
  /** The date and time the candidate submitted this reference. */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Filter criteria for listing requisitions. */
export type RequisitionFilter = {
  /** Filter by archived flag (defaults to active-only when omitted). */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by division. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive partial match on the job title. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by lifecycle status. */
  status?: InputMaybe<RequisitionStatus>;
};

/** A paginated list of requisitions. */
export type RequisitionsResult = {
  __typename?: 'RequisitionsResult';
  items: Array<Requisition>;
  pageInfo: PageInfo;
};

export type SharePage = {
  __typename?: 'SharePage';
  dateShared?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  shareContent?: Maybe<Scalars['String']['output']>;
  sharer?: Maybe<Scalars['String']['output']>;
  sharerEmail?: Maybe<Scalars['String']['output']>;
  sk?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SsoConfig = {
  __typename?: 'SSOConfig';
  acsUrl?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  logoutUrl?: Maybe<Scalars['String']['output']>;
};

export type SsoConnection = {
  __typename?: 'SSOConnection';
  acsUrl?: Maybe<Scalars['String']['output']>;
  attributeMapping?: Maybe<Scalars['JSON']['output']>;
  autoSignup?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customParams?: Maybe<Scalars['JSON']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  encryptedResponses?: Maybe<Scalars['Boolean']['output']>;
  encryptionCertificate?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idpIdentifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isComponoAdmin?: Maybe<Scalars['Boolean']['output']>;
  logoutUrl?: Maybe<Scalars['String']['output']>;
  metadataFile?: Maybe<Scalars['String']['output']>;
  metadataUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['ID']['output'];
  replaceLoginPage?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

/** Standalone CV that can be used independently of a candidate profile. */
export type StandaloneCv = {
  __typename?: 'StandaloneCV';
  /** The MIME type of the CV. */
  contentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** All processing tasks with their status. */
  processing?: Maybe<StandaloneCvProcessing>;
};

export type StandaloneCvProcessing = {
  __typename?: 'StandaloneCVProcessing';
  convertToPdf?: Maybe<StandaloneCvProcessingConvertToPdf>;
  extractStructuredData?: Maybe<StandaloneCvProcessingExtractStructuredData>;
  generateSummaries?: Maybe<Array<StandaloneCvProcessingGenerateSummary>>;
};

export type StandaloneCvProcessingConvertToPdf = {
  __typename?: 'StandaloneCVProcessingConvertToPdf';
  /** Short lived URL to download the converted PDF. To generate a new URL run the query again. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The error message if the PDF conversion failed. */
  error?: Maybe<Scalars['String']['output']>;
  status: StandaloneCvProcessingStatus;
};

export enum StandaloneCvProcessingStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type StandaloneCvProcessingExtractStructuredData = {
  __typename?: 'StandaloneCVProcessingExtractStructuredData';
  /** The error message if the structured data extraction failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The extracted structured data from the CV. */
  extractedData?: Maybe<StandaloneCvStructuredData>;
  status: StandaloneCvProcessingStatus;
};

export type StandaloneCvStructuredData = {
  __typename?: 'StandaloneCVStructuredData';
  achievements?: Maybe<Array<StandaloneCvAchievement>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hobbies?: Maybe<Array<StandaloneCvHobby>>;
  jobHistory?: Maybe<Array<StandaloneCvJob>>;
  languages?: Maybe<Array<StandaloneCvLanguage>>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<StandaloneCvLocation>;
  other?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  professionalLinks?: Maybe<Array<StandaloneCvProfessionalLink>>;
  qualifications?: Maybe<Array<StandaloneCvQualification>>;
  references?: Maybe<Array<StandaloneCvReference>>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvAchievement = {
  __typename?: 'StandaloneCVAchievement';
  awardedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvHobby = {
  __typename?: 'StandaloneCVHobby';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvJob = {
  __typename?: 'StandaloneCVJob';
  companyName?: Maybe<Scalars['String']['output']>;
  currentJob?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  startDate?: Maybe<Scalars['String']['output']>;
  workAreas?: Maybe<Array<Scalars['String']['output']>>;
};

export type StandaloneCvLanguage = {
  __typename?: 'StandaloneCVLanguage';
  language?: Maybe<Scalars['String']['output']>;
  proficiency?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvLocation = {
  __typename?: 'StandaloneCVLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvProfessionalLink = {
  __typename?: 'StandaloneCVProfessionalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvQualification = {
  __typename?: 'StandaloneCVQualification';
  currentlyCompleting?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  qualificationName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type StandaloneCvReference = {
  __typename?: 'StandaloneCVReference';
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  socialNetworkProfileLinks?: Maybe<Array<Scalars['String']['output']>>;
};

export type StandaloneCvProcessingGenerateSummary = {
  __typename?: 'StandaloneCVProcessingGenerateSummary';
  /** The error message if the summary generation failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The format of the summary. */
  format?: Maybe<StandaloneCvSummaryFormat>;
  /** The ID of the standalone CV summary. */
  id: Scalars['ID']['output'];
  /** The status of the summary generation. */
  status: StandaloneCvProcessingStatus;
  /** The structure of the summary. */
  structure?: Maybe<StandaloneCvSummaryStructure>;
  /** The generated summary from the CV. */
  summary?: Maybe<Scalars['String']['output']>;
};

export enum StandaloneCvSummaryFormat {
  Markdown = 'MARKDOWN',
  PlainText = 'PLAIN_TEXT'
}

export enum StandaloneCvSummaryStructure {
  KeyHighlights = 'KEY_HIGHLIGHTS',
  ShortParagraphs = 'SHORT_PARAGRAPHS',
  SingleParagraph = 'SINGLE_PARAGRAPH'
}

/** A page of hiring teams. */
export type TeamsResult = {
  __typename?: 'TeamsResult';
  /** The teams on this page. */
  items: Array<Team>;
  /** Pagination metadata for this result. */
  pageInfo: PageInfo;
};

export type UploadRequest = {
  __typename?: 'UploadRequest';
  /** Short-lived presigned GET URL for reading the uploaded file back. */
  downloadUrl: Scalars['String']['output'];
  /** The ID of the upload request. */
  id: Scalars['ID']['output'];
  /** The URL to upload the file to. */
  uploadUrl: Scalars['String']['output'];
};

export type PublicUser = PublicUserBase & {
  __typename?: 'PublicUser';
  division?: Maybe<OrganisationDivision>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  groupMemberships?: Maybe<Array<Maybe<OrganisationGroupMembership>>>;
  hiringTeams?: Maybe<Array<Maybe<OrganisationHiringTeamMembership>>>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<OrganisationJobTitle>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<OrganisationLocation>;
  organisation?: Maybe<OrganisationInfo>;
  productAccess?: Maybe<Array<Maybe<ProductAccess>>>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
};

export type OrganisationGroupMembership = {
  __typename?: 'OrganisationGroupMembership';
  groupId: Scalars['ID']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type OrganisationHiringTeamMembership = {
  __typename?: 'OrganisationHiringTeamMembership';
  teamId: Scalars['ID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
};

export type UserGroupMemberInput = {
  memberId: Scalars['ID']['input'];
};

export type UsersFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type UsersPagination = {
  /** Default: 1 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Default: 20, max: 100 */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersResult = {
  __typename?: 'UsersResult';
  items: Array<PublicUserListItem>;
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add an approver to a specific requisition. Allowed while the requisition is
   * still in the approval process (Draft, Pending or Declined) — not once it is
   * Approved, Closed or Withdrawn. Idempotent for an existing approver.
   */
  addApproverToRequisition: Requisition;
  /**
   * Add members to a group
   *
   * - **Required Scopes:** `group:member:add`.
   */
  addGroupMembers?: Maybe<AddGroupMembersPayload>;
  /** Add an approval-type label to the org's approval config. */
  addRequisitionApprovalType: ApprovalConfig;
  /** Add a user to the org's curated approver pool. */
  addRequisitionApprover: ApprovalConfig;
  /** Drop (remove) an applicant from a listing. Requires editor role. */
  applicantDrop: ApplicantMutationResult;
  /** Invite a talent pool candidate to apply for the listing. Requires editor role. */
  applicantInvite: ApplicantMutationResult;
  /** Restore a previously dropped applicant. Requires editor role. */
  applicantRestore: ApplicantMutationResult;
  /** Drop (remove) multiple applicants from a listing. Requires editor role. */
  applicantsDrop: ApplicantsMutationResult;
  /** Mark a single application as hired. Requires employer authentication. */
  applicationHire: ApplicationMutationResult;
  /** Mark a single application as seen (clears the isNew flag). Requires employer authentication. */
  applicationMarkSeen: ApplicationMutationResult;
  /** Mark a single application as unseen (sets the isNew flag). Requires employer authentication. */
  applicationMarkUnseen: ApplicationMutationResult;
  /** Mark a batch of applications as unsuccessful. Requires employer authentication. */
  applicationMarkUnsuccessful: BatchApplicationMutationResult;
  /** Manually add a reference to an application. */
  applicationReferenceAdd: ReferenceMutationResult;
  /** Complete a reference by recording the results. */
  applicationReferenceComplete: ReferenceMutationResult;
  /** Decline a reference. */
  applicationReferenceDecline: ReferenceMutationResult;
  /** Edit a manually added reference's contact details. */
  applicationReferenceEdit: ReferenceMutationResult;
  /** Remove a reference from an application. */
  applicationReferenceRemove: ReferenceMutationResult;
  /** Request reference checks for an application. */
  applicationReferencesRequest: ReferenceMutationResult;
  /** Update the results of an already-completed reference. */
  applicationReferenceUpdateResults: ReferenceMutationResult;
  /** Mark a batch of applications as hired. Requires employer authentication. */
  applicationsHire: BatchApplicationMutationResult;
  /** Move a batch of applications to the specified pipeline stage. Requires employer authentication. */
  applicationsSetStage: BatchApplicationMutationResult;
  /** Reverse a hire decision for a single application. Requires employer authentication. */
  applicationUnhire: ApplicationMutationResult;
  /** Record the authenticated approver's approval on a Pending requisition. */
  approveRequisition: Requisition;
  /**
   * Generate the assessment-based suggestion set for an interview's candidate +
   * listing, if one doesn't already exist. The caller (frontend) computes the
   * qualifying gaps; this persists a GENERATING set (keyed by candidate + listing,
   * shared across all of that candidate/role's interviews) and hands generation to
   * gen-ai over EventBridge; the UI polls assessmentSuggestions until READY.
   * Reused across interviews: a no-op returning the existing set when one is
   * already present. Panel-scoped (interviewer on this panel only).
   */
  assessmentSuggestionsGenerate: AssessmentSuggestionSet;
  /**
   * Regenerate the set from scratch with freshly-computed gaps, discarding the
   * current suggestions and their added-state, for a clean slate in the panel.
   * Scorecard questions already added from the old set are left in place.
   * Panel-scoped (interviewer on this panel only).
   */
  assessmentSuggestionsRegenerate: AssessmentSuggestionSet;
  assignGroupRole?: Maybe<GroupMemberResponse>;
  /** Create a new question in the organisation's question bank. */
  bankQuestionCreate: BankQuestionMutationResult;
  /** Delete a bank question. */
  bankQuestionDelete: BankQuestionMutationResult;
  /** Update an existing bank question. */
  bankQuestionUpdate: BankQuestionMutationResult;
  /**
   * Removes the standing context for the caller's currently-selected organisation,
   * returning it to having no profile at all. False when there was none to remove.
   */
  businessProfileDelete: Scalars['Boolean']['output'];
  /**
   * Creates or changes the standing context for the caller's currently-selected
   * organisation. The profile is created on the first call.
   */
  businessProfileUpdate: BusinessProfileMutationResult;
  /** Manually close an Approved requisition. */
  closeRequisition: Requisition;
  confirmUserEmailUpdate: Scalars['Boolean']['output'];
  /** Creates a new Auth Client from the Auth Clients Management flow. */
  createAuthClient: CreateAuthClientPayload;
  /**
   * Create a group in the caller's organisation.
   *
   * - **Required Scopes:** `group:create`.
   */
  createGroup?: Maybe<PublicGroupMutationPayload>;
  /**
   * Create a Job (Listing) from an Approved requisition, linking it back to the
   * requisition. Reuses the existing Listings creation flow in-process. Returns
   * the newly-created Listing.
   */
  createJobFromRequisition: Listing;
  /** Create a new requisition draft. */
  createRequisition: Requisition;
  createSSOConnection?: Maybe<SsoConnection>;
  /** Create a new standalone CV */
  createStandaloneCV?: Maybe<StandaloneCv>;
  /** Create a new upload request */
  createUploadRequest?: Maybe<UploadRequest>;
  /**
   * Create a user in the caller's organisation.
   *
   * - **Required Scopes:** `user:create`.
   */
  createUser?: Maybe<PublicUser>;
  /**
   * Removes a campaign's culture report, along with every earlier run over the same
   * campaign and everything those runs produced. False when there was nothing to remove.
   * A run still generating goes too: its remaining stages are dropped rather than
   * finished, so the campaign is left ready to be reported on again.
   */
  cultureReportDelete: Scalars['Boolean']['output'];
  /**
   * Starts generating the culture report for a closed campaign. Returns as soon as the
   * report is queued, long before it is readable — poll the cultureReport query for
   * progress. Asking again while one is already generating is an error rather than a
   * second run.
   */
  cultureReportGenerate: CultureReportMutationResult;
  /**
   * Deactivates a user within the caller's organisation.
   * The user will no longer be able to authenticate.
   * Historical records are preserved.
   *
   * - **Required Scopes:** `user:deactivate`.
   */
  deactivateUser: DeactivateUserPayload;
  /** Record the authenticated approver's decline on a Pending requisition. */
  declineRequisition: Requisition;
  deleteAuthClient: Scalars['Boolean']['output'];
  deleteOrganisationTag?: Maybe<DeleteOrganisationTagMutationResult>;
  /** Permanently delete a Draft requisition. Returns true on success. */
  deleteRequisition: Scalars['Boolean']['output'];
  /**
   * Update a group in the caller's organisation.
   *
   * - **Required Scopes:** `group:update`.
   */
  editGroup?: Maybe<PublicGroupMutationPayload>;
  expireShareLink?: Maybe<Scalars['String']['output']>;
  getInsights?: Maybe<PersonalityInsights>;
  /**
   * Grants a user access to a product/module for the first time.
   * The user must already exist and belong to the organisation.
   * The user must not already have access to the specified product.
   *
   * - **Required Scopes:** `user:create` or `user:update`.
   */
  grantProductAccess?: Maybe<PublicUser>;
  groupAssignUser?: Maybe<GroupMemberResponse>;
  groupCreate?: Maybe<GroupResponse>;
  groupDelete?: Maybe<GroupResponse>;
  groupEdit?: Maybe<GroupResponse>;
  groupUnassignUser?: Maybe<GroupMemberResponse>;
  /** Archive a guide (hidden from the default list; restorable). */
  interviewGuideArchive: InterviewGuideMutationResult;
  /**
   * Assign a published guide to an interview: captures a point-in-time snapshot
   * of the guide and provisions a scorecard for every panel interviewer.
   */
  interviewGuideAssign: ScorecardMutationResult;
  /** Create a new interview guide in Draft. */
  interviewGuideCreate: InterviewGuideMutationResult;
  /** Delete a guide permanently. Blocked while the guide is assigned to any interview. */
  interviewGuideDelete: InterviewGuideMutationResult;
  /** Duplicate a guide (questions, checklist, competencies) as a new Draft. */
  interviewGuideDuplicate: InterviewGuideMutationResult;
  /**
   * Generate an entire interview guide using AI, based on position description and preferences.
   * Creates the guide with generated questions, competencies, and checklist items.
   */
  interviewGuideGenerateAI: InterviewGuideMutationResult;
  /**
   * Generate a brand-new question draft (text + scoring guide) from a context
   * prompt using AI. Does NOT persist — powers the "Generate Draft" panel in the
   * Add Question dialog. The caller applies / saves the result separately.
   */
  interviewGuideGenerateDraft: GeneratedQuestionResult;
  /** Generate a single interview question using AI for a specific KSSARTI topic. */
  interviewGuideGenerateQuestion: InterviewGuideMutationResult;
  /**
   * Generate multiple questions from a position description using AI and append
   * them to an existing guide (does not create a new guide).
   */
  interviewGuideGenerateQuestions: InterviewGuideMutationResult;
  /**
   * Generate multiple questions from a position description using AI and RETURN
   * them WITHOUT persisting — the editor batches them into local state and the
   * eventual interviewGuideSave writes them. Preview counterpart of
   * interviewGuideGenerateQuestions; uses the guide's saved role context.
   */
  interviewGuideGenerateQuestionsPreview: Array<GeneratedGuideQuestion>;
  /** Modify an existing question using AI with a natural language instruction. */
  interviewGuideModifyQuestion: InterviewGuideMutationResult;
  /** Add a question to a guide. */
  interviewGuideQuestionAdd: InterviewGuideMutationResult;
  /** Lock or unlock a guide question against reviewer edits. */
  interviewGuideQuestionLock: InterviewGuideMutationResult;
  /** Remove a question from a guide. */
  interviewGuideQuestionRemove: InterviewGuideMutationResult;
  /** Save a guide question to the organisation's question bank. */
  interviewGuideQuestionSaveToBank: InterviewGuideMutationResult;
  /** Reorder a guide's questions to match the given ID order. */
  interviewGuideQuestionsReorder: InterviewGuideMutationResult;
  /** Update a guide question. Omitted fields are left unchanged. */
  interviewGuideQuestionUpdate: InterviewGuideMutationResult;
  /**
   * Recreate an interview guide from a document the team already uses. Creates
   * the guide shell immediately with generation status `GENERATING` and
   * transcribes the uploaded document into it in the background — poll
   * `generationStatus` for the result, as with `interviewGuideGenerateAI`.
   */
  interviewGuideRecreate: InterviewGuideMutationResult;
  /**
   * Refine a question's wording with AI and return the result for preview.
   * Does NOT persist — powers the Modify Question dialog's "Refine with AI" chips
   * (the caller applies the change separately).
   */
  interviewGuideRefineQuestion: RefineQuestionResult;
  /**
   * Remove the assigned guide from an interview. Cascades: deletes all
   * scorecards (and answers), the snapshot, the shared candidate questions,
   * and clears the transcript's AI analysis. The transcript itself is kept.
   */
  interviewGuideRemove: ScorecardMutationResult;
  /**
   * Remove a single reviewer from a guide's `inputRequestedFrom` list (the "×"
   * on a requested person). Idempotent — removing an id that isn't present is a
   * no-op success.
   */
  interviewGuideRemoveInputRequest: InterviewGuideMutationResult;
  /**
   * Ask selected reviewers for input on a guide: records them on
   * `inputRequestedFrom` (deduplicated) and emails them. Does NOT change the
   * guide's status and works in any state (Draft or Published). The recorded
   * reviewers persist until explicitly removed via interviewGuideRemoveInputRequest.
   */
  interviewGuideRequestInput: InterviewGuideMutationResult;
  /** Restore an archived guide. */
  interviewGuideRestore: InterviewGuideMutationResult;
  /**
   * Persist the full editable state of a guide in one atomic operation — the
   * editor's batched "Save and close" / "Publish" / "Move to draft". Reconciles
   * details + questions + checklist + competencies to match `input` (children
   * with an id are updated, without an id are created, and existing children
   * absent from the arrays are deleted; array order sets display order), then
   * sets the status: PUBLISHED when `publish` is true, otherwise DRAFT.
   */
  interviewGuideSave: InterviewGuideMutationResult;
  /** Update a guide's details. Omitted fields are left unchanged. */
  interviewGuideUpdate: InterviewGuideMutationResult;
  /**
   * Mark a listing as awaiting a match recalculation, inside the request. Requires editor role.
   *
   * For the client that has just done something matchmaker will rescore for — opening a
   * listing, or editing an open one — and is about to show the applicants list. The rescore
   * is triggered by matchmaker's own projection of the resulting Listing.Updated, an
   * EventBridge delivery and a queue later, so until that lands Listing.isProcessingMatches
   * reads false: a page loading in between shows a list that is still being built as though
   * it were settled, and nothing on it asks again.
   *
   * This writes the same pending marker that projection would, so the flag is already true
   * for the next read. It enqueues nothing — the event still drives the recalculation
   * itself — and the marker is TTL'd, so marking a listing no event follows costs a spinner
   * that clears itself. Idempotent: the projection's own write a moment later replaces
   * pending with pending.
   */
  listingMatchmakingMarkPending: ListingMatchmakingMutationResult;
  /**
   * Start a recalculation of a listing's match scores. Requires editor role or above,
   * on the listing's team unless admin or owner. Refuses a closed listing.
   *
   * Despite the name, this does NOT persist the score weights. The listings service owns
   * them and matchmaker's listing row is a projection of Listing.Updated, so the
   * scoreWeights argument is echoed back in the result rather than applied — a caller that
   * only calls this mutation changes no ranking. Persist the weights through the listings
   * service (today, trackyr-gateway's updateListing); the resulting Listing.Updated is
   * what enqueues the rescore.
   *
   * What this adds on top of that event is immediacy: it marks the listing as recomputing
   * inside the request, so Listing.isProcessingMatches is already true for the refetch a
   * client issues straight after saving, rather than a queue hop later.
   */
  listingScoreWeightsUpdate: ListingScoreWeightsMutationResult;
  messageTemplateCreate?: Maybe<MessageTemplateMutationResult>;
  messageTemplateDelete?: Maybe<MessageTemplateMutationResult>;
  messageTemplateUpdate?: Maybe<MessageTemplateMutationResult>;
  /** Add an approver (idempotent). Allowed until the approval settles. */
  offerApprovalAddApprover: Offer;
  /** Approve as a named approver (optional comment). */
  offerApprovalApprove: Offer;
  /**
   * Show or hide one candidate section on the approval form, for the whole
   * organisation (idempotent). One section per call so that two admins toggling
   * different sections do not overwrite each other.
   */
  offerApprovalConfigSetCandidateSection: OfferApprovalConfig;
  /** Enable or disable the Approval to Hire workflow. Never deletes data. */
  offerApprovalConfigSetEnabled: OfferApprovalConfig;
  /** Decline as a named approver. A comment is required. */
  offerApprovalDecline: Offer;
  /**
   * Remove an approver (idempotent). Removing the last outstanding approver
   * settles the approval from the remaining decisions.
   */
  offerApprovalRemoveApprover: Offer;
  /**
   * 'Make changes and resubmit' — takes the edited payload and re-pends every
   * approver in one write. The amendments summary is optional: an edit made
   * through the stepped flow is described by the change itself, and forcing a
   * sentence before the approvers can be re-asked only invites filler.
   */
  offerApprovalResubmit: Offer;
  /** Initiate the Approval to Hire for an offer (idempotent). */
  offerApprovalStart: Offer;
  /** Submit the Approval to Hire with the full form payload. */
  offerApprovalSubmit: Offer;
  /** Add an approval-type label (idempotent). */
  offerApprovalTypeAdd: OfferApprovalConfig;
  /** Remove an approval-type label. At least one must always remain. */
  offerApprovalTypeRemove: OfferApprovalConfig;
  /** Withdraw a pending/declined approval; the offer unlocks for editing. */
  offerApprovalWithdraw: Offer;
  /** Add a user to the org's approver pool (idempotent). */
  offerApproverAdd: OfferApprovalConfig;
  /** Remove a user from the approver pool (idempotent). */
  offerApproverRemove: OfferApprovalConfig;
  /** Stage every template in a package — one document per template. */
  offerDocumentAddFromPackage: Array<OfferDocument>;
  /**
   * Stage a document generated from a template. Returns immediately with
   * generationStatus PENDING; the async pipeline flips it to READY | FAILED.
   */
  offerDocumentAddFromTemplate: OfferDocument;
  /** Stage an uploaded document on the offer (ready immediately). */
  offerDocumentAddFromUpload: OfferDocument;
  /** Upload a signed copy directly into the offer's repository. */
  offerDocumentAddToRepository: OfferDocument;
  /** Record that a prepared document has gone to the candidate. */
  offerDocumentMarkSent: OfferDocument;
  /** Create a document package. */
  offerDocumentPackageCreate: OfferDocumentPackage;
  /** Remove a document package (templates are untouched). */
  offerDocumentPackageRemove: Array<OfferDocumentPackage>;
  /** Update a document package. */
  offerDocumentPackageUpdate: OfferDocumentPackage;
  /** Remove a document from the offer. */
  offerDocumentRemove: Array<OfferDocument>;
  /** Register an uploaded .docx as a document template. */
  offerDocumentTemplateCreate: OfferDocumentTemplate;
  /** Remove a template; it is also detached from any package bundling it. */
  offerDocumentTemplateRemove: Array<OfferDocumentTemplate>;
  /** Create an offer document type. */
  offerDocumentTypeCreate: OfferDocumentType;
  /** Remove a document type. A type in use by a template can't be removed. */
  offerDocumentTypeRemove: Array<OfferDocumentType>;
  /** Save the offer's Job Details / Compensation. */
  offerSaveDetails: Offer;
  /** Start the offer process for an application (idempotent). */
  offerStart: Offer;
  /** Create a new reference check guide question for the current organisation. */
  organisationReferenceQuestionCreate: OrganisationReferenceQuestionMutationResult;
  /** Delete a reference check guide question. */
  organisationReferenceQuestionDelete: OrganisationReferenceQuestionMutationResult;
  /** Update an existing reference check guide question. */
  organisationReferenceQuestionUpdate: OrganisationReferenceQuestionMutationResult;
  organisationTagActivitySet?: Maybe<OrganisationTagActivityMutationResult>;
  organisationTagCreate?: Maybe<OrganisationTagMutationResult>;
  personalityAssessmentInviteMembers?: Maybe<PersonalityAssessmentInviteMembers>;
  personalityAssessmentSaveAnswers?: Maybe<PersonalityAssessment>;
  /** Edit previously submitted referee details. */
  referenceEdit: CandidateReferenceMutationResult;
  /** Submit referee details for a pending reference placeholder. */
  referenceSubmit: CandidateReferenceMutationResult;
  /**
   * Remove an approver from a specific requisition. Same status rules as
   * addApproverToRequisition. If the remaining approvers are decisive (e.g. all
   * have approved) the requisition settles accordingly.
   */
  removeApproverFromRequisition: Requisition;
  /**
   * Remove members from a group
   *
   * - **Required Scopes:** `group:member:remove`.
   */
  removeGroupMembers?: Maybe<RemoveGroupMembersPayload>;
  /** Remove an approval-type label from the org's approval config. */
  removeRequisitionApprovalType: ApprovalConfig;
  /** Remove a user from the org's curated approver pool. */
  removeRequisitionApprover: ApprovalConfig;
  removeSSOConnection?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a standalone CV */
  removeStandaloneCV?: Maybe<StandaloneCvRemoval>;
  /** Reopen a Closed requisition so jobs can be created against it again. */
  reopenRequisition: Requisition;
  resendUserEmailUpdateCode: Scalars['Boolean']['output'];
  /**
   * Resubmit a Pending/Declined requisition, re-pending all approvers. Pass
   * input to persist edits made via Make Changes & Resubmit before re-pending.
   */
  resubmitRequisition: Requisition;
  /**
   * Removes a user's access to a product/module.
   * The user account remains active. Only the specified product access is removed.
   *
   * - **Required Scopes:** `user:create` or `user:update`.
   */
  revokeProductAccess?: Maybe<PublicUser>;
  saveComponoAssistReaction?: Maybe<ComponoAssistReaction>;
  /** Save changes to an existing draft requisition. */
  saveRequisitionDraft: Requisition;
  /**
   * Idempotently create the calling interviewer's own scorecard for the guide
   * already assigned to this interview. Used to self-provision a panel member
   * who joined after assignment (so the fan-out missed them) — e.g. a Reviewer.
   * Returns a null scorecard (no error) when no guide is assigned or the caller
   * is not on the interview panel.
   */
  scorecardEnsure: ScorecardMutationResult;
  /**
   * Add a candidate-specific question during the interview. The question is
   * shared with the whole panel; each interviewer scores it on their own
   * scorecard. Interviewers who already submitted get it marked "not asked".
   */
  scorecardQuestionAdd: ScorecardMutationResult;
  /** Remove a shared candidate question for the whole panel (sweeps every interviewer's answer for it). */
  scorecardQuestionRemove: ScorecardMutationResult;
  /** Save draft answers (scores/notes/notAsked), recommendation and comment on the caller's scorecard. */
  scorecardSave: ScorecardMutationResult;
  /** Submit the caller's scorecard: persists final answers and computes the guide/candidate/overall scores. */
  scorecardSubmit: ScorecardMutationResult;
  /**
   * Replace a requisition's approver list in one go — the Edit Approvers
   * session. An approvers-only change does not restart the approval: existing
   * decisions stand, dropped approvers are stood down, newcomers are asked (in
   * turn on a sequential chain) and removing the active approver hands the turn
   * to the next. Draft or Pending only; a Pending requisition keeps at least one
   * approver.
   */
  setRequisitionApprovers: Requisition;
  /** Archive or restore a requisition (Active/Archived list split). */
  setRequisitionArchived: Requisition;
  /** Enable or disable the requisition workflow for the caller's org. */
  setRequisitionWorkflowEnabled: ApprovalConfig;
  shareCultureReport?: Maybe<SharePage>;
  /** Submit a draft for approval (Draft → Pending). */
  submitRequisition: Requisition;
  systemTagActivitySet?: Maybe<TagActivityMutationResult>;
  /** Remove the transcript (and its summary / AI analysis) for an interview. */
  transcriptDelete: TranscriptMutationResult;
  /**
   * Extract and store the transcript text from an uploaded file via AI so it
   * can be displayed. Idempotent: returns the existing text when already
   * extracted (or when the transcript was pasted as text).
   */
  transcriptExtractText: TranscriptMutationResult;
  /**
   * Generate an AI scorecard analysis of the transcript against the interview's
   * question set. Async: marks `aiAnalysisStatus` GENERATING and returns
   * immediately — poll `aiAnalysisStatus` until COMPLETE/FAILED.
   */
  transcriptGenerateAIScore: TranscriptMutationResult;
  /**
   * Generate an AI summary of the transcript. Async: marks `summaryStatus`
   * GENERATING and returns immediately — poll `summaryStatus` until
   * COMPLETE/FAILED.
   */
  transcriptGenerateSummary: TranscriptMutationResult;
  /** Upload an interview transcript as pasted text or a file. One transcript per interview. */
  transcriptUpload: TranscriptMutationResult;
  /**
   * Edit an Approved requisition. Every field except the approver list is
   * writable — the sign-off is final, so 'approvers' on the input is ignored.
   * A changed closing date must still be in the future.
   */
  updateApprovedRequisition: Requisition;
  updateAuthClient: AuthClient;
  /** @deprecated Use listingScoreWeightsUpdate instead. */
  updateListingScoreWeights?: Maybe<ListingScoreWeights>;
  /**
   * Updates the role for a product/module the user already has access to.
   * Only the specified product is affected; other product access remains unchanged.
   *
   * - **Required Scopes:** `user:create` or `user:update`.
   */
  updateProductAccess?: Maybe<PublicUser>;
  updateSSOConnection?: Maybe<SsoConnection>;
  /**
   * Update a user in the caller's organisation.
   *
   * - **Required Scopes:** `user:update`.
   */
  updateUser?: Maybe<PublicUser>;
  validateSkillQualificationMatches: MatchValidationResult;
  /** Withdraw a Pending/Declined requisition. */
  withdrawRequisition: Requisition;
};


export type MutationAddApproverToRequisitionArgs = {
  approver: ApproverInput;
  id: Scalars['ID']['input'];
};


export type MutationAddGroupMembersArgs = {
  input: AddGroupMembersInput;
};


export type MutationAddRequisitionApprovalTypeArgs = {
  label: Scalars['String']['input'];
};


export type MutationAddRequisitionApproverArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationApplicantDropArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplicantInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplicantRestoreArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplicantsDropArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationApplicationHireArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplicationMarkSeenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplicationMarkUnseenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplicationMarkUnsuccessfulArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationApplicationReferenceAddArgs = {
  applicationId: Scalars['ID']['input'];
  input: ApplicationReferenceAddInput;
};


export type MutationApplicationReferenceCompleteArgs = {
  applicationId: Scalars['ID']['input'];
  input: ReferenceResultsInput;
  referenceId: Scalars['ID']['input'];
};


export type MutationApplicationReferenceDeclineArgs = {
  applicationId: Scalars['ID']['input'];
  referenceId: Scalars['ID']['input'];
};


export type MutationApplicationReferenceEditArgs = {
  applicationId: Scalars['ID']['input'];
  input: ApplicationReferenceAddInput;
  referenceId: Scalars['ID']['input'];
};


export type MutationApplicationReferenceRemoveArgs = {
  applicationId: Scalars['ID']['input'];
  referenceId: Scalars['ID']['input'];
};


export type MutationApplicationReferencesRequestArgs = {
  id: Scalars['ID']['input'];
  input: RequestReferencesInput;
};


export type MutationApplicationReferenceUpdateResultsArgs = {
  applicationId: Scalars['ID']['input'];
  input: ReferenceResultsInput;
  referenceId: Scalars['ID']['input'];
};


export type MutationApplicationsHireArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationApplicationsSetStageArgs = {
  ids: Array<Scalars['ID']['input']>;
  input: ApplicationsSetStageInput;
};


export type MutationApplicationUnhireArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveRequisitionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAssessmentSuggestionsGenerateArgs = {
  input: AssessmentSuggestionsGenerateInput;
  interviewId: Scalars['ID']['input'];
};


export type MutationAssessmentSuggestionsRegenerateArgs = {
  input: AssessmentSuggestionsGenerateInput;
  interviewId: Scalars['ID']['input'];
};


export type MutationAssignGroupRoleArgs = {
  input?: InputMaybe<GroupUserRoleInput>;
};


export type MutationBankQuestionCreateArgs = {
  input: BankQuestionCreateInput;
};


export type MutationBankQuestionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBankQuestionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: BankQuestionUpdateInput;
};


export type MutationBusinessProfileUpdateArgs = {
  input: BusinessProfileUpdateInput;
};


export type MutationCloseRequisitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmUserEmailUpdateArgs = {
  input: ConfirmUserEmailUpdateMutationInput;
};


export type MutationCreateAuthClientArgs = {
  input: CreateAuthClientInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateJobFromRequisitionArgs = {
  id: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateRequisitionArgs = {
  input: RequisitionInput;
};


export type MutationCreateSsoConnectionArgs = {
  input: SsoConnectionInput;
};


export type MutationCreateStandaloneCvArgs = {
  input: StandaloneCvCreateInput;
};


export type MutationCreateUploadRequestArgs = {
  input: CreateUploadRequestInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCultureReportDeleteArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationCultureReportGenerateArgs = {
  campaignId: Scalars['ID']['input'];
  input?: InputMaybe<CultureReportGenerateInput>;
};


export type MutationDeactivateUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeclineRequisitionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteAuthClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganisationTagArgs = {
  input?: InputMaybe<DeleteOrganisationTagInput>;
};


export type MutationDeleteRequisitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditGroupArgs = {
  input: EditGroupInput;
};


export type MutationExpireShareLinkArgs = {
  sk?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetInsightsArgs = {
  input?: InputMaybe<PersonalityInsightsInput>;
};


export type MutationGrantProductAccessArgs = {
  input: GrantProductAccessInput;
  userId: Scalars['ID']['input'];
};


export type MutationGroupAssignUserArgs = {
  input?: InputMaybe<GroupAssignUserInput>;
};


export type MutationGroupCreateArgs = {
  input?: InputMaybe<GroupCreateInput>;
};


export type MutationGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGroupEditArgs = {
  input?: InputMaybe<GroupEditInput>;
};


export type MutationGroupUnassignUserArgs = {
  input?: InputMaybe<GroupAssignUserInput>;
};


export type MutationInterviewGuideArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInterviewGuideAssignArgs = {
  guideId: Scalars['ID']['input'];
  interviewId: Scalars['ID']['input'];
};


export type MutationInterviewGuideCreateArgs = {
  input: InterviewGuideCreateInput;
};


export type MutationInterviewGuideDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInterviewGuideDuplicateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInterviewGuideGenerateAiArgs = {
  input: AiGuideGenerationInput;
};


export type MutationInterviewGuideGenerateDraftArgs = {
  input: GenerateDraftInput;
};


export type MutationInterviewGuideGenerateQuestionArgs = {
  guideId: Scalars['ID']['input'];
  input: AiQuestionGenerationInput;
};


export type MutationInterviewGuideGenerateQuestionsArgs = {
  guideId: Scalars['ID']['input'];
  input: AiQuestionsGenerationInput;
};


export type MutationInterviewGuideGenerateQuestionsPreviewArgs = {
  guideId: Scalars['ID']['input'];
  input: AiQuestionsGenerationInput;
};


export type MutationInterviewGuideModifyQuestionArgs = {
  guideId: Scalars['ID']['input'];
  input: AiQuestionModificationInput;
  questionId: Scalars['ID']['input'];
};


export type MutationInterviewGuideQuestionAddArgs = {
  guideId: Scalars['ID']['input'];
  input: GuideQuestionInput;
};


export type MutationInterviewGuideQuestionLockArgs = {
  guideId: Scalars['ID']['input'];
  locked: Scalars['Boolean']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationInterviewGuideQuestionRemoveArgs = {
  guideId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationInterviewGuideQuestionSaveToBankArgs = {
  guideId: Scalars['ID']['input'];
  input?: InputMaybe<SaveToBankInput>;
  questionId: Scalars['ID']['input'];
};


export type MutationInterviewGuideQuestionsReorderArgs = {
  guideId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};


export type MutationInterviewGuideQuestionUpdateArgs = {
  guideId: Scalars['ID']['input'];
  input: GuideQuestionUpdateInput;
  questionId: Scalars['ID']['input'];
};


export type MutationInterviewGuideRecreateArgs = {
  input: InterviewGuideRecreateInput;
};


export type MutationInterviewGuideRefineQuestionArgs = {
  input: RefineQuestionInput;
};


export type MutationInterviewGuideRemoveArgs = {
  interviewId: Scalars['ID']['input'];
};


export type MutationInterviewGuideRemoveInputRequestArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationInterviewGuideRequestInputArgs = {
  id: Scalars['ID']['input'];
  input: RequestInputInput;
};


export type MutationInterviewGuideRestoreArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInterviewGuideSaveArgs = {
  id: Scalars['ID']['input'];
  input: InterviewGuideSaveInput;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInterviewGuideUpdateArgs = {
  id: Scalars['ID']['input'];
  input: InterviewGuideUpdateInput;
};


export type MutationListingMatchmakingMarkPendingArgs = {
  listingId: Scalars['ID']['input'];
};


export type MutationListingScoreWeightsUpdateArgs = {
  input: ListingScoreWeightsUpdateInput;
  listingId: Scalars['ID']['input'];
};


export type MutationMessageTemplateCreateArgs = {
  input: MessageTemplateCreateInput;
};


export type MutationMessageTemplateDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMessageTemplateUpdateArgs = {
  input?: InputMaybe<MessageTemplateUpdateInput>;
};


export type MutationOfferApprovalAddApproverArgs = {
  applicationId: Scalars['ID']['input'];
  approvalTypes: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationOfferApprovalApproveArgs = {
  applicationId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOfferApprovalConfigSetCandidateSectionArgs = {
  section: OfferCandidateSection;
  visible: Scalars['Boolean']['input'];
};


export type MutationOfferApprovalConfigSetEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationOfferApprovalDeclineArgs = {
  applicationId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
};


export type MutationOfferApprovalRemoveApproverArgs = {
  applicationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationOfferApprovalResubmitArgs = {
  amendmentsSummary?: InputMaybe<Scalars['String']['input']>;
  applicationId: Scalars['ID']['input'];
  input: OfferApprovalSubmitInput;
};


export type MutationOfferApprovalStartArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationOfferApprovalSubmitArgs = {
  applicationId: Scalars['ID']['input'];
  input: OfferApprovalSubmitInput;
};


export type MutationOfferApprovalTypeAddArgs = {
  label: Scalars['String']['input'];
};


export type MutationOfferApprovalTypeRemoveArgs = {
  label: Scalars['String']['input'];
};


export type MutationOfferApprovalWithdrawArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationOfferApproverAddArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationOfferApproverRemoveArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationOfferDocumentAddFromPackageArgs = {
  applicationId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};


export type MutationOfferDocumentAddFromTemplateArgs = {
  applicationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationOfferDocumentAddFromUploadArgs = {
  applicationId: Scalars['ID']['input'];
  input: OfferDocumentUploadInput;
};


export type MutationOfferDocumentAddToRepositoryArgs = {
  applicationId: Scalars['ID']['input'];
  input: OfferDocumentUploadInput;
};


export type MutationOfferDocumentMarkSentArgs = {
  applicationId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationOfferDocumentPackageCreateArgs = {
  input: OfferDocumentPackageInput;
};


export type MutationOfferDocumentPackageRemoveArgs = {
  packageId: Scalars['ID']['input'];
};


export type MutationOfferDocumentPackageUpdateArgs = {
  input: OfferDocumentPackageInput;
  packageId: Scalars['ID']['input'];
};


export type MutationOfferDocumentRemoveArgs = {
  applicationId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
};


export type MutationOfferDocumentTemplateCreateArgs = {
  input: OfferDocumentTemplateCreateInput;
};


export type MutationOfferDocumentTemplateRemoveArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationOfferDocumentTypeCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationOfferDocumentTypeRemoveArgs = {
  documentTypeId: Scalars['ID']['input'];
};


export type MutationOfferSaveDetailsArgs = {
  applicationId: Scalars['ID']['input'];
  input: OfferDetailsInput;
};


export type MutationOfferStartArgs = {
  applicationId: Scalars['ID']['input'];
  input?: InputMaybe<OfferDetailsInput>;
};


export type MutationOrganisationReferenceQuestionCreateArgs = {
  input: OrganisationReferenceQuestionCreateInput;
};


export type MutationOrganisationReferenceQuestionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationReferenceQuestionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: OrganisationReferenceQuestionUpdateInput;
};


export type MutationOrganisationTagActivitySetArgs = {
  input: OrganisationTagActivityInput;
};


export type MutationOrganisationTagCreateArgs = {
  input: OrganisationTagCreateInput;
};


export type MutationPersonalityAssessmentInviteMembersArgs = {
  input: PersonalityAssessmentInviteMembersInput;
};


export type MutationPersonalityAssessmentSaveAnswersArgs = {
  input: PersonalityAssessmentAnswersInput;
};


export type MutationReferenceEditArgs = {
  applicationId: Scalars['ID']['input'];
  input: SubmitReferenceInput;
  referenceId: Scalars['ID']['input'];
};


export type MutationReferenceSubmitArgs = {
  applicationId: Scalars['ID']['input'];
  input: SubmitReferenceInput;
  referenceId: Scalars['ID']['input'];
};


export type MutationRemoveApproverFromRequisitionArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveGroupMembersArgs = {
  input: RemoveGroupMembersInput;
};


export type MutationRemoveRequisitionApprovalTypeArgs = {
  label: Scalars['String']['input'];
};


export type MutationRemoveRequisitionApproverArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRemoveSsoConnectionArgs = {
  id: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationRemoveStandaloneCvArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReopenRequisitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendUserEmailUpdateCodeArgs = {
  input: ResendUserEmailUpdateCodeMutationInput;
};


export type MutationResubmitRequisitionArgs = {
  amendmentsSummary: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  input?: InputMaybe<RequisitionInput>;
};


export type MutationRevokeProductAccessArgs = {
  input: RevokeProductAccessInput;
  userId: Scalars['ID']['input'];
};


export type MutationSaveComponoAssistReactionArgs = {
  input: SaveComponoAssistReactionInput;
};


export type MutationSaveRequisitionDraftArgs = {
  id: Scalars['ID']['input'];
  input: RequisitionInput;
};


export type MutationScorecardEnsureArgs = {
  interviewId: Scalars['ID']['input'];
};


export type MutationScorecardQuestionAddArgs = {
  input: ScorecardQuestionAddInput;
  interviewId: Scalars['ID']['input'];
};


export type MutationScorecardQuestionRemoveArgs = {
  interviewId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationScorecardSaveArgs = {
  input: ScorecardSaveInput;
  interviewId: Scalars['ID']['input'];
};


export type MutationScorecardSubmitArgs = {
  input: ScorecardSubmitInput;
  interviewId: Scalars['ID']['input'];
};


export type MutationSetRequisitionApproversArgs = {
  approvers: Array<ApproverInput>;
  id: Scalars['ID']['input'];
};


export type MutationSetRequisitionArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetRequisitionWorkflowEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationShareCultureReportArgs = {
  input: SharePageInput;
};


export type MutationSubmitRequisitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSystemTagActivitySetArgs = {
  input: SystemTagActivityInput;
};


export type MutationTranscriptDeleteArgs = {
  interviewId: Scalars['ID']['input'];
};


export type MutationTranscriptExtractTextArgs = {
  interviewId: Scalars['ID']['input'];
};


export type MutationTranscriptGenerateAiScoreArgs = {
  interviewId: Scalars['ID']['input'];
};


export type MutationTranscriptGenerateSummaryArgs = {
  interviewId: Scalars['ID']['input'];
};


export type MutationTranscriptUploadArgs = {
  input: TranscriptUploadInput;
  interviewId: Scalars['ID']['input'];
};


export type MutationUpdateApprovedRequisitionArgs = {
  id: Scalars['ID']['input'];
  input: RequisitionInput;
};


export type MutationUpdateAuthClientArgs = {
  input: UpdateAuthClientInput;
};


export type MutationUpdateListingScoreWeightsArgs = {
  input: UpdateListingScoreWeightsInput;
};


export type MutationUpdateProductAccessArgs = {
  input: UpdateProductAccessInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateSsoConnectionArgs = {
  input: SsoConnectionInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationValidateSkillQualificationMatchesArgs = {
  input: MatchValidationRequestInput;
};


export type MutationWithdrawRequisitionArgs = {
  id: Scalars['ID']['input'];
};

export type ApproverInput = {
  /** The approval-type labels this approver is responsible for. */
  approvalTypes: Array<Scalars['String']['input']>;
  /** The approver user id. */
  userId: Scalars['ID']['input'];
};

export type AddGroupMembersInput = {
  groupId: Scalars['ID']['input'];
  members: Array<AddGroupMemberInput>;
};

export type AddGroupMemberInput = {
  id: Scalars['ID']['input'];
  role?: InputMaybe<PublicGroupRole>;
};

export enum PublicGroupRole {
  Facilitator = 'facilitator',
  Learner = 'learner',
  Manager = 'manager'
}

export type AddGroupMembersPayload = {
  __typename?: 'AddGroupMembersPayload';
  failCount: Scalars['Int']['output'];
  failed: Array<Scalars['ID']['output']>;
  missing: Array<Scalars['ID']['output']>;
  status: GroupMemberOperationStatus;
};

export enum GroupMemberOperationStatus {
  Fail = 'fail',
  Partial = 'partial',
  Success = 'success'
}

/** Result payload for a single-applicant mutation. */
export type ApplicantMutationResult = {
  __typename?: 'ApplicantMutationResult';
  /** The updated applicant, or null if the mutation failed. */
  applicant?: Maybe<Applicant>;
  /** Business-level errors. Empty on success. */
  errors: Array<ApplicantMutationError>;
};

/** A structured error returned from an applicant mutation. */
export type ApplicantMutationError = {
  __typename?: 'ApplicantMutationError';
  /** Machine-readable error code. */
  code: ApplicantMutationErrorCode;
  /**
   * The applicant ID this error is about, echoed back from the request. On a bulk
   * mutation this is the only way to tell which of the submitted IDs failed.
   */
  id: Scalars['ID']['output'];
  /** Human-readable description of the error. */
  message: Scalars['String']['output'];
};

/** Machine-readable error codes for applicant mutations. */
export enum ApplicantMutationErrorCode {
  /** No applicant exists with the given ID. */
  ApplicantNotFound = 'APPLICANT_NOT_FOUND',
  /** The mutation could not be applied for this applicant. Only a bulk mutation reports this: a single-applicant mutation surfaces the same failure as a transport error, since it has no partial result to preserve. */
  ApplicantUpdateFailed = 'APPLICANT_UPDATE_FAILED',
  /** The mutation succeeded but the applicant index has not yet caught up, so the refreshed applicant could not be returned. */
  ApplicantUpdatePending = 'APPLICANT_UPDATE_PENDING',
  /** The requested state transition is not valid for this applicant. */
  InvalidStateTransition = 'INVALID_STATE_TRANSITION',
  /** The current user is not authorised to perform this action. */
  Unauthorised = 'UNAUTHORISED'
}

/** Result payload for a bulk-applicant mutation. */
export type ApplicantsMutationResult = {
  __typename?: 'ApplicantsMutationResult';
  /** The updated applicants. Empty if the mutation failed for all items. */
  applicants: Array<Applicant>;
  /** Business-level errors. Empty on success. */
  errors: Array<ApplicantMutationError>;
};

/** The result payload returned by single-application mutations. */
export type ApplicationMutationResult = {
  __typename?: 'ApplicationMutationResult';
  /** The updated application. Null if the mutation failed. */
  application?: Maybe<Application>;
  /** Business-level errors. Empty on success. */
  errors: Array<ApplicationMutationError>;
};

/** A user-facing error returned from an application mutation. */
export type ApplicationMutationError = {
  __typename?: 'ApplicationMutationError';
  /** A machine-readable code identifying the error type. Always present. */
  code: ApplicationMutationErrorCode;
  /** A human-readable description of the error. */
  message: Scalars['String']['output'];
};

/** Machine-readable codes for errors returned by application mutations. */
export enum ApplicationMutationErrorCode {
  /** The candidate has already been hired for this listing. */
  ApplicationAlreadyHired = 'APPLICATION_ALREADY_HIRED',
  /** The application belongs to another organisation. */
  ApplicationForbidden = 'APPLICATION_FORBIDDEN',
  /** No application exists with the given ID. */
  ApplicationNotFound = 'APPLICATION_NOT_FOUND',
  /** The application has not been submitted and cannot be acted on. */
  ApplicationNotSubmitted = 'APPLICATION_NOT_SUBMITTED',
  /** The application is not available for this action, e.g. already hired for a different listing. */
  ApplicationUnavailable = 'APPLICATION_UNAVAILABLE',
  /** The listing is closed and cannot accept further actions. */
  ListingClosed = 'LISTING_CLOSED',
  /** An unexpected error occurred. */
  UnknownError = 'UNKNOWN_ERROR'
}

/** The result payload returned by batch application mutations. */
export type BatchApplicationMutationResult = {
  __typename?: 'BatchApplicationMutationResult';
  /** The updated applications. Empty if the mutation failed for all items. */
  applications: Array<Application>;
  /** Business-level errors, including per-application failures. Empty on full success. */
  errors: Array<ApplicationMutationError>;
};

/** Input for manually adding a reference to an application. */
export type ApplicationReferenceAddInput = {
  /** The company where the referee and candidate worked together. */
  company: Scalars['String']['input'];
  /** The referee's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The full name of the referee. */
  name: Scalars['String']['input'];
  /** The referee's phone number. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The professional relationship between the referee and the candidate. */
  relationship: ReferenceRelationship;
  /** Optional results if the reference has already been completed. */
  results?: InputMaybe<ReferenceResultsInput>;
};

/** Input for recording reference check results. */
export type ReferenceResultsInput = {
  /** Any additional notes provided about the candidate. */
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  /** The date the referee was contacted. */
  dateContacted: Scalars['DateTime']['input'];
  /** Responses to the guide questions. */
  guideResponses?: InputMaybe<Array<GuideResponseInput>>;
  /** The referee's overall rating of the candidate. */
  overallRating: OverallRating;
  /** Whether the referee would rehire or work with the candidate again. */
  wouldRehire: WouldRehire;
};

/** Input for a single guide question response. */
export type GuideResponseInput = {
  /** The ID of the guide question being answered. */
  questionId: Scalars['ID']['input'];
  /** The referee's response to this question. */
  response?: InputMaybe<Scalars['String']['input']>;
};

/** The result payload returned by reference mutations. */
export type ReferenceMutationResult = {
  __typename?: 'ReferenceMutationResult';
  /** The parent application. Null if the mutation failed. */
  application?: Maybe<Application>;
  /** Business-level errors. Empty on success. */
  errors: Array<ReferenceMutationError>;
};

/** A user-facing error returned from a reference mutation. */
export type ReferenceMutationError = {
  __typename?: 'ReferenceMutationError';
  /** A machine-readable code identifying the error type. */
  code: ReferenceMutationErrorCode;
  /** A human-readable description of the error. */
  message: Scalars['String']['output'];
};

/** Machine-readable codes for errors returned by reference mutations. */
export enum ReferenceMutationErrorCode {
  /** No application exists with the given ID. */
  ApplicationNotFound = 'APPLICATION_NOT_FOUND',
  /** The deadline for this reference request has passed. */
  DeadlinePassed = 'DEADLINE_PASSED',
  /** The reference source does not allow this operation. */
  InvalidSource = 'INVALID_SOURCE',
  /** The requested status transition is not valid for the current reference status. */
  InvalidStatusTransition = 'INVALID_STATUS_TRANSITION',
  /** No reference exists with the given ID. */
  ReferenceNotFound = 'REFERENCE_NOT_FOUND',
  /** The current user is not authorised to perform this action. */
  Unauthorised = 'UNAUTHORISED',
  /** An unexpected error occurred. */
  UnknownError = 'UNKNOWN_ERROR',
  /** One or more input fields failed validation. */
  ValidationError = 'VALIDATION_ERROR'
}

/** Input for requesting references from a candidate. */
export type RequestReferencesInput = {
  /** The deadline by which references must be submitted. */
  deadline: Scalars['DateTime']['input'];
  /** The body of the notification email sent to the candidate. */
  messageBody: Scalars['String']['input'];
  /** The subject line of the notification email sent to the candidate. */
  messageSubject: Scalars['String']['input'];
  /** The number of references required from the candidate. */
  requiredCount: Scalars['Int']['input'];
};

/** Input for moving a batch of applications to a new pipeline stage. */
export type ApplicationsSetStageInput = {
  /** The ID of the stage to move the applications to. Use 'unreviewed' to clear the stage. */
  stageId: Scalars['ID']['input'];
};

/** Input for assessmentSuggestionsGenerate / assessmentSuggestionsRegenerate. */
export type AssessmentSuggestionsGenerateInput = {
  /** The qualifying gaps to generate one question each for, in display order. */
  gaps: Array<AssessmentGapInput>;
  /** Optional response-format framework (from the assigned guide) to shape phrasing. */
  responseFormat?: InputMaybe<ResponseFormat>;
};

/**
 * One qualifying assessment gap, computed + filtered by the caller. The AI turns
 * each into a single calibrated question; it does not recompute any of this.
 */
export type AssessmentGapInput = {
  /** Which assessment this gap is from. */
  assessment: AssessmentType;
  /** Role benchmark 1-5 score (null for a work-personality type mismatch). */
  benchmarkScore?: InputMaybe<Scalars['Float']['input']>;
  /** Candidate's 1-5 score (null for a work-personality type mismatch). */
  candidateScore?: InputMaybe<Scalars['Float']['input']>;
  /** Work Personality only: the candidate's dominant work-style type. */
  candidateType?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable dimension label, e.g. Innovative to Risk Averse. */
  dimension: Scalars['String']['input'];
  /** Signed gap (candidate − benchmark). Null for a work-personality type mismatch. */
  gap?: InputMaybe<Scalars['Float']['input']>;
  /** Plain-language description of what the gap means, for the AI to calibrate to. */
  gapDirection: Scalars['String']['input'];
  /** Opaque id assigned by the caller; echoed on the generated question for matching. */
  id: Scalars['ID']['input'];
  /** Culture Fit only: left bipolar pole label. */
  leftLabel?: InputMaybe<Scalars['String']['input']>;
  /** Gap priority. */
  priority: AssessmentGapPriority;
  /** Work Personality only: the role's required work-style type. */
  requiredType?: InputMaybe<Scalars['String']['input']>;
  /** Culture Fit only: right bipolar pole label. */
  rightLabel?: InputMaybe<Scalars['String']['input']>;
};

export type GroupUserRoleInput = {
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  memberType?: InputMaybe<MemberType>;
  role?: InputMaybe<GroupRole>;
};

export type GroupMemberResponse = {
  __typename?: 'GroupMemberResponse';
  errors?: Maybe<Array<Maybe<GroupMemberMutationError>>>;
  groupMember?: Maybe<GroupMember>;
};

export type GroupMemberMutationError = {
  __typename?: 'GroupMemberMutationError';
  code?: Maybe<GroupMemberMutationErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum GroupMemberMutationErrorCode {
  DuplicateGroupMember = 'DUPLICATE_GROUP_MEMBER',
  GroupMemberNotFound = 'GROUP_MEMBER_NOT_FOUND'
}

/** Input for creating a bank question. */
export type BankQuestionCreateInput = {
  /** Division/department to categorise the question under. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** Job title to categorise the question under. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The competency topic this question assesses. */
  kssartiTopic?: InputMaybe<KssartiTopic>;
  /** The 1-5 scoring rubric for the question. */
  scoringGuide: ScoringGuideInput;
  /** The question text. */
  text: Scalars['String']['input'];
};

/** A 1-5 scoring rubric: what a response at each level looks like. */
export type ScoringGuideInput = {
  /** What a level-1 (poor) response looks like. */
  level1: Scalars['String']['input'];
  /** What a level-2 response looks like. */
  level2: Scalars['String']['input'];
  /** What a level-3 response looks like. */
  level3: Scalars['String']['input'];
  /** What a level-4 response looks like. */
  level4: Scalars['String']['input'];
  /** What a level-5 (excellent) response looks like. */
  level5: Scalars['String']['input'];
};

/** Result payload for bank-question mutations. */
export type BankQuestionMutationResult = {
  __typename?: 'BankQuestionMutationResult';
  /** The affected bank question. Null when the mutation failed. */
  bankQuestion?: Maybe<BankQuestion>;
  /** Business errors. Empty on success. */
  errors: Array<BankQuestionMutationError>;
};

/** A business-level error from a bank-question mutation. */
export type BankQuestionMutationError = {
  __typename?: 'BankQuestionMutationError';
  /** Machine-readable error code. */
  code: BankQuestionMutationErrorCode;
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Error codes for bank-question mutations. */
export enum BankQuestionMutationErrorCode {
  /** No bank question exists with the given ID. */
  NotFound = 'NOT_FOUND',
  /** The caller is not permitted to perform this action. */
  Unauthorised = 'UNAUTHORISED',
  /** The input failed validation. */
  ValidationFailed = 'VALIDATION_FAILED'
}

/** Input for updating a bank question. Omitted fields are left unchanged. */
export type BankQuestionUpdateInput = {
  /** New division/department categorisation. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** New job-title categorisation. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** New competency topic. */
  kssartiTopic?: InputMaybe<KssartiTopic>;
  /** New 1-5 scoring rubric. */
  scoringGuide?: InputMaybe<ScoringGuideInput>;
  /** New question text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Changes to the caller's business profile. Every field is optional: a section that is
 * supplied replaces that section in full, and a section that is left out is untouched.
 */
export type BusinessProfileUpdateInput = {
  /** The organisation's priorities, most important first. At most three. */
  goals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** What the organisation does, how big it is and where it operates. */
  identity?: InputMaybe<BusinessProfileIdentityInput>;
  /** The identifier of the user who leads the organisation. */
  leaderId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The identifiers of the rest of the leadership team, not including the leader. At most
   * twelve, and none of them the leader.
   */
  leadershipTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The stage the organisation is in. */
  lifecycleStage?: InputMaybe<LifecycleStage>;
  /** The organisation's own description of its stage. Required when stage is OTHER. */
  lifecycleStageOther?: InputMaybe<Scalars['String']['input']>;
  /** Why the organisation exists and what it is working towards. */
  purpose?: InputMaybe<BusinessProfilePurposeInput>;
  /** How the organisation's leadership is arranged. */
  structure?: InputMaybe<BusinessProfileStructureInput>;
};

/**
 * What the organisation does, how big it is and where it operates. Supplying this section
 * replaces it in full; any field left out is cleared.
 */
export type BusinessProfileIdentityInput = {
  /** The founding year, or how long the organisation has been operating. */
  founded?: InputMaybe<Scalars['String']['input']>;
  /** The business type and industry. */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Head office and other locations. */
  locations?: InputMaybe<Scalars['String']['input']>;
  /** The geographic spread of operations. */
  reach?: InputMaybe<BusinessReach>;
  /** Headcount and revenue band. */
  scale?: InputMaybe<Scalars['String']['input']>;
  /** Whether people work onsite, hybrid or remote. */
  workModel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Why the organisation exists and what it is working towards. Supplying this section
 * replaces it in full; any field left out is cleared.
 */
export type BusinessProfilePurposeInput = {
  /** Why the organisation exists today. */
  mission?: InputMaybe<Scalars['String']['input']>;
  /** The values the organisation holds. */
  values?: InputMaybe<Array<BusinessValueInput>>;
  /** Where the organisation is trying to get to. */
  vision?: InputMaybe<Scalars['String']['input']>;
};

/** A value the organisation holds, and what it means in practice. */
export type BusinessValueInput = {
  /** What living this value looks like day to day. */
  meaning?: InputMaybe<Scalars['String']['input']>;
  /** The name of the value. */
  name: Scalars['String']['input'];
};

/**
 * How the organisation's leadership is arranged. Supplying this section replaces it in
 * full; any field left out is cleared.
 */
export type BusinessProfileStructureInput = {
  /** Reporting lines, direct reports and team leads. */
  shape?: InputMaybe<Scalars['String']['input']>;
};

/** The result of a business profile mutation. */
export type BusinessProfileMutationResult = {
  __typename?: 'BusinessProfileMutationResult';
  /** The profile after the mutation. Null when the mutation failed. */
  businessProfile?: Maybe<BusinessProfile>;
  /** Any errors that occurred during the mutation. Empty on success. */
  errors: Array<BusinessProfileMutationError>;
};

/** An error that occurred during a business profile mutation. */
export type BusinessProfileMutationError = {
  __typename?: 'BusinessProfileMutationError';
  /** A machine-readable error code. */
  code: BusinessProfileMutationErrorCode;
  /** The input field the error relates to, where one field is at fault. */
  field?: Maybe<Scalars['String']['output']>;
  /** A human-readable error message. */
  message: Scalars['String']['output'];
};

/** Why a business profile mutation failed. */
export enum BusinessProfileMutationErrorCode {
  /** Someone named on the leadership is not a user of this organisation. */
  LeaderNotFound = 'LEADER_NOT_FOUND',
  /** The user is not authorised to perform this action. */
  Unauthorised = 'UNAUTHORISED',
  /** An unexpected error occurred. */
  UnknownError = 'UNKNOWN_ERROR',
  /** The input failed validation. */
  ValidationError = 'VALIDATION_ERROR'
}

export type ConfirmUserEmailUpdateMutationInput = {
  code: Scalars['String']['input'];
  userPool?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAuthClientInput = {
  /** Auth Client name shown in Auth Clients Management when creating a new client. */
  clientName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  scopeIds: Array<Scalars['String']['input']>;
};

export type CreateAuthClientPayload = {
  __typename?: 'CreateAuthClientPayload';
  client: AuthClient;
  clientSecret: Scalars['String']['output'];
};

export type CreateGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type PublicGroupMutationPayload = {
  __typename?: 'PublicGroupMutationPayload';
  group?: Maybe<PublicGroupDetail>;
};

/** Writable fields for creating or saving a requisition draft. */
export type RequisitionInput = {
  /** How the approvers are asked. May only change while the requisition is a Draft. */
  approvalMode?: InputMaybe<ApprovalMode>;
  approvers?: InputMaybe<Array<ApproverInput>>;
  compensation?: InputMaybe<CompensationInput>;
  headcount?: InputMaybe<HeadcountInput>;
  jobDetails?: InputMaybe<JobDetailsInput>;
  positionDescription?: InputMaybe<RequisitionFileInput>;
  recruitmentStrategy?: InputMaybe<RecruitmentStrategyInput>;
  supportingDocuments?: InputMaybe<Array<RequisitionFileInput>>;
  supportingNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CompensationInput = {
  baseSalaryMax: Scalars['Int']['input'];
  baseSalaryMin: Scalars['Int']['input'];
  benefits?: InputMaybe<Scalars['String']['input']>;
  bonuses?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  otherCompensation?: InputMaybe<Scalars['String']['input']>;
  paymentSchedule?: InputMaybe<Scalars['String']['input']>;
  salaryConditions?: InputMaybe<Scalars['String']['input']>;
  salaryPeriod: Scalars['String']['input'];
  superannuation?: InputMaybe<Scalars['String']['input']>;
};

export type HeadcountInput = {
  budgetNotes?: InputMaybe<Scalars['String']['input']>;
  fte: Scalars['Int']['input'];
  positionNumber?: InputMaybe<Scalars['String']['input']>;
  replacingWho?: InputMaybe<Scalars['String']['input']>;
  requestType: RequestType;
  unplannedReason?: InputMaybe<Scalars['String']['input']>;
};

export type JobDetailsInput = {
  costCentre?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employmentType: Scalars['String']['input'];
  hiringTeamId?: InputMaybe<Scalars['ID']['input']>;
  hiringTeamName?: InputMaybe<Scalars['String']['input']>;
  idealStartDate?: InputMaybe<Scalars['String']['input']>;
  jobTitle: Scalars['String']['input'];
  jobTitleId?: InputMaybe<Scalars['ID']['input']>;
  reportingManager?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
  workSetting?: InputMaybe<Scalars['String']['input']>;
};

export type RequisitionFileInput = {
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeBytes?: InputMaybe<Scalars['Int']['input']>;
};

export type RecruitmentStrategyInput = {
  estimatedCost?: InputMaybe<Scalars['Int']['input']>;
  strategy?: InputMaybe<Scalars['String']['input']>;
};

export type SsoConnectionInput = {
  attributeMapping?: InputMaybe<Scalars['JSON']['input']>;
  autoSignup?: InputMaybe<Scalars['Boolean']['input']>;
  callbackUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  customParams?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  encryptedResponses?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idpIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  metadataFile?: InputMaybe<Scalars['String']['input']>;
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  replaceLoginPage?: InputMaybe<Scalars['Boolean']['input']>;
  signingCertificate?: InputMaybe<Scalars['String']['input']>;
  type: SsoConnectionType;
};

export enum SsoConnectionType {
  Oidc = 'OIDC',
  Saml = 'SAML'
}

export type StandaloneCvCreateInput = {
  /** The MIME type of the file. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Base64 encoded file content. */
  fileContent?: InputMaybe<Scalars['String']['input']>;
  /** The name of the file. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** The processing options for the file. */
  processing?: InputMaybe<StandaloneCvProcessingInput>;
};

export type StandaloneCvProcessingInput = {
  /** Whether to convert the CV to PDF format. */
  convertToPdf?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to extract structured data from the CV. */
  extractStructuredData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to generate a summary from the CV. */
  generateSummaries?: InputMaybe<Array<StandaloneCvGenerateSummaryInput>>;
};

export type StandaloneCvGenerateSummaryInput = {
  /** The format of the summary. */
  format?: InputMaybe<StandaloneCvSummaryFormat>;
  /** The structure of the summary. */
  structure?: InputMaybe<StandaloneCvSummaryStructure>;
};

export type CreateUploadRequestInput = {
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type CreateUserInput = {
  /** ID of the division the user belongs to. */
  divisionId?: InputMaybe<Scalars['ID']['input']>;
  /** Required. Email address. Must be unique within the platform. */
  email: Scalars['String']['input'];
  /** Required. First name of the user. */
  firstName: Scalars['String']['input'];
  /** ID of the job title assigned to this user. */
  jobTitleId?: InputMaybe<Scalars['ID']['input']>;
  /** Required. Last name of the user. */
  lastName: Scalars['String']['input'];
  /** ID of the organisational location for this user. */
  orgLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** Start date in ISO 8601 format (e.g. 2024-01-15T00:00:00.000Z). */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Context to generate the report with. Optional in full: a report can be generated from the
 * campaign data alone.
 */
export type CultureReportGenerateInput = {
  /** What has changed since the last campaign. */
  whatsChanged?: InputMaybe<CultureReportContextInput>;
};

/**
 * What has changed at the organisation since the last campaign. Read by the report stage,
 * which has no other way of knowing.
 */
export type CultureReportContextInput = {
  /** What has been helping the culture. 600 characters at most, once trimmed. */
  helping?: InputMaybe<Scalars['String']['input']>;
  /** What has been getting in the way. 600 characters at most, once trimmed. */
  hindering?: InputMaybe<Scalars['String']['input']>;
};

/** The result of a culture report mutation. */
export type CultureReportMutationResult = {
  __typename?: 'CultureReportMutationResult';
  /** The report after the mutation. Null when the mutation failed. */
  cultureReport?: Maybe<CultureReport>;
  /** Any errors that occurred during the mutation. Empty on success. */
  errors: Array<CultureReportMutationError>;
};

/** An error that occurred during a culture report mutation. */
export type CultureReportMutationError = {
  __typename?: 'CultureReportMutationError';
  /** A machine-readable error code. */
  code: CultureReportMutationErrorCode;
  /** The input field the error relates to, where one field is at fault. */
  field?: Maybe<Scalars['String']['output']>;
  /** A human-readable error message. */
  message: Scalars['String']['output'];
};

/** Why a culture report mutation failed. */
export enum CultureReportMutationErrorCode {
  /** The campaign is still open. A report can only be generated once responses are in. */
  CampaignNotClosed = 'CAMPAIGN_NOT_CLOSED',
  /** No campaign of that identifier belongs to this organisation. */
  CampaignNotFound = 'CAMPAIGN_NOT_FOUND',
  /** The campaign asked one side of the culture assessment and not the other, so there are no gaps to report. */
  CultureAssessmentIncomplete = 'CULTURE_ASSESSMENT_INCOMPLETE',
  /** A report for this campaign is already being generated. */
  GenerationAlreadyRunning = 'GENERATION_ALREADY_RUNNING',
  /** The user is not authorised to perform this action. */
  Unauthorised = 'UNAUTHORISED',
  /** An unexpected error occurred. */
  UnknownError = 'UNKNOWN_ERROR',
  /** The input failed validation. */
  ValidationError = 'VALIDATION_ERROR'
}

export type DeactivateUserPayload = {
  __typename?: 'DeactivateUserPayload';
  /** The resulting status of the user after deactivation. */
  status: UserStatus;
  /** The ID of the user that was deactivated. */
  userId: Scalars['ID']['output'];
};

export type DeleteOrganisationTagInput = {
  tagId: Scalars['ID']['input'];
};

export type DeleteOrganisationTagMutationResult = {
  __typename?: 'DeleteOrganisationTagMutationResult';
  errors?: Maybe<Array<Maybe<DeleteOrganisationTagMutationError>>>;
  tag?: Maybe<OrganisationTag>;
};

export type DeleteOrganisationTagMutationError = {
  __typename?: 'DeleteOrganisationTagMutationError';
  message?: Maybe<Scalars['String']['output']>;
};

export type EditGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalityInsightsInput = {
  distribution?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalityInsights = {
  __typename?: 'PersonalityInsights';
  distributionType?: Maybe<Scalars['String']['output']>;
  distributionTypeSummary?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  mergedSummaries?: Maybe<Scalars['String']['output']>;
  teamSummary?: Maybe<Scalars['String']['output']>;
};

export type GrantProductAccessInput = {
  /** The app code identifying the product (e.g. "shortlyster", "retayner", "develop"). */
  appCode: Scalars['String']['input'];
  /** The role to assign for this product (e.g. "base", "admin"). */
  role: Scalars['String']['input'];
};

export type GroupAssignUserInput = {
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  memberType?: InputMaybe<MemberType>;
};

export type GroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type GroupResponse = {
  __typename?: 'GroupResponse';
  errors?: Maybe<Array<Maybe<GroupMutationError>>>;
  group?: Maybe<Group>;
};

export type GroupMutationError = {
  __typename?: 'GroupMutationError';
  code?: Maybe<GroupMutationErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum GroupMutationErrorCode {
  DuplicateGroup = 'DUPLICATE_GROUP',
  MaxGroupCharactersReached = 'MAX_GROUP_CHARACTERS_REACHED',
  NotAlphanumericGroup = 'NOT_ALPHANUMERIC_GROUP'
}

export type GroupEditInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Result payload for interview-guide mutations. */
export type InterviewGuideMutationResult = {
  __typename?: 'InterviewGuideMutationResult';
  /** Business errors. Empty on success. */
  errors: Array<InterviewGuideMutationError>;
  /** The affected guide. Null when the mutation failed. */
  interviewGuide?: Maybe<InterviewGuide>;
};

/** A business-level error from an interview-guide mutation. */
export type InterviewGuideMutationError = {
  __typename?: 'InterviewGuideMutationError';
  /** Machine-readable error code. */
  code: InterviewGuideMutationErrorCode;
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Error codes for interview-guide mutations. */
export enum InterviewGuideMutationErrorCode {
  /** The AI generation failed or could not be started; the user can retry. */
  AiGenerationFailed = 'AI_GENERATION_FAILED',
  /** A conflicting record already exists. */
  AlreadyExists = 'ALREADY_EXISTS',
  /** The guide is assigned to an interview and cannot be deleted. */
  GuideInUse = 'GUIDE_IN_USE',
  /** The action is not valid for the guide's current status (e.g. requesting input on a published guide). */
  InvalidStatusTransition = 'INVALID_STATUS_TRANSITION',
  /** No guide exists with the given ID. */
  NotFound = 'NOT_FOUND',
  /** The caller is not permitted to perform this action. */
  Unauthorised = 'UNAUTHORISED',
  /** The input failed validation. */
  ValidationFailed = 'VALIDATION_FAILED'
}

/** Result payload for scorecard mutations. */
export type ScorecardMutationResult = {
  __typename?: 'ScorecardMutationResult';
  /** Business errors. Empty on success. */
  errors: Array<ScorecardMutationError>;
  /** The affected scorecard. Null when the mutation failed (or scorecardEnsure had nothing to provision). */
  scorecard?: Maybe<Scorecard>;
};

/** A business-level error from a scorecard mutation. */
export type ScorecardMutationError = {
  __typename?: 'ScorecardMutationError';
  /** Machine-readable error code. */
  code: ScorecardMutationErrorCode;
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Error codes for scorecard mutations. */
export enum ScorecardMutationErrorCode {
  /** Only published guides can be assigned to interviews. */
  GuideNotPublished = 'GUIDE_NOT_PUBLISHED',
  /** No interview exists with the given ID. */
  InterviewNotFound = 'INTERVIEW_NOT_FOUND',
  /** The scorecard or guide was not found. */
  NotFound = 'NOT_FOUND',
  /** The caller is not permitted to perform this action. */
  Unauthorised = 'UNAUTHORISED',
  /** The input failed validation. */
  ValidationFailed = 'VALIDATION_FAILED'
}

/** Input for creating an interview guide. */
export type InterviewGuideCreateInput = {
  /** Division/department the guide is intended for. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** Whether the pre-interview checklist section is enabled. Defaults to true. */
  includeChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the key-competencies section is enabled. Defaults to true. */
  includeCompetencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Interview purpose tags. */
  interviewPurpose?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Job title the guide is intended for. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Response format questions are framed for. */
  responseFormat?: InputMaybe<ResponseFormat>;
  /** The guide title. */
  title: Scalars['String']['input'];
  /** Guidance on when to use this guide. */
  whenToUse?: InputMaybe<Scalars['String']['input']>;
};

/** Preferences and role context for full AI guide generation. */
export type AiGuideGenerationInput = {
  /** Division/department the role belongs to. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** KSSARTI topics to focus questions on. */
  focusTopics?: InputMaybe<Array<KssartiTopic>>;
  /** Whether the pre-interview checklist section is enabled. Defaults to true. */
  includeChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the key competencies section is enabled. Defaults to true. */
  includeCompetencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include rapport-building questions. */
  includeRapportBuilding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Interview duration in minutes (helps calibrate question count). */
  interviewDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Interview purpose tags carried over from the wizard. */
  interviewPurpose?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Job title for the position. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Number of questions to generate. */
  numberOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  /** Position description or job advertisement text for context. */
  positionDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * Uploaded position-description file, read directly by the AI. Takes
   * precedence over `positionDescription` when both are provided.
   */
  positionDescriptionFile?: InputMaybe<PositionDescriptionFileInput>;
  /** Response format to guide question framing. */
  responseFormat?: InputMaybe<ResponseFormat>;
  /** Title for the generated guide. */
  title: Scalars['String']['input'];
  /** Description of when to use this guide. */
  whenToUse?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Reference to an uploaded position-description file (held in the uploads
 * service's S3 request bucket). When supplied, the file is read directly by the
 * AI instead of using `positionDescription` text.
 */
export type PositionDescriptionFileInput = {
  /** MIME type of the uploaded file. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Short-lived presigned GET URL the AI service uses to fetch the file. */
  downloadUrl: Scalars['String']['input'];
  /** Original file name (used to derive the document format/name). */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** S3 object key (the upload-request id) — kept for traceability. */
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Context for generating a question draft with AI (preview only). */
export type GenerateDraftInput = {
  /** Description of what the question should assess. */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Job title for role-appropriate phrasing. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Response format to frame the generated question for. */
  responseFormat?: InputMaybe<ResponseFormat>;
};

/** A generated question draft (text + scoring guide), not persisted. */
export type GeneratedQuestionResult = {
  __typename?: 'GeneratedQuestionResult';
  /** The generated 1-5 scoring rubric. */
  scoringGuide: ScoringGuide;
  /** The generated question text. */
  text: Scalars['String']['output'];
};

/** Preferences for generating a single question with AI. */
export type AiQuestionGenerationInput = {
  /** Additional context to guide question generation. */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Job title for role-appropriate questions. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Response format to frame the question for. */
  responseFormat?: InputMaybe<ResponseFormat>;
  /** KSSARTI topic for the generated question. */
  topic: KssartiTopic;
};

/**
 * Preferences and position description for appending AI-generated questions to
 * an existing guide.
 */
export type AiQuestionsGenerationInput = {
  /** KSSARTI topics to focus the generated questions on. */
  focusTopics?: InputMaybe<Array<KssartiTopic>>;
  /** Whether to include rapport-building questions. */
  includeRapportBuilding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target number of questions to generate. */
  numberOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  /** Position description text to extract requirements from. */
  positionDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * Uploaded position-description file, read directly by the AI. Takes
   * precedence over `positionDescription` when both are provided.
   */
  positionDescriptionFile?: InputMaybe<PositionDescriptionFileInput>;
  /** Response format to frame the questions for. */
  responseFormat?: InputMaybe<ResponseFormat>;
};

/**
 * An AI-generated question returned by interviewGuideGenerateQuestionsPreview
 * (not persisted; the caller adds it to the editor's local state).
 */
export type GeneratedGuideQuestion = {
  __typename?: 'GeneratedGuideQuestion';
  /** The competency topic the AI assigned, if any. */
  kssartiTopic?: Maybe<KssartiTopic>;
  /** The generated 1-5 scoring rubric. */
  scoringGuide: ScoringGuide;
  /** The generated question text. */
  text: Scalars['String']['output'];
};

/** A natural-language modification to apply to a question with AI. */
export type AiQuestionModificationInput = {
  /**
   * Natural language instruction for how to modify the question.
   * e.g. "Make more concise", "Add STAR focus", "Make more formal"
   */
  modification: Scalars['String']['input'];
  /** Response format to apply to the modified question. */
  responseFormat?: InputMaybe<ResponseFormat>;
};

/** A question to add to a guide. */
export type GuideQuestionInput = {
  /** The bank question this was added from, if any. */
  bankQuestionId?: InputMaybe<Scalars['ID']['input']>;
  /** The competency topic this question assesses. */
  kssartiTopic?: InputMaybe<KssartiTopic>;
  /** The 1-5 scoring rubric. */
  scoringGuide: ScoringGuideInput;
  /** The question text. */
  text: Scalars['String']['input'];
};

/** Optional categorisation when saving a guide question to the bank. */
export type SaveToBankInput = {
  /** Division/department for the bank copy. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** Job title for the bank copy. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The competency topic for the bank copy. */
  kssartiTopic?: InputMaybe<KssartiTopic>;
};

/** Fields to update on a guide question. Omitted fields are left unchanged. */
export type GuideQuestionUpdateInput = {
  /** New competency topic. */
  kssartiTopic?: InputMaybe<KssartiTopic>;
  /** New 1-5 scoring rubric. */
  scoringGuide?: InputMaybe<ScoringGuideInput>;
  /** New question text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The uploaded guide document to transcribe into a new guide. */
export type InterviewGuideRecreateInput = {
  /**
   * The uploaded document. Read directly by the AI, which takes the guide's
   * title, questions, competencies and checklist from it.
   */
  file: PositionDescriptionFileInput;
};

/** A question refinement request (preview only — nothing is persisted). */
export type RefineQuestionInput = {
  /** Natural-language refinement instruction (e.g. "More formal", "Fix grammar"). */
  modification: Scalars['String']['input'];
  /** The current question text to refine. */
  questionText: Scalars['String']['input'];
  /** Response format to frame the refined question for. */
  responseFormat?: InputMaybe<ResponseFormat>;
};

/** Preview result of an AI refinement (not persisted). */
export type RefineQuestionResult = {
  __typename?: 'RefineQuestionResult';
  /**
   * The scoring rubric for the refined question. Returned on every refinement,
   * so the caller decides whether the modification warrants applying it.
   */
  scoringGuide: ScoringGuide;
  /** The refined question text. */
  text: Scalars['String']['output'];
};

/**
 * Ids of the org Hire users selected to provide input on a guide, plus an
 * optional message. The ids are stored on the guide as `inputRequestedFrom`;
 * the notifications service resolves each reviewer's email/name when sending.
 */
export type RequestInputInput = {
  /** Optional message included in the notification email. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The user IDs of the selected reviewers. */
  userIds: Array<Scalars['ID']['input']>;
};

/**
 * Full desired state of a guide's editable content for interviewGuideSave.
 * Children are reconciled to exactly match the arrays (id present = update, id
 * absent = create, existing-but-absent = delete); array order sets display order.
 */
export type InterviewGuideSaveInput = {
  /** The complete set of checklist items, in display order. */
  checklist: Array<GuideChecklistSaveInput>;
  /** The complete set of competencies, in display order. */
  competencies: Array<GuideCompetencySaveInput>;
  /** Division/department the guide is intended for. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** Whether the pre-interview checklist section is enabled. */
  includeChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the key-competencies section is enabled. */
  includeCompetencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Interview purpose tags. */
  interviewPurpose?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Job title the guide is intended for. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The complete set of questions, in display order. */
  questions: Array<GuideQuestionSaveInput>;
  /** Response format questions are framed for. */
  responseFormat?: InputMaybe<ResponseFormat>;
  /** Show/hide assessment-based question suggestions in the editor. */
  showSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** The guide title. */
  title: Scalars['String']['input'];
  /** Guidance on when to use this guide. */
  whenToUse?: InputMaybe<Scalars['String']['input']>;
};

/** A checklist item in an interviewGuideSave payload. Null id = a new item. */
export type GuideChecklistSaveInput = {
  /** The item's id, or null to create a new item. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The checklist item text. */
  text: Scalars['String']['input'];
};

/** A competency in an interviewGuideSave payload. Null id = a new competency. */
export type GuideCompetencySaveInput = {
  /** The competency's id, or null to create a new competency. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The competency name. */
  name: Scalars['String']['input'];
  /** Optional note about how the competency is assessed. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** A question in an interviewGuideSave payload. Null id = a new question. */
export type GuideQuestionSaveInput = {
  /** The bank question this was added from, if any. */
  bankQuestionId?: InputMaybe<Scalars['ID']['input']>;
  /** The question's id, or null to create a new question. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The competency topic this question assesses. */
  kssartiTopic?: InputMaybe<KssartiTopic>;
  /** Whether the question is locked against reviewer edits. */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** The 1-5 scoring rubric. */
  scoringGuide: ScoringGuideInput;
  /** The question text. */
  text: Scalars['String']['input'];
};

/** Input for updating a guide's details. Omitted fields are left unchanged. */
export type InterviewGuideUpdateInput = {
  /** New division/department. */
  division?: InputMaybe<Scalars['String']['input']>;
  /** Enable/disable the pre-interview checklist section. */
  includeChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable/disable the key-competencies section. */
  includeCompetencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** New interview purpose tags. */
  interviewPurpose?: InputMaybe<Array<Scalars['String']['input']>>;
  /** New job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** New response format. */
  responseFormat?: InputMaybe<ResponseFormat>;
  /** Show/hide assessment-based question suggestions in the editor. */
  showSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** New guide title. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** New when-to-use guidance. */
  whenToUse?: InputMaybe<Scalars['String']['input']>;
};

/** Result payload for the listingMatchmakingMarkPending mutation. */
export type ListingMatchmakingMutationResult = {
  __typename?: 'ListingMatchmakingMutationResult';
  /** Business-level errors. Empty on success. */
  errors: Array<ListingMatchmakingMutationError>;
  /**
   * The listing the marker was written for, so a caller can read isProcessingMatches
   * back in the same round trip. Null if the mutation failed.
   */
  listing?: Maybe<Listing>;
};

/** A structured error returned from a listing matchmaking mutation. */
export type ListingMatchmakingMutationError = {
  __typename?: 'ListingMatchmakingMutationError';
  /** Machine-readable error code. */
  code: ListingMatchmakingMutationErrorCode;
  /** Human-readable description of the error. */
  message: Scalars['String']['output'];
};

/** Machine-readable error codes for listing matchmaking mutations. */
export enum ListingMatchmakingMutationErrorCode {
  /** An unexpected server-side error occurred. */
  UnknownError = 'UNKNOWN_ERROR'
}

/** Input data for the listingScoreWeightsUpdate mutation. */
export type ListingScoreWeightsUpdateInput = {
  /** The new score weights to apply. */
  scoreWeights: ScoreWeightInput;
};

/** Score weight configuration for a listing's match scoring. */
export type ScoreWeightInput = {
  /** Weight (0–100) assigned to assessment scores. */
  assessments?: InputMaybe<Scalars['Int']['input']>;
  /** Weight (0–100) assigned to qualification scores. */
  qualifications?: InputMaybe<Scalars['Int']['input']>;
  /** Weight (0–100) assigned to skill scores. */
  skills?: InputMaybe<Scalars['Int']['input']>;
};

/** Result payload for the listingScoreWeightsUpdate mutation. */
export type ListingScoreWeightsMutationResult = {
  __typename?: 'ListingScoreWeightsMutationResult';
  /** Business-level errors. Empty on success. */
  errors: Array<ListingScoreWeightsMutationError>;
  /** The updated score weights, or null if the mutation failed. */
  listingScoreWeights?: Maybe<ListingScoreWeights>;
};

/** A structured error returned from a listingScoreWeightsUpdate mutation. */
export type ListingScoreWeightsMutationError = {
  __typename?: 'ListingScoreWeightsMutationError';
  /** Machine-readable error code. */
  code: ListingScoreWeightsMutationErrorCode;
  /** Human-readable description of the error. */
  message: Scalars['String']['output'];
};

/** Machine-readable error codes for listingScoreWeightsUpdate mutations. */
export enum ListingScoreWeightsMutationErrorCode {
  /** An unexpected server-side error occurred. */
  UnknownError = 'UNKNOWN_ERROR'
}

export type MessageTemplateCreateInput = {
  content: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type MessageTemplateMutationResult = {
  __typename?: 'MessageTemplateMutationResult';
  errors: Array<Maybe<MessageTemplateMutationError>>;
  messageTemplate?: Maybe<MessageTemplate>;
};

export type MessageTemplateUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The Approval to Hire form payload, taken whole on submit/resubmit so
 * 'Submit for Approval' is a single write.
 */
export type OfferApprovalSubmitInput = {
  /**
   * Chosen on submit and fixed thereafter. In SEQUENTIAL mode the order of the
   * approvers list is the chain order.
   */
  approvalMode?: InputMaybe<OfferApprovalMode>;
  /** Replaces the working approver set; everyone starts PENDING. */
  approvers?: InputMaybe<Array<OfferApproverInput>>;
  headcount?: InputMaybe<OfferHeadcountInput>;
  /**
   * Resubmit only: the offer details, amended in the same edit session.
   * They ride the resubmit because the offer is locked while an approval is
   * in flight — writing them here applies the change and re-asks every
   * approver in one step, so no approver can sign off details that have
   * since moved. Ignored on the first submit, where the offer is editable
   * in its own right.
   */
  offerDetails?: InputMaybe<OfferDetailsInput>;
  supportingDocuments?: InputMaybe<Array<OfferFileInput>>;
  supportingNotes?: InputMaybe<Scalars['String']['input']>;
};

export type OfferApproverInput = {
  approvalTypes: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type OfferHeadcountInput = {
  budgetNotes?: InputMaybe<Scalars['String']['input']>;
  fte: Scalars['Int']['input'];
  positionNumber?: InputMaybe<Scalars['String']['input']>;
  replacingWho?: InputMaybe<Scalars['String']['input']>;
  requestType: OfferRequestType;
  unplannedReason?: InputMaybe<Scalars['String']['input']>;
};

/** Offer details payload shared by start and save. */
export type OfferDetailsInput = {
  compensation?: InputMaybe<OfferCompensationInput>;
  jobDetails?: InputMaybe<OfferJobDetailsInput>;
};

export type OfferCompensationInput = {
  baseSalaryMax?: InputMaybe<Scalars['Int']['input']>;
  baseSalaryMin?: InputMaybe<Scalars['Int']['input']>;
  benefits?: InputMaybe<Scalars['String']['input']>;
  bonuses?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  otherCompensation?: InputMaybe<Scalars['String']['input']>;
  paymentSchedule?: InputMaybe<OfferPaymentSchedule>;
  salaryConditions?: InputMaybe<Scalars['String']['input']>;
  salaryPeriod?: InputMaybe<OfferSalaryPeriod>;
  superannuation?: InputMaybe<Scalars['String']['input']>;
};

export type OfferJobDetailsInput = {
  costCentre?: InputMaybe<Scalars['String']['input']>;
  division?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<OfferEmploymentType>;
  jobTitle: Scalars['String']['input'];
  jobTitleId?: InputMaybe<Scalars['ID']['input']>;
  reportingManager?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
  workSetting?: InputMaybe<OfferWorkSetting>;
};

export type OfferFileInput = {
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeBytes?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferDocumentUploadInput = {
  documentTypeId: Scalars['ID']['input'];
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeBytes?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferDocumentPackageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  templateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OfferDocumentTemplateCreateInput = {
  documentTypeId: Scalars['ID']['input'];
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Input for creating a new guide question. */
export type OrganisationReferenceQuestionCreateInput = {
  /** Whether the question should be active. */
  enabled: Scalars['Boolean']['input'];
  /** Additional context shown below the question label. */
  helperText?: InputMaybe<Scalars['String']['input']>;
  /** Display order of the question. */
  order: Scalars['Int']['input'];
  /** Placeholder text for the response text area. */
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** The main question text. */
  questionLabel: Scalars['String']['input'];
};

/** The result of a guide question mutation. */
export type OrganisationReferenceQuestionMutationResult = {
  __typename?: 'OrganisationReferenceQuestionMutationResult';
  /** Any errors that occurred during the mutation. */
  errors: Array<OrganisationReferenceQuestionMutationError>;
  /** The guide question affected by the mutation, if successful. */
  question?: Maybe<OrganisationReferenceQuestion>;
};

/** An error that occurred during a guide question mutation. */
export type OrganisationReferenceQuestionMutationError = {
  __typename?: 'OrganisationReferenceQuestionMutationError';
  /** A machine-readable error code. */
  code: OrganisationReferenceQuestionMutationErrorCode;
  /** A human-readable error message. */
  message: Scalars['String']['output'];
};

/** Error codes for guide question mutation failures. */
export enum OrganisationReferenceQuestionMutationErrorCode {
  /** The requested guide question was not found. */
  QuestionNotFound = 'QUESTION_NOT_FOUND',
  /** The user is not authorised to perform this action. */
  Unauthorised = 'UNAUTHORISED',
  /** An unexpected error occurred. */
  UnknownError = 'UNKNOWN_ERROR',
  /** The input failed validation. */
  ValidationError = 'VALIDATION_ERROR'
}

/** Input for updating an existing guide question. */
export type OrganisationReferenceQuestionUpdateInput = {
  /** Whether the question should be active. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional context shown below the question label. */
  helperText?: InputMaybe<Scalars['String']['input']>;
  /** Display order of the question. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Placeholder text for the response text area. */
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** The main question text. */
  questionLabel?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationTagActivityInput = {
  activities: Array<OrganisationTagCoreActivityInput>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationTagCoreActivityInput = {
  action: TagActivityAction;
  tagId: Scalars['ID']['input'];
};

export type OrganisationTagActivityMutationResult = {
  __typename?: 'OrganisationTagActivityMutationResult';
  errors: Array<TagActivityMutationError>;
  tagActivities?: Maybe<Array<Maybe<TagActivity>>>;
};

export type TagActivityMutationError = {
  __typename?: 'TagActivityMutationError';
  code?: Maybe<TagActivityMutationErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum TagActivityMutationErrorCode {
  InvalidTag = 'INVALID_TAG',
  MaxTagsAssigned = 'MAX_TAGS_ASSIGNED'
}

export type OrganisationTagCreateInput = {
  category: TagCategory;
  label: Scalars['String']['input'];
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganisationTagMutationResult = {
  __typename?: 'OrganisationTagMutationResult';
  errors: Array<CreateTagError>;
  tag?: Maybe<Tag>;
};

export type CreateTagError = {
  __typename?: 'CreateTagError';
  code?: Maybe<CreateTagErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreateTagErrorCode {
  DuplicateTag = 'DUPLICATE_TAG',
  MaxTagCharactersReached = 'MAX_TAG_CHARACTERS_REACHED',
  MaxTagsReached = 'MAX_TAGS_REACHED',
  NotAlphanumericTag = 'NOT_ALPHANUMERIC_TAG'
}

export type PersonalityAssessmentInviteMembersInput = {
  emailContent: Scalars['String']['input'];
  filters: Array<PersonalityResultsQueryInput>;
  fromName: Scalars['String']['input'];
  fromTitle: Scalars['String']['input'];
};

export type PersonalityAssessmentInviteMembers = {
  __typename?: 'PersonalityAssessmentInviteMembers';
  error?: Maybe<Scalars['String']['output']>;
};

export type PersonalityAssessmentAnswersInput = {
  answers: Array<PersonalityAssessmentAnswerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PersonalityAssessmentAnswerInput = {
  answer: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

/** Input for submitting or editing a reference's referee details. */
export type SubmitReferenceInput = {
  /** The company where the referee and candidate worked together. */
  company: Scalars['String']['input'];
  /** The referee's email address. */
  email: Scalars['String']['input'];
  /** The full name of the referee. */
  name: Scalars['String']['input'];
  /** The referee's phone number. */
  phone: Scalars['String']['input'];
  /** The professional relationship between the referee and the candidate. */
  relationship: ReferenceRelationship;
};

/** The result payload returned by candidate reference mutations. */
export type CandidateReferenceMutationResult = {
  __typename?: 'CandidateReferenceMutationResult';
  /** Business-level errors. Empty on success. */
  errors: Array<CandidateReferenceMutationError>;
  /** The updated reference. Null if the mutation failed. */
  reference?: Maybe<CandidateReference>;
};

/** A user-facing error returned from a candidate reference mutation. */
export type CandidateReferenceMutationError = {
  __typename?: 'CandidateReferenceMutationError';
  /** A machine-readable code identifying the error type. */
  code: CandidateReferenceMutationErrorCode;
  /** A human-readable description of the error. */
  message: Scalars['String']['output'];
};

/** Machine-readable codes for errors returned by candidate reference mutations. */
export enum CandidateReferenceMutationErrorCode {
  /** No application exists with the given ID. */
  ApplicationNotFound = 'APPLICATION_NOT_FOUND',
  /** The deadline for this reference request has passed. */
  DeadlinePassed = 'DEADLINE_PASSED',
  /** The reference is not in a state that allows this transition (e.g. already submitted). */
  InvalidStatusTransition = 'INVALID_STATUS_TRANSITION',
  /** The reference has already been completed and cannot be edited. */
  ReferenceCompleted = 'REFERENCE_COMPLETED',
  /** No reference exists with the given ID. */
  ReferenceNotFound = 'REFERENCE_NOT_FOUND',
  /** An unexpected error occurred. */
  UnknownError = 'UNKNOWN_ERROR',
  /** One or more input fields failed validation. */
  ValidationError = 'VALIDATION_ERROR'
}

export type RemoveGroupMembersInput = {
  groupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type RemoveGroupMembersPayload = {
  __typename?: 'RemoveGroupMembersPayload';
  failCount: Scalars['Int']['output'];
  failed: Array<Scalars['ID']['output']>;
  missing: Array<Scalars['ID']['output']>;
  status: GroupMemberOperationStatus;
};

export type StandaloneCvRemoval = {
  __typename?: 'StandaloneCVRemoval';
  /** The error message if the removal failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The ID of the standalone CV. */
  id: Scalars['ID']['output'];
  /** Whether the removal was successful. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendUserEmailUpdateCodeMutationInput = {
  userPool?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeProductAccessInput = {
  /** The app code identifying the product whose access to revoke. */
  appCode: Scalars['String']['input'];
};

export type SaveComponoAssistReactionInput = {
  feedback: FeedbackType;
  keys: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

/** A candidate-specific question to add during the interview. */
export type ScorecardQuestionAddInput = {
  /** For a SUGGESTION, the opaque assessment-gap key it was generated from (assessment+dimension), for the panel's added-state matching. */
  assessmentGapKey?: InputMaybe<Scalars['String']['input']>;
  /** The competency topic this question assesses. */
  kssartiTopic?: InputMaybe<KssartiTopic>;
  /** The 1-5 scoring rubric. */
  scoringGuide: ScoringGuideInput;
  /** Where the question came from (CANDIDATE for ad-hoc, BANK for question-bank picks, SUGGESTION for assessment-based). */
  source: ScorecardQuestionSource;
  /** The question text. */
  text: Scalars['String']['input'];
};

/** Draft answers to save on a scorecard. Omitted fields are left unchanged. */
export type ScorecardSaveInput = {
  /** The interviewer's final comment. */
  finalComment?: InputMaybe<Scalars['String']['input']>;
  /** Per-question answers to upsert. */
  questions?: InputMaybe<Array<ScorecardQuestionScoreInput>>;
  /** The interviewer's current recommendation. */
  recommendation?: InputMaybe<ScorecardRecommendation>;
};

/** One question answer (score/notes/notAsked) keyed by the question's definition id. */
export type ScorecardQuestionScoreInput = {
  /** True when the question wasn't asked/scored. */
  notAsked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes for this question. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The question to answer, by its ScorecardQuestionEntry.questionId. */
  questionId: Scalars['ID']['input'];
  /** The 1-5 score. Omit while unscored. */
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** Final answers for submitting a scorecard. */
export type ScorecardSubmitInput = {
  /** The interviewer's final comment. */
  finalComment?: InputMaybe<Scalars['String']['input']>;
  /** Per-question final answers. */
  questions: Array<ScorecardQuestionScoreInput>;
  /** The interviewer's overall recommendation. */
  recommendation: ScorecardRecommendation;
};

export type SharePageInput = {
  campaignSk: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['Int']['input']>;
  password: Scalars['String']['input'];
  refCampaignSk?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SystemTagActivityInput = {
  action: TagActivityAction;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  tagId: SystemTagId;
};

export enum SystemTagId {
  Favourite = 'FAVOURITE'
}

export type TagActivityMutationResult = {
  __typename?: 'TagActivityMutationResult';
  errors: Array<UserError>;
  tagActivity?: Maybe<TagActivity>;
};

export type UserError = {
  __typename?: 'UserError';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/** Result payload for transcript mutations. */
export type TranscriptMutationResult = {
  __typename?: 'TranscriptMutationResult';
  /** Business errors. Empty on success. */
  errors: Array<TranscriptMutationError>;
  /** The affected transcript. Null when the mutation failed. */
  transcript?: Maybe<Transcript>;
};

/** A business-level error from a transcript mutation. */
export type TranscriptMutationError = {
  __typename?: 'TranscriptMutationError';
  /** Machine-readable error code. */
  code: TranscriptMutationErrorCode;
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Error codes for transcript mutations. */
export enum TranscriptMutationErrorCode {
  /** The AI generation failed or could not be started; the user can retry. */
  AiGenerationFailed = 'AI_GENERATION_FAILED',
  /** No transcript exists for the given interview. */
  NotFound = 'NOT_FOUND',
  /** A transcript already exists for this interview. */
  TranscriptAlreadyExists = 'TRANSCRIPT_ALREADY_EXISTS',
  /** The caller has no access to this interview's transcript. */
  Unauthorised = 'UNAUTHORISED',
  /** The input failed validation. */
  ValidationFailed = 'VALIDATION_FAILED'
}

/** Transcript content for upload: pasted text OR an uploaded file reference. */
export type TranscriptUploadInput = {
  /** Uploaded transcript file (PDF/DOCX/TXT). Its text is extracted by AI and stored. Provide this OR `text`. */
  file?: InputMaybe<PositionDescriptionFileInput>;
  /** Original file name for display. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Pasted transcript text (plain). Provide this OR `file`. Remains the plain-text projection the AI reads, even when `textHtml` is also supplied. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Rich-text (HTML) version of the pasted transcript, produced by the rich editor. Optional; when present it is stored for display while `text` carries the plain-text projection. */
  textHtml?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAuthClientInput = {
  clientName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  scopeIds: Array<Scalars['String']['input']>;
};

/** Input for updating the score weights on a listing. */
export type UpdateListingScoreWeightsInput = {
  /** The ID of the listing to update the score weights for. */
  listingId: Scalars['ID']['input'];
  /** The new score weights to apply. */
  scoreWeights: ScoreWeightInput;
};

export type UpdateProductAccessInput = {
  /** The app code identifying the product whose access to update. */
  appCode: Scalars['String']['input'];
  /** The new role to assign for this product, replacing the existing role. */
  role: Scalars['String']['input'];
};

export type UpdateUserInput = {
  /** Updated division ID. */
  divisionId?: InputMaybe<Scalars['ID']['input']>;
  /** Updated first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Updated job title ID. */
  jobTitleId?: InputMaybe<Scalars['ID']['input']>;
  /** Updated last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Updated organisational location ID. */
  orgLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** Updated start date in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type MatchValidationRequestInput = {
  qualifications: Array<QualificationMatchInput>;
  skills: Array<SkillMatchInput>;
};

export type QualificationMatchInput = {
  parsedQualification: QualificationInput;
  possibleMatches: Array<DatabaseMatchInput>;
};

export type QualificationInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DatabaseMatchInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  similarity: Scalars['Float']['input'];
};

export type SkillMatchInput = {
  parsedSkill: SkillInput;
  possibleMatches: Array<DatabaseMatchInput>;
};

export type SkillInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type MatchValidationResult = {
  __typename?: 'MatchValidationResult';
  qualificationMatches: Array<QualificationMatchResult>;
  skillMatches: Array<SkillMatchResult>;
};

export type QualificationMatchResult = {
  __typename?: 'QualificationMatchResult';
  bestMatch?: Maybe<DatabaseMatch>;
  confidence: Scalars['Float']['output'];
  parsedQualification: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
};

export type DatabaseMatch = {
  __typename?: 'DatabaseMatch';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  similarity: Scalars['Float']['output'];
};

export type SkillMatchResult = {
  __typename?: 'SkillMatchResult';
  bestMatch?: Maybe<DatabaseMatch>;
  confidence: Scalars['Float']['output'];
  parsedSkill: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
};

/**
 * A protected candidate profile stub used for CV summary federation chain.
 * Marked non-resolvable: this is the planned migration target for the deprecated
 * ListingApplicantProtectedProfile but has no reference resolver yet, so the
 * gateway must not attempt to resolve it as an entity.
 */
export type ApplicantProtectedProfile = {
  __typename?: 'ApplicantProtectedProfile';
  /** The candidate ID this protected profile belongs to. */
  candidateId: Scalars['ID']['output'];
};

export type TagActivityFilter = {
  candidateId?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<TagCategory>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  listingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AuthClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthClientsQuery = { __typename?: 'Query', authClients: Array<{ __typename?: 'AuthClient', id: string, clientId: string, clientName: string, description?: string | null, createdAt?: string | null, lastUsedAt?: string | null, scopes: Array<{ __typename?: 'AuthScope', id: string, label: string, description: string, group: string }>, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }> };

export type AuthScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthScopesQuery = { __typename?: 'Query', authScopes: Array<{ __typename?: 'AuthScope', id: string, label: string, description: string, group: string }> };

export type CreateAuthClientMutationVariables = Exact<{
  input: CreateAuthClientInput;
}>;


export type CreateAuthClientMutation = { __typename?: 'Mutation', createAuthClient: { __typename?: 'CreateAuthClientPayload', clientSecret: string, client: { __typename?: 'AuthClient', id: string, clientId: string, clientName: string, description?: string | null, createdAt?: string | null, lastUsedAt?: string | null, scopes: Array<{ __typename?: 'AuthScope', id: string, label: string, description: string, group: string }>, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } } };

export type UpdateAuthClientMutationVariables = Exact<{
  input: UpdateAuthClientInput;
}>;


export type UpdateAuthClientMutation = { __typename?: 'Mutation', updateAuthClient: { __typename?: 'AuthClient', id: string, clientId: string, clientName: string, description?: string | null, createdAt?: string | null, lastUsedAt?: string | null, scopes: Array<{ __typename?: 'AuthScope', id: string, label: string, description: string, group: string }>, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } };

export type DeleteAuthClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAuthClientMutation = { __typename?: 'Mutation', deleteAuthClient: boolean };

export type OrganisationTalent_ListItemFragment = { __typename?: 'OrganisationTalent', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, rankingScore?: number | null, contactLocation?: { __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null } | null, jobs?: Array<{ __typename?: 'OrganisationTalentJob', company?: string | null, startDate?: string | null, endDate?: string | null, years?: number | null, title?: string | null, currentJob?: boolean | null }> | null, prePopulate?: { __typename?: 'PrePopulate', allowed?: boolean | null, userConfirmed?: boolean | null, isPrePopulated?: boolean | null } | null };

export type GetOrganisationTalentsQueryVariables = Exact<{
  input?: InputMaybe<OrganisationTalentSearchInput>;
}>;


export type GetOrganisationTalentsQuery = { __typename?: 'Query', organisationTalents?: Array<{ __typename?: 'OrganisationTalent', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, rankingScore?: number | null, contactLocation?: { __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null } | null, jobs?: Array<{ __typename?: 'OrganisationTalentJob', company?: string | null, startDate?: string | null, endDate?: string | null, years?: number | null, title?: string | null, currentJob?: boolean | null }> | null, prePopulate?: { __typename?: 'PrePopulate', allowed?: boolean | null, userConfirmed?: boolean | null, isPrePopulated?: boolean | null } | null }> | null };

export type OrganisationTalent_DetailFragment = { __typename?: 'OrganisationTalent', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, employmentOptions: Array<string>, workPersonalityType?: string | null, lastSigninAt?: string | null, willRelocateTo?: Array<{ __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null, requiresVisa?: boolean | null }> | null, professionalLinks?: Array<{ __typename?: 'OrganisationTalentProfessionalLink', label: string, url: string }> | null, education?: Array<{ __typename?: 'OrganisationTalentEducation', institutionId?: string | null, institutionName?: string | null, startDate?: string | null, endDate?: string | null, completed?: boolean | null, qualification?: { __typename?: 'Qualification', id: string, name: string, typeName: string } | null }> | null, contactLocation?: { __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null, requiresVisa?: boolean | null } | null, contact?: { __typename?: 'OrganisationTalentContact', phone1?: string | null } | null, jobs?: Array<{ __typename?: 'OrganisationTalentJob', company?: string | null, startDate?: string | null, endDate?: string | null, years?: number | null, title?: string | null, currentJob?: boolean | null, skills: Array<{ __typename?: 'Skill', id: string, name: string }> }> | null, documents?: Array<{ __typename?: 'OrganisationTalentDocument', id: string, fileName: string, type: OrganisationTalentDocumentType, availableFormats?: Array<{ __typename?: 'OrganisationTalentDocumentFormat', isOriginal?: boolean | null, downloadUrl?: string | null, mimeType?: string | null }> | null }> | null, applicationHistory?: Array<{ __typename?: 'OrganisationTalentApplication', id: string, listingId: string, applicantId: string, canView?: boolean | null, jobTitle: string, appliedDate?: any | null, stageName?: string | null, team?: { __typename?: 'Team', id: string, name: string, organisationId: string } | null }> | null, prePopulate?: { __typename?: 'PrePopulate', allowed?: boolean | null, isPrePopulated?: boolean | null, userConfirmed?: boolean | null } | null };

export type GetOrganisationTalentDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganisationTalentDetailsQuery = { __typename?: 'Query', organisationTalent?: { __typename?: 'OrganisationTalent', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, employmentOptions: Array<string>, workPersonalityType?: string | null, lastSigninAt?: string | null, willRelocateTo?: Array<{ __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null, requiresVisa?: boolean | null }> | null, professionalLinks?: Array<{ __typename?: 'OrganisationTalentProfessionalLink', label: string, url: string }> | null, education?: Array<{ __typename?: 'OrganisationTalentEducation', institutionId?: string | null, institutionName?: string | null, startDate?: string | null, endDate?: string | null, completed?: boolean | null, qualification?: { __typename?: 'Qualification', id: string, name: string, typeName: string } | null }> | null, contactLocation?: { __typename?: 'OrganisationTalentLocation', country?: string | null, state?: string | null, city?: string | null, requiresVisa?: boolean | null } | null, contact?: { __typename?: 'OrganisationTalentContact', phone1?: string | null } | null, jobs?: Array<{ __typename?: 'OrganisationTalentJob', company?: string | null, startDate?: string | null, endDate?: string | null, years?: number | null, title?: string | null, currentJob?: boolean | null, skills: Array<{ __typename?: 'Skill', id: string, name: string }> }> | null, documents?: Array<{ __typename?: 'OrganisationTalentDocument', id: string, fileName: string, type: OrganisationTalentDocumentType, availableFormats?: Array<{ __typename?: 'OrganisationTalentDocumentFormat', isOriginal?: boolean | null, downloadUrl?: string | null, mimeType?: string | null }> | null }> | null, applicationHistory?: Array<{ __typename?: 'OrganisationTalentApplication', id: string, listingId: string, applicantId: string, canView?: boolean | null, jobTitle: string, appliedDate?: any | null, stageName?: string | null, team?: { __typename?: 'Team', id: string, name: string, organisationId: string } | null }> | null, prePopulate?: { __typename?: 'PrePopulate', allowed?: boolean | null, isPrePopulated?: boolean | null, userConfirmed?: boolean | null } | null } | null };

export type GetOrganisationTalentDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganisationTalentDocumentsQuery = { __typename?: 'Query', organisationTalent?: { __typename?: 'OrganisationTalent', id: string, documents?: Array<{ __typename?: 'OrganisationTalentDocument', id: string, fileName: string, type: OrganisationTalentDocumentType, availableFormats?: Array<{ __typename?: 'OrganisationTalentDocumentFormat', isOriginal?: boolean | null, downloadUrl?: string | null, mimeType?: string | null }> | null }> | null } | null };

export type GetMyCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCoursesQuery = { __typename?: 'Query', myCourses?: Array<{ __typename?: 'Course', id: string, title?: string | null, url?: string | null, imageUrl?: string | null, authorName?: string | null, enrolmentStatus?: string | null, mandatory?: boolean | null, hasEvents?: boolean | null, hasAssessments?: boolean | null, categories?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null }> | null };

export type GetDivisionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDivisionsQuery = { __typename?: 'Query', divisions: Array<{ __typename?: 'Division', id: string, organisationId: string, name: string, description?: string | null, parentId?: string | null, isDefault?: boolean | null, createdAt?: any | null, updatedAt?: any | null }> };

export type GetGroupsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', groups?: Array<{ __typename?: 'Group', organisationId: string, id: string, name: string, memberCount?: number | null, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null> | null };

export type GetGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetGroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', organisationId: string, name: string, memberCount?: number | null, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null };

export type CreateGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', groupCreate?: { __typename?: 'GroupResponse', group?: { __typename?: 'Group', id: string, organisationId: string, name: string, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null, errors?: Array<{ __typename?: 'GroupMutationError', message?: string | null } | null> | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', groupEdit?: { __typename?: 'GroupResponse', group?: { __typename?: 'Group', id: string, organisationId: string, name: string, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null, errors?: Array<{ __typename?: 'GroupMutationError', message?: string | null } | null> | null } | null };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', groupDelete?: { __typename?: 'GroupResponse', group?: { __typename?: 'Group', id: string, organisationId: string, name: string, description?: string | null, members?: Array<{ __typename?: 'User', id: string } | null> | null } | null } | null };

export type GroupAssignUserMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type GroupAssignUserMutation = { __typename?: 'Mutation', groupAssignUser?: { __typename?: 'GroupMemberResponse', groupMember?: { __typename?: 'GroupMember', groupId: string, memberId: string, memberType?: MemberType | null, organisationId: string, role?: GroupRole | null, roleDisplayName?: string | null } | null, errors?: Array<{ __typename?: 'GroupMemberMutationError', message?: string | null } | null> | null } | null };

export type AssignUserGroupRoleMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  role?: InputMaybe<GroupRole>;
}>;


export type AssignUserGroupRoleMutation = { __typename?: 'Mutation', assignGroupRole?: { __typename?: 'GroupMemberResponse', groupMember?: { __typename?: 'GroupMember', groupId: string, memberId: string, memberType?: MemberType | null, organisationId: string, role?: GroupRole | null, roleDisplayName?: string | null } | null } | null };

export type GroupUnassignUserMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type GroupUnassignUserMutation = { __typename?: 'Mutation', groupUnassignUser?: { __typename?: 'GroupMemberResponse', groupMember?: { __typename?: 'GroupMember', groupId: string, memberId: string, memberType?: MemberType | null, organisationId: string, role?: GroupRole | null, roleDisplayName?: string | null } | null, errors?: Array<{ __typename?: 'GroupMemberMutationError', message?: string | null } | null> | null } | null };

export type GroupMembersQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type GroupMembersQuery = { __typename?: 'Query', groupMembers?: Array<{ __typename?: 'GroupMember', memberId: string, organisationId: string, groupId: string, memberType?: MemberType | null, role?: GroupRole | null, roleDisplayName?: string | null } | null> | null };

export type UserGroupMembersQueryVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type UserGroupMembersQuery = { __typename?: 'Query', userGroupMembers?: Array<{ __typename?: 'GroupMember', memberId: string, organisationId: string, groupId: string, memberType?: MemberType | null, role?: GroupRole | null, roleDisplayName?: string | null } | null> | null };

export type GetGuideQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGuideQuestionsQuery = { __typename?: 'Query', organisationReferenceQuestions: Array<{ __typename?: 'OrganisationReferenceQuestion', id: string, questionLabel: string, helperText?: string | null, placeholderText?: string | null, enabled: boolean, order: number, createdAt: any, updatedAt: any, organisation: { __typename?: 'Organisation', id: string } }> };

export type GetGuideQuestionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetGuideQuestionQuery = { __typename?: 'Query', organisationReferenceQuestion?: { __typename?: 'OrganisationReferenceQuestion', id: string, questionLabel: string, helperText?: string | null, placeholderText?: string | null, enabled: boolean, order: number, createdAt: any, updatedAt: any, organisation: { __typename?: 'Organisation', id: string } } | null };

export type CreateGuideQuestionMutationVariables = Exact<{
  input: OrganisationReferenceQuestionCreateInput;
}>;


export type CreateGuideQuestionMutation = { __typename?: 'Mutation', organisationReferenceQuestionCreate: { __typename?: 'OrganisationReferenceQuestionMutationResult', question?: { __typename?: 'OrganisationReferenceQuestion', id: string, questionLabel: string, helperText?: string | null, placeholderText?: string | null, enabled: boolean, order: number, createdAt: any, updatedAt: any, organisation: { __typename?: 'Organisation', id: string } } | null, errors: Array<{ __typename?: 'OrganisationReferenceQuestionMutationError', message: string, code: OrganisationReferenceQuestionMutationErrorCode }> } };

export type UpdateGuideQuestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: OrganisationReferenceQuestionUpdateInput;
}>;


export type UpdateGuideQuestionMutation = { __typename?: 'Mutation', organisationReferenceQuestionUpdate: { __typename?: 'OrganisationReferenceQuestionMutationResult', question?: { __typename?: 'OrganisationReferenceQuestion', id: string, questionLabel: string, helperText?: string | null, placeholderText?: string | null, enabled: boolean, order: number, createdAt: any, updatedAt: any, organisation: { __typename?: 'Organisation', id: string } } | null, errors: Array<{ __typename?: 'OrganisationReferenceQuestionMutationError', message: string, code: OrganisationReferenceQuestionMutationErrorCode }> } };

export type DeleteGuideQuestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGuideQuestionMutation = { __typename?: 'Mutation', organisationReferenceQuestionDelete: { __typename?: 'OrganisationReferenceQuestionMutationResult', question?: { __typename?: 'OrganisationReferenceQuestion', id: string, questionLabel: string, organisation: { __typename?: 'Organisation', id: string } } | null, errors: Array<{ __typename?: 'OrganisationReferenceQuestionMutationError', message: string, code: OrganisationReferenceQuestionMutationErrorCode }> } };

export type HireReportProcessQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  hiringTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  timezoneOffset: Scalars['Int']['input'];
}>;


export type HireReportProcessQuery = { __typename?: 'Query', hireReportProcess: { __typename?: 'HireReportProcess', id: string } };

export type HireReportResultQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HireReportResultQuery = { __typename?: 'Query', hireReportResult?: { __typename?: 'HireReportResult', id: string, report: { __typename?: 'HireReportStats', aggregates: { __typename?: 'HireReport', jobsOpenAtStartDate: number, jobsOpenAtEndDate: number, jobsOpenedInPeriod: number, jobsClosedInPeriod: number, totalApplications: number, totalHires: number, avgTimeToFillInDays: number, avgTimeToHireInDays: number }, applicationSources: { __typename?: 'HireReportApplicationSources', all: Array<{ __typename?: 'HireReportApplicationSourceCount', name: string, count: number }>, hired: Array<{ __typename?: 'HireReportApplicationSourceCount', name: string, count: number }> } }, export: { __typename?: 'HireReportExport', csvUrl: string, noOfEntries: number } } | null };

export type GetMessageTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMessageTemplateQuery = { __typename?: 'Query', messageTemplate?: { __typename?: 'MessageTemplate', organisationId?: string | null, id?: string | null, name?: string | null, description?: string | null, subject?: string | null, content?: string | null, enabled?: boolean | null } | null };

export type GetMessageTemplateGenerateQueryVariables = Exact<{
  prompt: Scalars['String']['input'];
  tone: Scalars['String']['input'];
  previousAnswer?: InputMaybe<Scalars['String']['input']>;
  additionalInstruction?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMessageTemplateGenerateQuery = { __typename?: 'Query', messageTemplateGenerate?: { __typename?: 'MessageTemplateGeneratedResult', messageTemplateGenerated?: { __typename?: 'MessageTemplateGenerated', subject: string, content: string } | null, errors?: Array<{ __typename?: 'MessageTemplateMutationError', message?: string | null } | null> | null } | null };

export type CreateMessageTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  content: Scalars['String']['input'];
}>;


export type CreateMessageTemplateMutation = { __typename?: 'Mutation', messageTemplateCreate?: { __typename?: 'MessageTemplateMutationResult', messageTemplate?: { __typename?: 'MessageTemplate', id?: string | null, organisationId?: string | null, name?: string | null, subject?: string | null, content?: string | null, description?: string | null, enabled?: boolean | null } | null, errors: Array<{ __typename?: 'MessageTemplateMutationError', message?: string | null } | null> } | null };

export type UpdateMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMessageTemplateMutation = { __typename?: 'Mutation', messageTemplateUpdate?: { __typename?: 'MessageTemplateMutationResult', messageTemplate?: { __typename?: 'MessageTemplate', id?: string | null, organisationId?: string | null, name?: string | null, description?: string | null, subject?: string | null, content?: string | null, enabled?: boolean | null } | null, errors: Array<{ __typename?: 'MessageTemplateMutationError', message?: string | null } | null> } | null };

export type DeleteMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMessageTemplateMutation = { __typename?: 'Mutation', messageTemplateDelete?: { __typename?: 'MessageTemplateMutationResult', messageTemplate?: { __typename?: 'MessageTemplate', id?: string | null, organisationId?: string | null, name?: string | null, description?: string | null, subject?: string | null, content?: string | null, enabled?: boolean | null } | null } | null };

export type GetComponoAssistReactionQueryVariables = Exact<{
  input: GetComponoAssistReactionInput;
}>;


export type GetComponoAssistReactionQuery = { __typename?: 'Query', getComponoAssistReaction?: { __typename?: 'ComponoAssistReaction', feedback: FeedbackType, data?: any | null } | null };

export type SaveComponoAssistReactionMutationVariables = Exact<{
  input: SaveComponoAssistReactionInput;
}>;


export type SaveComponoAssistReactionMutation = { __typename?: 'Mutation', saveComponoAssistReaction?: { __typename?: 'ComponoAssistReaction', feedback: FeedbackType, data?: any | null } | null };

export type GetApplicationReferencesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetApplicationReferencesQuery = { __typename?: 'Query', application?: { __typename?: 'Application', id: string, references: Array<{ __typename?: 'Reference', id: string, requestId?: string | null, name: string, relationship: ReferenceRelationship, company: string, phone?: string | null, email?: string | null, status: ReferenceStatus, source: ReferenceSource, submittedAt?: any | null, editedAt?: any | null, dateContacted?: any | null, overallRating?: OverallRating | null, wouldRehire?: WouldRehire | null, additionalNotes?: string | null, completedAt?: any | null, completedBy?: string | null, createdAt: any, updatedAt: any, guideQuestions: Array<{ __typename?: 'ReferenceGuideQuestionSnapshot', questionId: string, questionLabel: string, helperText?: string | null, placeholderText?: string | null, order: number, response?: string | null }> }>, referenceRequests: Array<{ __typename?: 'ReferenceRequest', id: string, requestedBy: string, requestedAt: any, requiredCount: number, deadline: any, messageSubject: string, messageBody: string }>, referenceStatusSummary?: { __typename?: 'ReferenceStatusSummary', total: number, pending: number, sent: number, completed: number, declined: number } | null } | null };

export type ApplicationReferencesRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RequestReferencesInput;
}>;


export type ApplicationReferencesRequestMutation = { __typename?: 'Mutation', applicationReferencesRequest: { __typename?: 'ReferenceMutationResult', application?: { __typename?: 'Application', id: string } | null, errors: Array<{ __typename?: 'ReferenceMutationError', message: string, code: ReferenceMutationErrorCode }> } };

export type ApplicationReferenceAddMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  input: ApplicationReferenceAddInput;
}>;


export type ApplicationReferenceAddMutation = { __typename?: 'Mutation', applicationReferenceAdd: { __typename?: 'ReferenceMutationResult', application?: { __typename?: 'Application', id: string } | null, errors: Array<{ __typename?: 'ReferenceMutationError', message: string, code: ReferenceMutationErrorCode }> } };

export type ApplicationReferenceCompleteMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  referenceId: Scalars['ID']['input'];
  input: ReferenceResultsInput;
}>;


export type ApplicationReferenceCompleteMutation = { __typename?: 'Mutation', applicationReferenceComplete: { __typename?: 'ReferenceMutationResult', application?: { __typename?: 'Application', id: string } | null, errors: Array<{ __typename?: 'ReferenceMutationError', message: string, code: ReferenceMutationErrorCode }> } };

export type ApplicationReferenceUpdateResultsMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  referenceId: Scalars['ID']['input'];
  input: ReferenceResultsInput;
}>;


export type ApplicationReferenceUpdateResultsMutation = { __typename?: 'Mutation', applicationReferenceUpdateResults: { __typename?: 'ReferenceMutationResult', application?: { __typename?: 'Application', id: string } | null, errors: Array<{ __typename?: 'ReferenceMutationError', message: string, code: ReferenceMutationErrorCode }> } };

export type ApplicationReferenceRemoveMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  referenceId: Scalars['ID']['input'];
}>;


export type ApplicationReferenceRemoveMutation = { __typename?: 'Mutation', applicationReferenceRemove: { __typename?: 'ReferenceMutationResult', application?: { __typename?: 'Application', id: string } | null, errors: Array<{ __typename?: 'ReferenceMutationError', message: string, code: ReferenceMutationErrorCode }> } };

export type ApplicationReferenceEditMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  referenceId: Scalars['ID']['input'];
  input: ApplicationReferenceAddInput;
}>;


export type ApplicationReferenceEditMutation = { __typename?: 'Mutation', applicationReferenceEdit: { __typename?: 'ReferenceMutationResult', application?: { __typename?: 'Application', id: string } | null, errors: Array<{ __typename?: 'ReferenceMutationError', message: string, code: ReferenceMutationErrorCode }> } };

export type ApplicationReferenceDeclineMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  referenceId: Scalars['ID']['input'];
}>;


export type ApplicationReferenceDeclineMutation = { __typename?: 'Mutation', applicationReferenceDecline: { __typename?: 'ReferenceMutationResult', application?: { __typename?: 'Application', id: string } | null, errors: Array<{ __typename?: 'ReferenceMutationError', message: string, code: ReferenceMutationErrorCode }> } };

export type RehydrateSkillsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RehydrateSkillsQuery = { __typename?: 'Query', rehydrateSkills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null };

export type RehydrateQualificationsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RehydrateQualificationsQuery = { __typename?: 'Query', rehydrateQualifications?: Array<{ __typename?: 'Qualification', id: string, name: string }> | null };

export type RehydrateWorkAreasQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RehydrateWorkAreasQuery = { __typename?: 'Query', rehydrateWorkAreas?: Array<{ __typename?: 'WorkArea', id: string, name: string }> | null };

export type GetRequisitionDivisionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequisitionDivisionsQuery = { __typename?: 'Query', divisions: Array<{ __typename?: 'Division', id: string, name: string, parentId?: string | null }> };

export type GetRequisitionJobTitlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequisitionJobTitlesQuery = { __typename?: 'Query', jobTitles: Array<{ __typename?: 'JobTitle', id: string, name: string }> };

export type SsoConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SsoConfigQuery = { __typename?: 'Query', ssoConfig?: { __typename?: 'SSOConfig', acsUrl?: string | null, entityId?: string | null, logoutUrl?: string | null } | null };

export type CreateSsoConnectionMutationVariables = Exact<{
  input: SsoConnectionInput;
}>;


export type CreateSsoConnectionMutation = { __typename?: 'Mutation', createSSOConnection?: { __typename: 'SSOConnection', id: string, organisationId: string, type: string } | null };

export type UpdateSsoConnectionMutationVariables = Exact<{
  input: SsoConnectionInput;
}>;


export type UpdateSsoConnectionMutation = { __typename?: 'Mutation', updateSSOConnection?: { __typename: 'SSOConnection', id: string, organisationId: string, type: string } | null };

export type SsoConnectionsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SsoConnectionsQuery = { __typename?: 'Query', ssoConnections: Array<{ __typename?: 'SSOConnection', id: string, name?: string | null, attributeMapping?: any | null, autoSignup?: boolean | null, clientId?: string | null, enabled?: boolean | null, encryptedResponses?: boolean | null, metadataFile?: string | null, metadataUrl?: string | null, replaceLoginPage?: boolean | null, encryptionCertificate?: string | null, type: string }> };

export type RemoveSsoConnectionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type RemoveSsoConnectionMutation = { __typename?: 'Mutation', removeSSOConnection?: boolean | null };

export const OrganisationTalent_ListItemFragmentDoc = gql`
    fragment OrganisationTalent_ListItem on OrganisationTalent {
  id
  firstName
  lastName
  email
  contactLocation {
    country
    state
    city
  }
  jobs {
    company
    startDate
    endDate
    years
    title
    currentJob
  }
  rankingScore
  prePopulate {
    allowed
    userConfirmed
    isPrePopulated
  }
}
    `;
export const OrganisationTalent_DetailFragmentDoc = gql`
    fragment OrganisationTalent_Detail on OrganisationTalent {
  id
  firstName
  lastName
  email
  employmentOptions
  workPersonalityType
  lastSigninAt
  willRelocateTo {
    country
    state
    city
    requiresVisa
  }
  professionalLinks {
    label
    url
  }
  education {
    institutionId
    institutionName
    startDate
    endDate
    completed
    qualification {
      id
      name
      typeName
    }
  }
  contactLocation {
    country
    state
    city
    requiresVisa
  }
  contact {
    phone1
  }
  jobs {
    company
    startDate
    endDate
    years
    title
    currentJob
    skills {
      id
      name
    }
  }
  documents {
    id
    fileName
    type
    availableFormats {
      isOriginal
      downloadUrl
      mimeType
    }
  }
  applicationHistory {
    id
    listingId
    applicantId
    canView
    jobTitle
    appliedDate
    stageName
    team {
      id
      name
      organisationId
    }
  }
  prePopulate {
    allowed
    isPrePopulated
    userConfirmed
  }
}
    `;
export const AuthClientsDocument = gql`
    query AuthClients {
  authClients {
    id
    clientId
    clientName
    description
    scopes {
      id
      label
      description
      group
    }
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
    lastUsedAt
  }
}
    `;

/**
 * __useAuthClientsQuery__
 *
 * To run a query within a React component, call `useAuthClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthClientsQuery(baseOptions?: Apollo.QueryHookOptions<AuthClientsQuery, AuthClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthClientsQuery, AuthClientsQueryVariables>(AuthClientsDocument, options);
      }
export function useAuthClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthClientsQuery, AuthClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthClientsQuery, AuthClientsQueryVariables>(AuthClientsDocument, options);
        }
// @ts-ignore
export function useAuthClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthClientsQuery, AuthClientsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthClientsQuery, AuthClientsQueryVariables>;
export function useAuthClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthClientsQuery, AuthClientsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthClientsQuery | undefined, AuthClientsQueryVariables>;
export function useAuthClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthClientsQuery, AuthClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthClientsQuery, AuthClientsQueryVariables>(AuthClientsDocument, options);
        }
export type AuthClientsQueryHookResult = ReturnType<typeof useAuthClientsQuery>;
export type AuthClientsLazyQueryHookResult = ReturnType<typeof useAuthClientsLazyQuery>;
export type AuthClientsSuspenseQueryHookResult = ReturnType<typeof useAuthClientsSuspenseQuery>;
export type AuthClientsQueryResult = Apollo.QueryResult<AuthClientsQuery, AuthClientsQueryVariables>;
export const AuthScopesDocument = gql`
    query AuthScopes {
  authScopes {
    id
    label
    description
    group
  }
}
    `;

/**
 * __useAuthScopesQuery__
 *
 * To run a query within a React component, call `useAuthScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthScopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthScopesQuery(baseOptions?: Apollo.QueryHookOptions<AuthScopesQuery, AuthScopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthScopesQuery, AuthScopesQueryVariables>(AuthScopesDocument, options);
      }
export function useAuthScopesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthScopesQuery, AuthScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthScopesQuery, AuthScopesQueryVariables>(AuthScopesDocument, options);
        }
// @ts-ignore
export function useAuthScopesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthScopesQuery, AuthScopesQueryVariables>): Apollo.UseSuspenseQueryResult<AuthScopesQuery, AuthScopesQueryVariables>;
export function useAuthScopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthScopesQuery, AuthScopesQueryVariables>): Apollo.UseSuspenseQueryResult<AuthScopesQuery | undefined, AuthScopesQueryVariables>;
export function useAuthScopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthScopesQuery, AuthScopesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthScopesQuery, AuthScopesQueryVariables>(AuthScopesDocument, options);
        }
export type AuthScopesQueryHookResult = ReturnType<typeof useAuthScopesQuery>;
export type AuthScopesLazyQueryHookResult = ReturnType<typeof useAuthScopesLazyQuery>;
export type AuthScopesSuspenseQueryHookResult = ReturnType<typeof useAuthScopesSuspenseQuery>;
export type AuthScopesQueryResult = Apollo.QueryResult<AuthScopesQuery, AuthScopesQueryVariables>;
export const CreateAuthClientDocument = gql`
    mutation CreateAuthClient($input: CreateAuthClientInput!) {
  createAuthClient(input: $input) {
    client {
      id
      clientId
      clientName
      description
      scopes {
        id
        label
        description
        group
      }
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
      lastUsedAt
    }
    clientSecret
  }
}
    `;
export type CreateAuthClientMutationFn = Apollo.MutationFunction<CreateAuthClientMutation, CreateAuthClientMutationVariables>;

/**
 * __useCreateAuthClientMutation__
 *
 * To run a mutation, you first call `useCreateAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthClientMutation, { data, loading, error }] = useCreateAuthClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthClientMutation, CreateAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuthClientMutation, CreateAuthClientMutationVariables>(CreateAuthClientDocument, options);
      }
export type CreateAuthClientMutationHookResult = ReturnType<typeof useCreateAuthClientMutation>;
export type CreateAuthClientMutationResult = Apollo.MutationResult<CreateAuthClientMutation>;
export type CreateAuthClientMutationOptions = Apollo.BaseMutationOptions<CreateAuthClientMutation, CreateAuthClientMutationVariables>;
export const UpdateAuthClientDocument = gql`
    mutation UpdateAuthClient($input: UpdateAuthClientInput!) {
  updateAuthClient(input: $input) {
    id
    clientId
    clientName
    description
    scopes {
      id
      label
      description
      group
    }
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
    lastUsedAt
  }
}
    `;
export type UpdateAuthClientMutationFn = Apollo.MutationFunction<UpdateAuthClientMutation, UpdateAuthClientMutationVariables>;

/**
 * __useUpdateAuthClientMutation__
 *
 * To run a mutation, you first call `useUpdateAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthClientMutation, { data, loading, error }] = useUpdateAuthClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuthClientMutation, UpdateAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthClientMutation, UpdateAuthClientMutationVariables>(UpdateAuthClientDocument, options);
      }
export type UpdateAuthClientMutationHookResult = ReturnType<typeof useUpdateAuthClientMutation>;
export type UpdateAuthClientMutationResult = Apollo.MutationResult<UpdateAuthClientMutation>;
export type UpdateAuthClientMutationOptions = Apollo.BaseMutationOptions<UpdateAuthClientMutation, UpdateAuthClientMutationVariables>;
export const DeleteAuthClientDocument = gql`
    mutation DeleteAuthClient($id: ID!) {
  deleteAuthClient(id: $id)
}
    `;
export type DeleteAuthClientMutationFn = Apollo.MutationFunction<DeleteAuthClientMutation, DeleteAuthClientMutationVariables>;

/**
 * __useDeleteAuthClientMutation__
 *
 * To run a mutation, you first call `useDeleteAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthClientMutation, { data, loading, error }] = useDeleteAuthClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAuthClientMutation, DeleteAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAuthClientMutation, DeleteAuthClientMutationVariables>(DeleteAuthClientDocument, options);
      }
export type DeleteAuthClientMutationHookResult = ReturnType<typeof useDeleteAuthClientMutation>;
export type DeleteAuthClientMutationResult = Apollo.MutationResult<DeleteAuthClientMutation>;
export type DeleteAuthClientMutationOptions = Apollo.BaseMutationOptions<DeleteAuthClientMutation, DeleteAuthClientMutationVariables>;
export const GetOrganisationTalentsDocument = gql`
    query GetOrganisationTalents($input: OrganisationTalentSearchInput) {
  organisationTalents(input: $input) {
    ...OrganisationTalent_ListItem
  }
}
    ${OrganisationTalent_ListItemFragmentDoc}`;

/**
 * __useGetOrganisationTalentsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTalentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganisationTalentsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>(GetOrganisationTalentsDocument, options);
      }
export function useGetOrganisationTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>(GetOrganisationTalentsDocument, options);
        }
// @ts-ignore
export function useGetOrganisationTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>;
export function useGetOrganisationTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationTalentsQuery | undefined, GetOrganisationTalentsQueryVariables>;
export function useGetOrganisationTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>(GetOrganisationTalentsDocument, options);
        }
export type GetOrganisationTalentsQueryHookResult = ReturnType<typeof useGetOrganisationTalentsQuery>;
export type GetOrganisationTalentsLazyQueryHookResult = ReturnType<typeof useGetOrganisationTalentsLazyQuery>;
export type GetOrganisationTalentsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationTalentsSuspenseQuery>;
export type GetOrganisationTalentsQueryResult = Apollo.QueryResult<GetOrganisationTalentsQuery, GetOrganisationTalentsQueryVariables>;
export const GetOrganisationTalentDetailsDocument = gql`
    query GetOrganisationTalentDetails($id: ID!) {
  organisationTalent(id: $id) {
    ...OrganisationTalent_Detail
  }
}
    ${OrganisationTalent_DetailFragmentDoc}`;

/**
 * __useGetOrganisationTalentDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTalentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTalentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTalentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganisationTalentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables> & ({ variables: GetOrganisationTalentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>(GetOrganisationTalentDetailsDocument, options);
      }
export function useGetOrganisationTalentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>(GetOrganisationTalentDetailsDocument, options);
        }
// @ts-ignore
export function useGetOrganisationTalentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>;
export function useGetOrganisationTalentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationTalentDetailsQuery | undefined, GetOrganisationTalentDetailsQueryVariables>;
export function useGetOrganisationTalentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>(GetOrganisationTalentDetailsDocument, options);
        }
export type GetOrganisationTalentDetailsQueryHookResult = ReturnType<typeof useGetOrganisationTalentDetailsQuery>;
export type GetOrganisationTalentDetailsLazyQueryHookResult = ReturnType<typeof useGetOrganisationTalentDetailsLazyQuery>;
export type GetOrganisationTalentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationTalentDetailsSuspenseQuery>;
export type GetOrganisationTalentDetailsQueryResult = Apollo.QueryResult<GetOrganisationTalentDetailsQuery, GetOrganisationTalentDetailsQueryVariables>;
export const GetOrganisationTalentDocumentsDocument = gql`
    query GetOrganisationTalentDocuments($id: ID!) {
  organisationTalent(id: $id) {
    id
    documents {
      id
      fileName
      type
      availableFormats {
        isOriginal
        downloadUrl
        mimeType
      }
    }
  }
}
    `;

/**
 * __useGetOrganisationTalentDocumentsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationTalentDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationTalentDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationTalentDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganisationTalentDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables> & ({ variables: GetOrganisationTalentDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>(GetOrganisationTalentDocumentsDocument, options);
      }
export function useGetOrganisationTalentDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>(GetOrganisationTalentDocumentsDocument, options);
        }
// @ts-ignore
export function useGetOrganisationTalentDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>;
export function useGetOrganisationTalentDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationTalentDocumentsQuery | undefined, GetOrganisationTalentDocumentsQueryVariables>;
export function useGetOrganisationTalentDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>(GetOrganisationTalentDocumentsDocument, options);
        }
export type GetOrganisationTalentDocumentsQueryHookResult = ReturnType<typeof useGetOrganisationTalentDocumentsQuery>;
export type GetOrganisationTalentDocumentsLazyQueryHookResult = ReturnType<typeof useGetOrganisationTalentDocumentsLazyQuery>;
export type GetOrganisationTalentDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationTalentDocumentsSuspenseQuery>;
export type GetOrganisationTalentDocumentsQueryResult = Apollo.QueryResult<GetOrganisationTalentDocumentsQuery, GetOrganisationTalentDocumentsQueryVariables>;
export const GetMyCoursesDocument = gql`
    query GetMyCourses {
  myCourses {
    id
    title
    url
    imageUrl
    authorName
    enrolmentStatus
    mandatory
    hasEvents
    hasAssessments
    categories {
      id
      name
    }
  }
}
    `;

/**
 * __useGetMyCoursesQuery__
 *
 * To run a query within a React component, call `useGetMyCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCoursesQuery, GetMyCoursesQueryVariables>(GetMyCoursesDocument, options);
      }
export function useGetMyCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCoursesQuery, GetMyCoursesQueryVariables>(GetMyCoursesDocument, options);
        }
// @ts-ignore
export function useGetMyCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCoursesQuery, GetMyCoursesQueryVariables>;
export function useGetMyCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCoursesQuery | undefined, GetMyCoursesQueryVariables>;
export function useGetMyCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCoursesQuery, GetMyCoursesQueryVariables>(GetMyCoursesDocument, options);
        }
export type GetMyCoursesQueryHookResult = ReturnType<typeof useGetMyCoursesQuery>;
export type GetMyCoursesLazyQueryHookResult = ReturnType<typeof useGetMyCoursesLazyQuery>;
export type GetMyCoursesSuspenseQueryHookResult = ReturnType<typeof useGetMyCoursesSuspenseQuery>;
export type GetMyCoursesQueryResult = Apollo.QueryResult<GetMyCoursesQuery, GetMyCoursesQueryVariables>;
export const GetDivisionsDocument = gql`
    query getDivisions {
  divisions {
    id
    organisationId
    name
    description
    parentId
    isDefault
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetDivisionsQuery__
 *
 * To run a query within a React component, call `useGetDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDivisionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDivisionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, options);
      }
export function useGetDivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, options);
        }
// @ts-ignore
export function useGetDivisionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDivisionsQuery, GetDivisionsQueryVariables>;
export function useGetDivisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDivisionsQuery | undefined, GetDivisionsQueryVariables>;
export function useGetDivisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, options);
        }
export type GetDivisionsQueryHookResult = ReturnType<typeof useGetDivisionsQuery>;
export type GetDivisionsLazyQueryHookResult = ReturnType<typeof useGetDivisionsLazyQuery>;
export type GetDivisionsSuspenseQueryHookResult = ReturnType<typeof useGetDivisionsSuspenseQuery>;
export type GetDivisionsQueryResult = Apollo.QueryResult<GetDivisionsQuery, GetDivisionsQueryVariables>;
export const GetGroupsDocument = gql`
    query getGroups($search: String) {
  groups(search: $search) {
    organisationId
    id
    name
    memberCount
    members {
      id
    }
    description
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
// @ts-ignore
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsQuery | undefined, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsSuspenseQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetGroupDocument = gql`
    query getGroup($id: ID!) {
  group(id: $id) {
    organisationId
    name
    memberCount
    members {
      id
    }
    description
  }
}
    `;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables> & ({ variables: GetGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
// @ts-ignore
export function useGetGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupQuery, GetGroupQueryVariables>;
export function useGetGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupQuery | undefined, GetGroupQueryVariables>;
export function useGetGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupSuspenseQueryHookResult = ReturnType<typeof useGetGroupSuspenseQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($name: String!, $description: String) {
  groupCreate(input: {name: $name, description: $description}) {
    group {
      id
      organisationId
      name
      members {
        id
      }
      description
    }
    errors {
      message
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($id: ID!, $name: String!, $description: String) {
  groupEdit(input: {id: $id, name: $name, description: $description}) {
    group {
      id
      organisationId
      name
      members {
        id
      }
      description
    }
    errors {
      message
    }
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($id: ID!) {
  groupDelete(id: $id) {
    group {
      id
      organisationId
      name
      members {
        id
      }
      description
    }
  }
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const GroupAssignUserDocument = gql`
    mutation groupAssignUser($groupId: ID!, $memberId: ID!) {
  groupAssignUser(input: {groupId: $groupId, memberId: $memberId}) {
    groupMember {
      groupId
      memberId
      memberType
      organisationId
      role
      roleDisplayName
    }
    errors {
      message
    }
  }
}
    `;
export type GroupAssignUserMutationFn = Apollo.MutationFunction<GroupAssignUserMutation, GroupAssignUserMutationVariables>;

/**
 * __useGroupAssignUserMutation__
 *
 * To run a mutation, you first call `useGroupAssignUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupAssignUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupAssignUserMutation, { data, loading, error }] = useGroupAssignUserMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGroupAssignUserMutation(baseOptions?: Apollo.MutationHookOptions<GroupAssignUserMutation, GroupAssignUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupAssignUserMutation, GroupAssignUserMutationVariables>(GroupAssignUserDocument, options);
      }
export type GroupAssignUserMutationHookResult = ReturnType<typeof useGroupAssignUserMutation>;
export type GroupAssignUserMutationResult = Apollo.MutationResult<GroupAssignUserMutation>;
export type GroupAssignUserMutationOptions = Apollo.BaseMutationOptions<GroupAssignUserMutation, GroupAssignUserMutationVariables>;
export const AssignUserGroupRoleDocument = gql`
    mutation assignUserGroupRole($groupId: ID!, $memberId: ID!, $role: GroupRole) {
  assignGroupRole(input: {groupId: $groupId, memberId: $memberId, role: $role}) {
    groupMember {
      groupId
      memberId
      memberType
      organisationId
      role
      roleDisplayName
    }
  }
}
    `;
export type AssignUserGroupRoleMutationFn = Apollo.MutationFunction<AssignUserGroupRoleMutation, AssignUserGroupRoleMutationVariables>;

/**
 * __useAssignUserGroupRoleMutation__
 *
 * To run a mutation, you first call `useAssignUserGroupRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserGroupRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUserGroupRoleMutation, { data, loading, error }] = useAssignUserGroupRoleMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      memberId: // value for 'memberId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAssignUserGroupRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignUserGroupRoleMutation, AssignUserGroupRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUserGroupRoleMutation, AssignUserGroupRoleMutationVariables>(AssignUserGroupRoleDocument, options);
      }
export type AssignUserGroupRoleMutationHookResult = ReturnType<typeof useAssignUserGroupRoleMutation>;
export type AssignUserGroupRoleMutationResult = Apollo.MutationResult<AssignUserGroupRoleMutation>;
export type AssignUserGroupRoleMutationOptions = Apollo.BaseMutationOptions<AssignUserGroupRoleMutation, AssignUserGroupRoleMutationVariables>;
export const GroupUnassignUserDocument = gql`
    mutation groupUnassignUser($groupId: ID!, $memberId: ID!) {
  groupUnassignUser(input: {groupId: $groupId, memberId: $memberId}) {
    groupMember {
      groupId
      memberId
      memberType
      organisationId
      role
      roleDisplayName
    }
    errors {
      message
    }
  }
}
    `;
export type GroupUnassignUserMutationFn = Apollo.MutationFunction<GroupUnassignUserMutation, GroupUnassignUserMutationVariables>;

/**
 * __useGroupUnassignUserMutation__
 *
 * To run a mutation, you first call `useGroupUnassignUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupUnassignUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupUnassignUserMutation, { data, loading, error }] = useGroupUnassignUserMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGroupUnassignUserMutation(baseOptions?: Apollo.MutationHookOptions<GroupUnassignUserMutation, GroupUnassignUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupUnassignUserMutation, GroupUnassignUserMutationVariables>(GroupUnassignUserDocument, options);
      }
export type GroupUnassignUserMutationHookResult = ReturnType<typeof useGroupUnassignUserMutation>;
export type GroupUnassignUserMutationResult = Apollo.MutationResult<GroupUnassignUserMutation>;
export type GroupUnassignUserMutationOptions = Apollo.BaseMutationOptions<GroupUnassignUserMutation, GroupUnassignUserMutationVariables>;
export const GroupMembersDocument = gql`
    query groupMembers($groupId: ID!) {
  groupMembers(input: {groupId: $groupId}) {
    memberId
    organisationId
    groupId
    memberType
    role
    roleDisplayName
  }
}
    `;

/**
 * __useGroupMembersQuery__
 *
 * To run a query within a React component, call `useGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMembersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables> & ({ variables: GroupMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
      }
export function useGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
        }
// @ts-ignore
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GroupMembersQuery, GroupMembersQueryVariables>;
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GroupMembersQuery | undefined, GroupMembersQueryVariables>;
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
        }
export type GroupMembersQueryHookResult = ReturnType<typeof useGroupMembersQuery>;
export type GroupMembersLazyQueryHookResult = ReturnType<typeof useGroupMembersLazyQuery>;
export type GroupMembersSuspenseQueryHookResult = ReturnType<typeof useGroupMembersSuspenseQuery>;
export type GroupMembersQueryResult = Apollo.QueryResult<GroupMembersQuery, GroupMembersQueryVariables>;
export const UserGroupMembersDocument = gql`
    query userGroupMembers($memberId: ID!) {
  userGroupMembers(input: {memberId: $memberId}) {
    memberId
    organisationId
    groupId
    memberType
    role
    roleDisplayName
  }
}
    `;

/**
 * __useUserGroupMembersQuery__
 *
 * To run a query within a React component, call `useUserGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupMembersQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useUserGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<UserGroupMembersQuery, UserGroupMembersQueryVariables> & ({ variables: UserGroupMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGroupMembersQuery, UserGroupMembersQueryVariables>(UserGroupMembersDocument, options);
      }
export function useUserGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupMembersQuery, UserGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGroupMembersQuery, UserGroupMembersQueryVariables>(UserGroupMembersDocument, options);
        }
// @ts-ignore
export function useUserGroupMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupMembersQuery, UserGroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<UserGroupMembersQuery, UserGroupMembersQueryVariables>;
export function useUserGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGroupMembersQuery, UserGroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<UserGroupMembersQuery | undefined, UserGroupMembersQueryVariables>;
export function useUserGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGroupMembersQuery, UserGroupMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGroupMembersQuery, UserGroupMembersQueryVariables>(UserGroupMembersDocument, options);
        }
export type UserGroupMembersQueryHookResult = ReturnType<typeof useUserGroupMembersQuery>;
export type UserGroupMembersLazyQueryHookResult = ReturnType<typeof useUserGroupMembersLazyQuery>;
export type UserGroupMembersSuspenseQueryHookResult = ReturnType<typeof useUserGroupMembersSuspenseQuery>;
export type UserGroupMembersQueryResult = Apollo.QueryResult<UserGroupMembersQuery, UserGroupMembersQueryVariables>;
export const GetGuideQuestionsDocument = gql`
    query getGuideQuestions {
  organisationReferenceQuestions {
    id
    organisation {
      id
    }
    questionLabel
    helperText
    placeholderText
    enabled
    order
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetGuideQuestionsQuery__
 *
 * To run a query within a React component, call `useGetGuideQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuideQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuideQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGuideQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>(GetGuideQuestionsDocument, options);
      }
export function useGetGuideQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>(GetGuideQuestionsDocument, options);
        }
// @ts-ignore
export function useGetGuideQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>;
export function useGetGuideQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuideQuestionsQuery | undefined, GetGuideQuestionsQueryVariables>;
export function useGetGuideQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>(GetGuideQuestionsDocument, options);
        }
export type GetGuideQuestionsQueryHookResult = ReturnType<typeof useGetGuideQuestionsQuery>;
export type GetGuideQuestionsLazyQueryHookResult = ReturnType<typeof useGetGuideQuestionsLazyQuery>;
export type GetGuideQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetGuideQuestionsSuspenseQuery>;
export type GetGuideQuestionsQueryResult = Apollo.QueryResult<GetGuideQuestionsQuery, GetGuideQuestionsQueryVariables>;
export const GetGuideQuestionDocument = gql`
    query getGuideQuestion($id: ID!) {
  organisationReferenceQuestion(id: $id) {
    id
    organisation {
      id
    }
    questionLabel
    helperText
    placeholderText
    enabled
    order
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetGuideQuestionQuery__
 *
 * To run a query within a React component, call `useGetGuideQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuideQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuideQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGuideQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetGuideQuestionQuery, GetGuideQuestionQueryVariables> & ({ variables: GetGuideQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>(GetGuideQuestionDocument, options);
      }
export function useGetGuideQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>(GetGuideQuestionDocument, options);
        }
// @ts-ignore
export function useGetGuideQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>;
export function useGetGuideQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuideQuestionQuery | undefined, GetGuideQuestionQueryVariables>;
export function useGetGuideQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>(GetGuideQuestionDocument, options);
        }
export type GetGuideQuestionQueryHookResult = ReturnType<typeof useGetGuideQuestionQuery>;
export type GetGuideQuestionLazyQueryHookResult = ReturnType<typeof useGetGuideQuestionLazyQuery>;
export type GetGuideQuestionSuspenseQueryHookResult = ReturnType<typeof useGetGuideQuestionSuspenseQuery>;
export type GetGuideQuestionQueryResult = Apollo.QueryResult<GetGuideQuestionQuery, GetGuideQuestionQueryVariables>;
export const CreateGuideQuestionDocument = gql`
    mutation createGuideQuestion($input: OrganisationReferenceQuestionCreateInput!) {
  organisationReferenceQuestionCreate(input: $input) {
    question {
      id
      organisation {
        id
      }
      questionLabel
      helperText
      placeholderText
      enabled
      order
      createdAt
      updatedAt
    }
    errors {
      message
      code
    }
  }
}
    `;
export type CreateGuideQuestionMutationFn = Apollo.MutationFunction<CreateGuideQuestionMutation, CreateGuideQuestionMutationVariables>;

/**
 * __useCreateGuideQuestionMutation__
 *
 * To run a mutation, you first call `useCreateGuideQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuideQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGuideQuestionMutation, { data, loading, error }] = useCreateGuideQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGuideQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateGuideQuestionMutation, CreateGuideQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGuideQuestionMutation, CreateGuideQuestionMutationVariables>(CreateGuideQuestionDocument, options);
      }
export type CreateGuideQuestionMutationHookResult = ReturnType<typeof useCreateGuideQuestionMutation>;
export type CreateGuideQuestionMutationResult = Apollo.MutationResult<CreateGuideQuestionMutation>;
export type CreateGuideQuestionMutationOptions = Apollo.BaseMutationOptions<CreateGuideQuestionMutation, CreateGuideQuestionMutationVariables>;
export const UpdateGuideQuestionDocument = gql`
    mutation updateGuideQuestion($id: ID!, $input: OrganisationReferenceQuestionUpdateInput!) {
  organisationReferenceQuestionUpdate(id: $id, input: $input) {
    question {
      id
      organisation {
        id
      }
      questionLabel
      helperText
      placeholderText
      enabled
      order
      createdAt
      updatedAt
    }
    errors {
      message
      code
    }
  }
}
    `;
export type UpdateGuideQuestionMutationFn = Apollo.MutationFunction<UpdateGuideQuestionMutation, UpdateGuideQuestionMutationVariables>;

/**
 * __useUpdateGuideQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateGuideQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuideQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuideQuestionMutation, { data, loading, error }] = useUpdateGuideQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGuideQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuideQuestionMutation, UpdateGuideQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuideQuestionMutation, UpdateGuideQuestionMutationVariables>(UpdateGuideQuestionDocument, options);
      }
export type UpdateGuideQuestionMutationHookResult = ReturnType<typeof useUpdateGuideQuestionMutation>;
export type UpdateGuideQuestionMutationResult = Apollo.MutationResult<UpdateGuideQuestionMutation>;
export type UpdateGuideQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateGuideQuestionMutation, UpdateGuideQuestionMutationVariables>;
export const DeleteGuideQuestionDocument = gql`
    mutation deleteGuideQuestion($id: ID!) {
  organisationReferenceQuestionDelete(id: $id) {
    question {
      id
      organisation {
        id
      }
      questionLabel
    }
    errors {
      message
      code
    }
  }
}
    `;
export type DeleteGuideQuestionMutationFn = Apollo.MutationFunction<DeleteGuideQuestionMutation, DeleteGuideQuestionMutationVariables>;

/**
 * __useDeleteGuideQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteGuideQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGuideQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGuideQuestionMutation, { data, loading, error }] = useDeleteGuideQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGuideQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGuideQuestionMutation, DeleteGuideQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGuideQuestionMutation, DeleteGuideQuestionMutationVariables>(DeleteGuideQuestionDocument, options);
      }
export type DeleteGuideQuestionMutationHookResult = ReturnType<typeof useDeleteGuideQuestionMutation>;
export type DeleteGuideQuestionMutationResult = Apollo.MutationResult<DeleteGuideQuestionMutation>;
export type DeleteGuideQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteGuideQuestionMutation, DeleteGuideQuestionMutationVariables>;
export const HireReportProcessDocument = gql`
    query hireReportProcess($startDate: String!, $endDate: String!, $hiringTeamIds: [String], $timezoneOffset: Int!) {
  hireReportProcess(params: {startDate: $startDate, endDate: $endDate, hiringTeamIds: $hiringTeamIds, timezoneOffset: $timezoneOffset}) {
    id
  }
}
    `;

/**
 * __useHireReportProcessQuery__
 *
 * To run a query within a React component, call `useHireReportProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useHireReportProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHireReportProcessQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      hiringTeamIds: // value for 'hiringTeamIds'
 *      timezoneOffset: // value for 'timezoneOffset'
 *   },
 * });
 */
export function useHireReportProcessQuery(baseOptions: Apollo.QueryHookOptions<HireReportProcessQuery, HireReportProcessQueryVariables> & ({ variables: HireReportProcessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HireReportProcessQuery, HireReportProcessQueryVariables>(HireReportProcessDocument, options);
      }
export function useHireReportProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HireReportProcessQuery, HireReportProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HireReportProcessQuery, HireReportProcessQueryVariables>(HireReportProcessDocument, options);
        }
// @ts-ignore
export function useHireReportProcessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HireReportProcessQuery, HireReportProcessQueryVariables>): Apollo.UseSuspenseQueryResult<HireReportProcessQuery, HireReportProcessQueryVariables>;
export function useHireReportProcessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HireReportProcessQuery, HireReportProcessQueryVariables>): Apollo.UseSuspenseQueryResult<HireReportProcessQuery | undefined, HireReportProcessQueryVariables>;
export function useHireReportProcessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HireReportProcessQuery, HireReportProcessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HireReportProcessQuery, HireReportProcessQueryVariables>(HireReportProcessDocument, options);
        }
export type HireReportProcessQueryHookResult = ReturnType<typeof useHireReportProcessQuery>;
export type HireReportProcessLazyQueryHookResult = ReturnType<typeof useHireReportProcessLazyQuery>;
export type HireReportProcessSuspenseQueryHookResult = ReturnType<typeof useHireReportProcessSuspenseQuery>;
export type HireReportProcessQueryResult = Apollo.QueryResult<HireReportProcessQuery, HireReportProcessQueryVariables>;
export const HireReportResultDocument = gql`
    query hireReportResult($id: ID!) {
  hireReportResult(id: $id) {
    id
    report {
      aggregates {
        jobsOpenAtStartDate
        jobsOpenAtEndDate
        jobsOpenedInPeriod
        jobsClosedInPeriod
        totalApplications
        totalHires
        avgTimeToFillInDays
        avgTimeToHireInDays
      }
      applicationSources {
        all {
          name
          count
        }
        hired {
          name
          count
        }
      }
    }
    export {
      csvUrl
      noOfEntries
    }
  }
}
    `;

/**
 * __useHireReportResultQuery__
 *
 * To run a query within a React component, call `useHireReportResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useHireReportResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHireReportResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHireReportResultQuery(baseOptions: Apollo.QueryHookOptions<HireReportResultQuery, HireReportResultQueryVariables> & ({ variables: HireReportResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HireReportResultQuery, HireReportResultQueryVariables>(HireReportResultDocument, options);
      }
export function useHireReportResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HireReportResultQuery, HireReportResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HireReportResultQuery, HireReportResultQueryVariables>(HireReportResultDocument, options);
        }
// @ts-ignore
export function useHireReportResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HireReportResultQuery, HireReportResultQueryVariables>): Apollo.UseSuspenseQueryResult<HireReportResultQuery, HireReportResultQueryVariables>;
export function useHireReportResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HireReportResultQuery, HireReportResultQueryVariables>): Apollo.UseSuspenseQueryResult<HireReportResultQuery | undefined, HireReportResultQueryVariables>;
export function useHireReportResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HireReportResultQuery, HireReportResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HireReportResultQuery, HireReportResultQueryVariables>(HireReportResultDocument, options);
        }
export type HireReportResultQueryHookResult = ReturnType<typeof useHireReportResultQuery>;
export type HireReportResultLazyQueryHookResult = ReturnType<typeof useHireReportResultLazyQuery>;
export type HireReportResultSuspenseQueryHookResult = ReturnType<typeof useHireReportResultSuspenseQuery>;
export type HireReportResultQueryResult = Apollo.QueryResult<HireReportResultQuery, HireReportResultQueryVariables>;
export const GetMessageTemplateDocument = gql`
    query getMessageTemplate($id: ID!) {
  messageTemplate(id: $id) {
    organisationId
    id
    name
    description
    subject
    content
    enabled
  }
}
    `;

/**
 * __useGetMessageTemplateQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMessageTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables> & ({ variables: GetMessageTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
      }
export function useGetMessageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
        }
// @ts-ignore
export function useGetMessageTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>;
export function useGetMessageTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageTemplateQuery | undefined, GetMessageTemplateQueryVariables>;
export function useGetMessageTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
        }
export type GetMessageTemplateQueryHookResult = ReturnType<typeof useGetMessageTemplateQuery>;
export type GetMessageTemplateLazyQueryHookResult = ReturnType<typeof useGetMessageTemplateLazyQuery>;
export type GetMessageTemplateSuspenseQueryHookResult = ReturnType<typeof useGetMessageTemplateSuspenseQuery>;
export type GetMessageTemplateQueryResult = Apollo.QueryResult<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>;
export const GetMessageTemplateGenerateDocument = gql`
    query getMessageTemplateGenerate($prompt: String!, $tone: String!, $previousAnswer: String, $additionalInstruction: String) {
  messageTemplateGenerate(prompt: $prompt, tone: $tone, previousAnswer: $previousAnswer, additionalInstruction: $additionalInstruction) {
    messageTemplateGenerated {
      subject
      content
    }
    errors {
      message
    }
  }
}
    `;

/**
 * __useGetMessageTemplateGenerateQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplateGenerateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplateGenerateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplateGenerateQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      tone: // value for 'tone'
 *      previousAnswer: // value for 'previousAnswer'
 *      additionalInstruction: // value for 'additionalInstruction'
 *   },
 * });
 */
export function useGetMessageTemplateGenerateQuery(baseOptions: Apollo.QueryHookOptions<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables> & ({ variables: GetMessageTemplateGenerateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>(GetMessageTemplateGenerateDocument, options);
      }
export function useGetMessageTemplateGenerateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>(GetMessageTemplateGenerateDocument, options);
        }
// @ts-ignore
export function useGetMessageTemplateGenerateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>;
export function useGetMessageTemplateGenerateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageTemplateGenerateQuery | undefined, GetMessageTemplateGenerateQueryVariables>;
export function useGetMessageTemplateGenerateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>(GetMessageTemplateGenerateDocument, options);
        }
export type GetMessageTemplateGenerateQueryHookResult = ReturnType<typeof useGetMessageTemplateGenerateQuery>;
export type GetMessageTemplateGenerateLazyQueryHookResult = ReturnType<typeof useGetMessageTemplateGenerateLazyQuery>;
export type GetMessageTemplateGenerateSuspenseQueryHookResult = ReturnType<typeof useGetMessageTemplateGenerateSuspenseQuery>;
export type GetMessageTemplateGenerateQueryResult = Apollo.QueryResult<GetMessageTemplateGenerateQuery, GetMessageTemplateGenerateQueryVariables>;
export const CreateMessageTemplateDocument = gql`
    mutation createMessageTemplate($name: String!, $description: String, $subject: String!, $content: String!) {
  messageTemplateCreate(input: {name: $name, description: $description, subject: $subject, content: $content, enabled: false}) {
    messageTemplate {
      id
      organisationId
      name
      subject
      content
      description
      enabled
    }
    errors {
      message
    }
  }
}
    `;
export type CreateMessageTemplateMutationFn = Apollo.MutationFunction<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;

/**
 * __useCreateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageTemplateMutation, { data, loading, error }] = useCreateMessageTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      subject: // value for 'subject'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>(CreateMessageTemplateDocument, options);
      }
export type CreateMessageTemplateMutationHookResult = ReturnType<typeof useCreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationResult = Apollo.MutationResult<CreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;
export const UpdateMessageTemplateDocument = gql`
    mutation updateMessageTemplate($id: ID!, $name: String, $description: String, $subject: String, $content: String, $enabled: Boolean) {
  messageTemplateUpdate(input: {id: $id, name: $name, description: $description, subject: $subject, content: $content, enabled: $enabled}) {
    messageTemplate {
      id
      organisationId
      name
      description
      subject
      content
      enabled
    }
    errors {
      message
    }
  }
}
    `;
export type UpdateMessageTemplateMutationFn = Apollo.MutationFunction<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;

/**
 * __useUpdateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageTemplateMutation, { data, loading, error }] = useUpdateMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      subject: // value for 'subject'
 *      content: // value for 'content'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>(UpdateMessageTemplateDocument, options);
      }
export type UpdateMessageTemplateMutationHookResult = ReturnType<typeof useUpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationResult = Apollo.MutationResult<UpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;
export const DeleteMessageTemplateDocument = gql`
    mutation deleteMessageTemplate($id: ID!) {
  messageTemplateDelete(id: $id) {
    messageTemplate {
      id
      organisationId
      name
      description
      subject
      content
      enabled
    }
  }
}
    `;
export type DeleteMessageTemplateMutationFn = Apollo.MutationFunction<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>;

/**
 * __useDeleteMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageTemplateMutation, { data, loading, error }] = useDeleteMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>(DeleteMessageTemplateDocument, options);
      }
export type DeleteMessageTemplateMutationHookResult = ReturnType<typeof useDeleteMessageTemplateMutation>;
export type DeleteMessageTemplateMutationResult = Apollo.MutationResult<DeleteMessageTemplateMutation>;
export type DeleteMessageTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>;
export const GetComponoAssistReactionDocument = gql`
    query GetComponoAssistReaction($input: GetComponoAssistReactionInput!) {
  getComponoAssistReaction(input: $input) {
    feedback
    data
  }
}
    `;

/**
 * __useGetComponoAssistReactionQuery__
 *
 * To run a query within a React component, call `useGetComponoAssistReactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponoAssistReactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponoAssistReactionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetComponoAssistReactionQuery(baseOptions: Apollo.QueryHookOptions<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables> & ({ variables: GetComponoAssistReactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>(GetComponoAssistReactionDocument, options);
      }
export function useGetComponoAssistReactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>(GetComponoAssistReactionDocument, options);
        }
// @ts-ignore
export function useGetComponoAssistReactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>;
export function useGetComponoAssistReactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetComponoAssistReactionQuery | undefined, GetComponoAssistReactionQueryVariables>;
export function useGetComponoAssistReactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>(GetComponoAssistReactionDocument, options);
        }
export type GetComponoAssistReactionQueryHookResult = ReturnType<typeof useGetComponoAssistReactionQuery>;
export type GetComponoAssistReactionLazyQueryHookResult = ReturnType<typeof useGetComponoAssistReactionLazyQuery>;
export type GetComponoAssistReactionSuspenseQueryHookResult = ReturnType<typeof useGetComponoAssistReactionSuspenseQuery>;
export type GetComponoAssistReactionQueryResult = Apollo.QueryResult<GetComponoAssistReactionQuery, GetComponoAssistReactionQueryVariables>;
export const SaveComponoAssistReactionDocument = gql`
    mutation SaveComponoAssistReaction($input: SaveComponoAssistReactionInput!) {
  saveComponoAssistReaction(input: $input) {
    feedback
    data
  }
}
    `;
export type SaveComponoAssistReactionMutationFn = Apollo.MutationFunction<SaveComponoAssistReactionMutation, SaveComponoAssistReactionMutationVariables>;

/**
 * __useSaveComponoAssistReactionMutation__
 *
 * To run a mutation, you first call `useSaveComponoAssistReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveComponoAssistReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveComponoAssistReactionMutation, { data, loading, error }] = useSaveComponoAssistReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveComponoAssistReactionMutation(baseOptions?: Apollo.MutationHookOptions<SaveComponoAssistReactionMutation, SaveComponoAssistReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveComponoAssistReactionMutation, SaveComponoAssistReactionMutationVariables>(SaveComponoAssistReactionDocument, options);
      }
export type SaveComponoAssistReactionMutationHookResult = ReturnType<typeof useSaveComponoAssistReactionMutation>;
export type SaveComponoAssistReactionMutationResult = Apollo.MutationResult<SaveComponoAssistReactionMutation>;
export type SaveComponoAssistReactionMutationOptions = Apollo.BaseMutationOptions<SaveComponoAssistReactionMutation, SaveComponoAssistReactionMutationVariables>;
export const GetApplicationReferencesDocument = gql`
    query getApplicationReferences($id: ID!) {
  application(id: $id) {
    id
    references {
      id
      requestId
      name
      relationship
      company
      phone
      email
      status
      source
      submittedAt
      editedAt
      dateContacted
      guideQuestions {
        questionId
        questionLabel
        helperText
        placeholderText
        order
        response
      }
      overallRating
      wouldRehire
      additionalNotes
      completedAt
      completedBy
      createdAt
      updatedAt
    }
    referenceRequests {
      id
      requestedBy
      requestedAt
      requiredCount
      deadline
      messageSubject
      messageBody
    }
    referenceStatusSummary {
      total
      pending
      sent
      completed
      declined
    }
  }
}
    `;

/**
 * __useGetApplicationReferencesQuery__
 *
 * To run a query within a React component, call `useGetApplicationReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationReferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationReferencesQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables> & ({ variables: GetApplicationReferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>(GetApplicationReferencesDocument, options);
      }
export function useGetApplicationReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>(GetApplicationReferencesDocument, options);
        }
// @ts-ignore
export function useGetApplicationReferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>;
export function useGetApplicationReferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationReferencesQuery | undefined, GetApplicationReferencesQueryVariables>;
export function useGetApplicationReferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>(GetApplicationReferencesDocument, options);
        }
export type GetApplicationReferencesQueryHookResult = ReturnType<typeof useGetApplicationReferencesQuery>;
export type GetApplicationReferencesLazyQueryHookResult = ReturnType<typeof useGetApplicationReferencesLazyQuery>;
export type GetApplicationReferencesSuspenseQueryHookResult = ReturnType<typeof useGetApplicationReferencesSuspenseQuery>;
export type GetApplicationReferencesQueryResult = Apollo.QueryResult<GetApplicationReferencesQuery, GetApplicationReferencesQueryVariables>;
export const ApplicationReferencesRequestDocument = gql`
    mutation applicationReferencesRequest($id: ID!, $input: RequestReferencesInput!) {
  applicationReferencesRequest(id: $id, input: $input) {
    application {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationReferencesRequestMutationFn = Apollo.MutationFunction<ApplicationReferencesRequestMutation, ApplicationReferencesRequestMutationVariables>;

/**
 * __useApplicationReferencesRequestMutation__
 *
 * To run a mutation, you first call `useApplicationReferencesRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationReferencesRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationReferencesRequestMutation, { data, loading, error }] = useApplicationReferencesRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationReferencesRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationReferencesRequestMutation, ApplicationReferencesRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationReferencesRequestMutation, ApplicationReferencesRequestMutationVariables>(ApplicationReferencesRequestDocument, options);
      }
export type ApplicationReferencesRequestMutationHookResult = ReturnType<typeof useApplicationReferencesRequestMutation>;
export type ApplicationReferencesRequestMutationResult = Apollo.MutationResult<ApplicationReferencesRequestMutation>;
export type ApplicationReferencesRequestMutationOptions = Apollo.BaseMutationOptions<ApplicationReferencesRequestMutation, ApplicationReferencesRequestMutationVariables>;
export const ApplicationReferenceAddDocument = gql`
    mutation applicationReferenceAdd($applicationId: ID!, $input: ApplicationReferenceAddInput!) {
  applicationReferenceAdd(applicationId: $applicationId, input: $input) {
    application {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationReferenceAddMutationFn = Apollo.MutationFunction<ApplicationReferenceAddMutation, ApplicationReferenceAddMutationVariables>;

/**
 * __useApplicationReferenceAddMutation__
 *
 * To run a mutation, you first call `useApplicationReferenceAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationReferenceAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationReferenceAddMutation, { data, loading, error }] = useApplicationReferenceAddMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationReferenceAddMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationReferenceAddMutation, ApplicationReferenceAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationReferenceAddMutation, ApplicationReferenceAddMutationVariables>(ApplicationReferenceAddDocument, options);
      }
export type ApplicationReferenceAddMutationHookResult = ReturnType<typeof useApplicationReferenceAddMutation>;
export type ApplicationReferenceAddMutationResult = Apollo.MutationResult<ApplicationReferenceAddMutation>;
export type ApplicationReferenceAddMutationOptions = Apollo.BaseMutationOptions<ApplicationReferenceAddMutation, ApplicationReferenceAddMutationVariables>;
export const ApplicationReferenceCompleteDocument = gql`
    mutation applicationReferenceComplete($applicationId: ID!, $referenceId: ID!, $input: ReferenceResultsInput!) {
  applicationReferenceComplete(applicationId: $applicationId, referenceId: $referenceId, input: $input) {
    application {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationReferenceCompleteMutationFn = Apollo.MutationFunction<ApplicationReferenceCompleteMutation, ApplicationReferenceCompleteMutationVariables>;

/**
 * __useApplicationReferenceCompleteMutation__
 *
 * To run a mutation, you first call `useApplicationReferenceCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationReferenceCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationReferenceCompleteMutation, { data, loading, error }] = useApplicationReferenceCompleteMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      referenceId: // value for 'referenceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationReferenceCompleteMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationReferenceCompleteMutation, ApplicationReferenceCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationReferenceCompleteMutation, ApplicationReferenceCompleteMutationVariables>(ApplicationReferenceCompleteDocument, options);
      }
export type ApplicationReferenceCompleteMutationHookResult = ReturnType<typeof useApplicationReferenceCompleteMutation>;
export type ApplicationReferenceCompleteMutationResult = Apollo.MutationResult<ApplicationReferenceCompleteMutation>;
export type ApplicationReferenceCompleteMutationOptions = Apollo.BaseMutationOptions<ApplicationReferenceCompleteMutation, ApplicationReferenceCompleteMutationVariables>;
export const ApplicationReferenceUpdateResultsDocument = gql`
    mutation applicationReferenceUpdateResults($applicationId: ID!, $referenceId: ID!, $input: ReferenceResultsInput!) {
  applicationReferenceUpdateResults(applicationId: $applicationId, referenceId: $referenceId, input: $input) {
    application {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationReferenceUpdateResultsMutationFn = Apollo.MutationFunction<ApplicationReferenceUpdateResultsMutation, ApplicationReferenceUpdateResultsMutationVariables>;

/**
 * __useApplicationReferenceUpdateResultsMutation__
 *
 * To run a mutation, you first call `useApplicationReferenceUpdateResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationReferenceUpdateResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationReferenceUpdateResultsMutation, { data, loading, error }] = useApplicationReferenceUpdateResultsMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      referenceId: // value for 'referenceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationReferenceUpdateResultsMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationReferenceUpdateResultsMutation, ApplicationReferenceUpdateResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationReferenceUpdateResultsMutation, ApplicationReferenceUpdateResultsMutationVariables>(ApplicationReferenceUpdateResultsDocument, options);
      }
export type ApplicationReferenceUpdateResultsMutationHookResult = ReturnType<typeof useApplicationReferenceUpdateResultsMutation>;
export type ApplicationReferenceUpdateResultsMutationResult = Apollo.MutationResult<ApplicationReferenceUpdateResultsMutation>;
export type ApplicationReferenceUpdateResultsMutationOptions = Apollo.BaseMutationOptions<ApplicationReferenceUpdateResultsMutation, ApplicationReferenceUpdateResultsMutationVariables>;
export const ApplicationReferenceRemoveDocument = gql`
    mutation applicationReferenceRemove($applicationId: ID!, $referenceId: ID!) {
  applicationReferenceRemove(applicationId: $applicationId, referenceId: $referenceId) {
    application {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationReferenceRemoveMutationFn = Apollo.MutationFunction<ApplicationReferenceRemoveMutation, ApplicationReferenceRemoveMutationVariables>;

/**
 * __useApplicationReferenceRemoveMutation__
 *
 * To run a mutation, you first call `useApplicationReferenceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationReferenceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationReferenceRemoveMutation, { data, loading, error }] = useApplicationReferenceRemoveMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useApplicationReferenceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationReferenceRemoveMutation, ApplicationReferenceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationReferenceRemoveMutation, ApplicationReferenceRemoveMutationVariables>(ApplicationReferenceRemoveDocument, options);
      }
export type ApplicationReferenceRemoveMutationHookResult = ReturnType<typeof useApplicationReferenceRemoveMutation>;
export type ApplicationReferenceRemoveMutationResult = Apollo.MutationResult<ApplicationReferenceRemoveMutation>;
export type ApplicationReferenceRemoveMutationOptions = Apollo.BaseMutationOptions<ApplicationReferenceRemoveMutation, ApplicationReferenceRemoveMutationVariables>;
export const ApplicationReferenceEditDocument = gql`
    mutation applicationReferenceEdit($applicationId: ID!, $referenceId: ID!, $input: ApplicationReferenceAddInput!) {
  applicationReferenceEdit(applicationId: $applicationId, referenceId: $referenceId, input: $input) {
    application {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationReferenceEditMutationFn = Apollo.MutationFunction<ApplicationReferenceEditMutation, ApplicationReferenceEditMutationVariables>;

/**
 * __useApplicationReferenceEditMutation__
 *
 * To run a mutation, you first call `useApplicationReferenceEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationReferenceEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationReferenceEditMutation, { data, loading, error }] = useApplicationReferenceEditMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      referenceId: // value for 'referenceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationReferenceEditMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationReferenceEditMutation, ApplicationReferenceEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationReferenceEditMutation, ApplicationReferenceEditMutationVariables>(ApplicationReferenceEditDocument, options);
      }
export type ApplicationReferenceEditMutationHookResult = ReturnType<typeof useApplicationReferenceEditMutation>;
export type ApplicationReferenceEditMutationResult = Apollo.MutationResult<ApplicationReferenceEditMutation>;
export type ApplicationReferenceEditMutationOptions = Apollo.BaseMutationOptions<ApplicationReferenceEditMutation, ApplicationReferenceEditMutationVariables>;
export const ApplicationReferenceDeclineDocument = gql`
    mutation applicationReferenceDecline($applicationId: ID!, $referenceId: ID!) {
  applicationReferenceDecline(applicationId: $applicationId, referenceId: $referenceId) {
    application {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationReferenceDeclineMutationFn = Apollo.MutationFunction<ApplicationReferenceDeclineMutation, ApplicationReferenceDeclineMutationVariables>;

/**
 * __useApplicationReferenceDeclineMutation__
 *
 * To run a mutation, you first call `useApplicationReferenceDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationReferenceDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationReferenceDeclineMutation, { data, loading, error }] = useApplicationReferenceDeclineMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useApplicationReferenceDeclineMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationReferenceDeclineMutation, ApplicationReferenceDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationReferenceDeclineMutation, ApplicationReferenceDeclineMutationVariables>(ApplicationReferenceDeclineDocument, options);
      }
export type ApplicationReferenceDeclineMutationHookResult = ReturnType<typeof useApplicationReferenceDeclineMutation>;
export type ApplicationReferenceDeclineMutationResult = Apollo.MutationResult<ApplicationReferenceDeclineMutation>;
export type ApplicationReferenceDeclineMutationOptions = Apollo.BaseMutationOptions<ApplicationReferenceDeclineMutation, ApplicationReferenceDeclineMutationVariables>;
export const RehydrateSkillsDocument = gql`
    query RehydrateSkills($ids: [ID!]!) {
  rehydrateSkills(id: $ids) {
    id
    name
  }
}
    `;

/**
 * __useRehydrateSkillsQuery__
 *
 * To run a query within a React component, call `useRehydrateSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRehydrateSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRehydrateSkillsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRehydrateSkillsQuery(baseOptions: Apollo.QueryHookOptions<RehydrateSkillsQuery, RehydrateSkillsQueryVariables> & ({ variables: RehydrateSkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>(RehydrateSkillsDocument, options);
      }
export function useRehydrateSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>(RehydrateSkillsDocument, options);
        }
// @ts-ignore
export function useRehydrateSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>;
export function useRehydrateSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>): Apollo.UseSuspenseQueryResult<RehydrateSkillsQuery | undefined, RehydrateSkillsQueryVariables>;
export function useRehydrateSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>(RehydrateSkillsDocument, options);
        }
export type RehydrateSkillsQueryHookResult = ReturnType<typeof useRehydrateSkillsQuery>;
export type RehydrateSkillsLazyQueryHookResult = ReturnType<typeof useRehydrateSkillsLazyQuery>;
export type RehydrateSkillsSuspenseQueryHookResult = ReturnType<typeof useRehydrateSkillsSuspenseQuery>;
export type RehydrateSkillsQueryResult = Apollo.QueryResult<RehydrateSkillsQuery, RehydrateSkillsQueryVariables>;
export const RehydrateQualificationsDocument = gql`
    query RehydrateQualifications($ids: [ID!]!) {
  rehydrateQualifications(id: $ids) {
    id
    name
  }
}
    `;

/**
 * __useRehydrateQualificationsQuery__
 *
 * To run a query within a React component, call `useRehydrateQualificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRehydrateQualificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRehydrateQualificationsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRehydrateQualificationsQuery(baseOptions: Apollo.QueryHookOptions<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables> & ({ variables: RehydrateQualificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>(RehydrateQualificationsDocument, options);
      }
export function useRehydrateQualificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>(RehydrateQualificationsDocument, options);
        }
// @ts-ignore
export function useRehydrateQualificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>): Apollo.UseSuspenseQueryResult<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>;
export function useRehydrateQualificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>): Apollo.UseSuspenseQueryResult<RehydrateQualificationsQuery | undefined, RehydrateQualificationsQueryVariables>;
export function useRehydrateQualificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>(RehydrateQualificationsDocument, options);
        }
export type RehydrateQualificationsQueryHookResult = ReturnType<typeof useRehydrateQualificationsQuery>;
export type RehydrateQualificationsLazyQueryHookResult = ReturnType<typeof useRehydrateQualificationsLazyQuery>;
export type RehydrateQualificationsSuspenseQueryHookResult = ReturnType<typeof useRehydrateQualificationsSuspenseQuery>;
export type RehydrateQualificationsQueryResult = Apollo.QueryResult<RehydrateQualificationsQuery, RehydrateQualificationsQueryVariables>;
export const RehydrateWorkAreasDocument = gql`
    query RehydrateWorkAreas($ids: [ID!]!) {
  rehydrateWorkAreas(id: $ids) {
    id
    name
  }
}
    `;

/**
 * __useRehydrateWorkAreasQuery__
 *
 * To run a query within a React component, call `useRehydrateWorkAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useRehydrateWorkAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRehydrateWorkAreasQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRehydrateWorkAreasQuery(baseOptions: Apollo.QueryHookOptions<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables> & ({ variables: RehydrateWorkAreasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>(RehydrateWorkAreasDocument, options);
      }
export function useRehydrateWorkAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>(RehydrateWorkAreasDocument, options);
        }
// @ts-ignore
export function useRehydrateWorkAreasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>): Apollo.UseSuspenseQueryResult<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>;
export function useRehydrateWorkAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>): Apollo.UseSuspenseQueryResult<RehydrateWorkAreasQuery | undefined, RehydrateWorkAreasQueryVariables>;
export function useRehydrateWorkAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>(RehydrateWorkAreasDocument, options);
        }
export type RehydrateWorkAreasQueryHookResult = ReturnType<typeof useRehydrateWorkAreasQuery>;
export type RehydrateWorkAreasLazyQueryHookResult = ReturnType<typeof useRehydrateWorkAreasLazyQuery>;
export type RehydrateWorkAreasSuspenseQueryHookResult = ReturnType<typeof useRehydrateWorkAreasSuspenseQuery>;
export type RehydrateWorkAreasQueryResult = Apollo.QueryResult<RehydrateWorkAreasQuery, RehydrateWorkAreasQueryVariables>;
export const GetRequisitionDivisionsDocument = gql`
    query GetRequisitionDivisions {
  divisions {
    id
    name
    parentId
  }
}
    `;

/**
 * __useGetRequisitionDivisionsQuery__
 *
 * To run a query within a React component, call `useGetRequisitionDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionDivisionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequisitionDivisionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>(GetRequisitionDivisionsDocument, options);
      }
export function useGetRequisitionDivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>(GetRequisitionDivisionsDocument, options);
        }
// @ts-ignore
export function useGetRequisitionDivisionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>;
export function useGetRequisitionDivisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionDivisionsQuery | undefined, GetRequisitionDivisionsQueryVariables>;
export function useGetRequisitionDivisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>(GetRequisitionDivisionsDocument, options);
        }
export type GetRequisitionDivisionsQueryHookResult = ReturnType<typeof useGetRequisitionDivisionsQuery>;
export type GetRequisitionDivisionsLazyQueryHookResult = ReturnType<typeof useGetRequisitionDivisionsLazyQuery>;
export type GetRequisitionDivisionsSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionDivisionsSuspenseQuery>;
export type GetRequisitionDivisionsQueryResult = Apollo.QueryResult<GetRequisitionDivisionsQuery, GetRequisitionDivisionsQueryVariables>;
export const GetRequisitionJobTitlesDocument = gql`
    query GetRequisitionJobTitles {
  jobTitles {
    id
    name
  }
}
    `;

/**
 * __useGetRequisitionJobTitlesQuery__
 *
 * To run a query within a React component, call `useGetRequisitionJobTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionJobTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionJobTitlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequisitionJobTitlesQuery(baseOptions?: Apollo.QueryHookOptions<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>(GetRequisitionJobTitlesDocument, options);
      }
export function useGetRequisitionJobTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>(GetRequisitionJobTitlesDocument, options);
        }
// @ts-ignore
export function useGetRequisitionJobTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>;
export function useGetRequisitionJobTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionJobTitlesQuery | undefined, GetRequisitionJobTitlesQueryVariables>;
export function useGetRequisitionJobTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>(GetRequisitionJobTitlesDocument, options);
        }
export type GetRequisitionJobTitlesQueryHookResult = ReturnType<typeof useGetRequisitionJobTitlesQuery>;
export type GetRequisitionJobTitlesLazyQueryHookResult = ReturnType<typeof useGetRequisitionJobTitlesLazyQuery>;
export type GetRequisitionJobTitlesSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionJobTitlesSuspenseQuery>;
export type GetRequisitionJobTitlesQueryResult = Apollo.QueryResult<GetRequisitionJobTitlesQuery, GetRequisitionJobTitlesQueryVariables>;
export const SsoConfigDocument = gql`
    query SsoConfig {
  ssoConfig {
    acsUrl
    entityId
    logoutUrl
  }
}
    `;

/**
 * __useSsoConfigQuery__
 *
 * To run a query within a React component, call `useSsoConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSsoConfigQuery(baseOptions?: Apollo.QueryHookOptions<SsoConfigQuery, SsoConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoConfigQuery, SsoConfigQueryVariables>(SsoConfigDocument, options);
      }
export function useSsoConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoConfigQuery, SsoConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoConfigQuery, SsoConfigQueryVariables>(SsoConfigDocument, options);
        }
// @ts-ignore
export function useSsoConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SsoConfigQuery, SsoConfigQueryVariables>): Apollo.UseSuspenseQueryResult<SsoConfigQuery, SsoConfigQueryVariables>;
export function useSsoConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SsoConfigQuery, SsoConfigQueryVariables>): Apollo.UseSuspenseQueryResult<SsoConfigQuery | undefined, SsoConfigQueryVariables>;
export function useSsoConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SsoConfigQuery, SsoConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SsoConfigQuery, SsoConfigQueryVariables>(SsoConfigDocument, options);
        }
export type SsoConfigQueryHookResult = ReturnType<typeof useSsoConfigQuery>;
export type SsoConfigLazyQueryHookResult = ReturnType<typeof useSsoConfigLazyQuery>;
export type SsoConfigSuspenseQueryHookResult = ReturnType<typeof useSsoConfigSuspenseQuery>;
export type SsoConfigQueryResult = Apollo.QueryResult<SsoConfigQuery, SsoConfigQueryVariables>;
export const CreateSsoConnectionDocument = gql`
    mutation CreateSSOConnection($input: SSOConnectionInput!) {
  createSSOConnection(input: $input) {
    id
    organisationId
    type
    __typename
  }
}
    `;
export type CreateSsoConnectionMutationFn = Apollo.MutationFunction<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>;

/**
 * __useCreateSsoConnectionMutation__
 *
 * To run a mutation, you first call `useCreateSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSsoConnectionMutation, { data, loading, error }] = useCreateSsoConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>(CreateSsoConnectionDocument, options);
      }
export type CreateSsoConnectionMutationHookResult = ReturnType<typeof useCreateSsoConnectionMutation>;
export type CreateSsoConnectionMutationResult = Apollo.MutationResult<CreateSsoConnectionMutation>;
export type CreateSsoConnectionMutationOptions = Apollo.BaseMutationOptions<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>;
export const UpdateSsoConnectionDocument = gql`
    mutation UpdateSSOConnection($input: SSOConnectionInput!) {
  updateSSOConnection(input: $input) {
    id
    organisationId
    type
    __typename
  }
}
    `;
export type UpdateSsoConnectionMutationFn = Apollo.MutationFunction<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>;

/**
 * __useUpdateSsoConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsoConnectionMutation, { data, loading, error }] = useUpdateSsoConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>(UpdateSsoConnectionDocument, options);
      }
export type UpdateSsoConnectionMutationHookResult = ReturnType<typeof useUpdateSsoConnectionMutation>;
export type UpdateSsoConnectionMutationResult = Apollo.MutationResult<UpdateSsoConnectionMutation>;
export type UpdateSsoConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>;
export const SsoConnectionsDocument = gql`
    query SsoConnections($organisationId: ID!) {
  ssoConnections(organisationId: $organisationId) {
    id
    name
    attributeMapping
    autoSignup
    clientId
    enabled
    encryptedResponses
    metadataFile
    metadataUrl
    replaceLoginPage
    encryptionCertificate
    type
  }
}
    `;

/**
 * __useSsoConnectionsQuery__
 *
 * To run a query within a React component, call `useSsoConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoConnectionsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSsoConnectionsQuery(baseOptions: Apollo.QueryHookOptions<SsoConnectionsQuery, SsoConnectionsQueryVariables> & ({ variables: SsoConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoConnectionsQuery, SsoConnectionsQueryVariables>(SsoConnectionsDocument, options);
      }
export function useSsoConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoConnectionsQuery, SsoConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoConnectionsQuery, SsoConnectionsQueryVariables>(SsoConnectionsDocument, options);
        }
// @ts-ignore
export function useSsoConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SsoConnectionsQuery, SsoConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<SsoConnectionsQuery, SsoConnectionsQueryVariables>;
export function useSsoConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SsoConnectionsQuery, SsoConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<SsoConnectionsQuery | undefined, SsoConnectionsQueryVariables>;
export function useSsoConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SsoConnectionsQuery, SsoConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SsoConnectionsQuery, SsoConnectionsQueryVariables>(SsoConnectionsDocument, options);
        }
export type SsoConnectionsQueryHookResult = ReturnType<typeof useSsoConnectionsQuery>;
export type SsoConnectionsLazyQueryHookResult = ReturnType<typeof useSsoConnectionsLazyQuery>;
export type SsoConnectionsSuspenseQueryHookResult = ReturnType<typeof useSsoConnectionsSuspenseQuery>;
export type SsoConnectionsQueryResult = Apollo.QueryResult<SsoConnectionsQuery, SsoConnectionsQueryVariables>;
export const RemoveSsoConnectionDocument = gql`
    mutation RemoveSSOConnection($organisationId: ID!, $id: ID!) {
  removeSSOConnection(organisationId: $organisationId, id: $id)
}
    `;
export type RemoveSsoConnectionMutationFn = Apollo.MutationFunction<RemoveSsoConnectionMutation, RemoveSsoConnectionMutationVariables>;

/**
 * __useRemoveSsoConnectionMutation__
 *
 * To run a mutation, you first call `useRemoveSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSsoConnectionMutation, { data, loading, error }] = useRemoveSsoConnectionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSsoConnectionMutation, RemoveSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSsoConnectionMutation, RemoveSsoConnectionMutationVariables>(RemoveSsoConnectionDocument, options);
      }
export type RemoveSsoConnectionMutationHookResult = ReturnType<typeof useRemoveSsoConnectionMutation>;
export type RemoveSsoConnectionMutationResult = Apollo.MutationResult<RemoveSsoConnectionMutation>;
export type RemoveSsoConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveSsoConnectionMutation, RemoveSsoConnectionMutationVariables>;